
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3tgy4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $chOte = parcelRequire("chOte");

var $9BXp4 = parcelRequire("9BXp4");

var $5dDC4 = parcelRequire("5dDC4");

var $4zyjT = parcelRequire("4zyjT");

var $a96iv = parcelRequire("a96iv");

var $hjUDQ = parcelRequire("hjUDQ");

var $5KFAG = parcelRequire("5KFAG");

var $2VNQP = parcelRequire("2VNQP");

var $d6u4w = parcelRequire("d6u4w");

var $4cGll = parcelRequire("4cGll");

var $bIp5p = parcelRequire("bIp5p");

var $9vJye = parcelRequire("9vJye");

var $cfM7x = parcelRequire("cfM7x");


var $dBD3L = parcelRequire("dBD3L");


var $k2pUk = parcelRequire("k2pUk");




var $ikd73 = parcelRequire("ikd73");

var $e25abac37e9b0f19$exports = {};
$e25abac37e9b0f19$exports = new URL("CardsV2Preview.35d6ee74.svg", import.meta.url).toString();

var $1fc5cfda5ccd77d9$exports = {};
$1fc5cfda5ccd77d9$exports = new URL("CardsV2PreviewDark.9d7cd6d3.svg", import.meta.url).toString();

var $4cfb46c97c571659$exports = {};
$4cfb46c97c571659$exports = new URL("CardsV1Preview.84b1fee2.svg", import.meta.url).toString();

var $7736333409c58daf$exports = {};
$7736333409c58daf$exports = new URL("CardsV1PreviewDark.4e29b6b0.svg", import.meta.url).toString();



var $3cB3o = parcelRequire("3cB3o");











var $jmFR8 = parcelRequire("jmFR8");


var $5eKkh = parcelRequire("5eKkh");



















var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");




var $cXCJB = parcelRequire("cXCJB");

var $4yUlE = parcelRequire("4yUlE");

var $5ddnJ = parcelRequire("5ddnJ");

var $4sYZY = parcelRequire("4sYZY");


var $4ZnIz = parcelRequire("4ZnIz");












var $kB5K2 = parcelRequire("kB5K2");







var $24tIi = parcelRequire("24tIi");







const $5cbaa2d63ab38c16$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    segmentationTargetGroupsLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label",
        defaultMessage: "Target groups"
    },
    segmentationTargetGroupsLabelV2: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2",
        defaultMessage: "Target audience groups"
    }
});


const $a2d6c26cfaa807db$var$updatedStyles = {
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    borderRadius: "var(--ds-radius-small, 4px)"
};
const $a2d6c26cfaa807db$export$2261f4215d6c3d25 = ({ targetGroupsIds: targetGroupsIds, onGroupSelected: onGroupSelected, showUpdatedStyles: showUpdatedStyles = false, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [selectedGroups, setSelectedGroups] = (0, $cozmU.useState)([]);
    const initialGroupIds = (0, $cozmU.useRef)(targetGroupsIds || []);
    const initialGroups = (0, $cozmU.useRef)([]);
    const [nextCursor, setNextCursor] = (0, $cozmU.useState)(undefined);
    const { useSegmentationTargetGroups: useSegmentationTargetGroups, cloudId: cloudId, orgId: orgId } = (0, $cfM7x.useProductDependencies)();
    const { data: data, loading: loading, errorComponent: errorComponent } = useSegmentationTargetGroups?.({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds.current || []
    }) || {};
    (0, $cozmU.useEffect)(()=>{
        const groups = [];
        const groupIds = initialGroupIds.current;
        for (const id of groupIds){
            const group = data?.groups?.nodes?.find((node)=>node?.id === id);
            if (group && group.id && group.name) groups.push({
                id: group.id,
                name: group.name,
                type: 'group'
            });
        }
        const newGroups = [
            ...initialGroups.current,
            ...groups
        ];
        initialGroups.current = newGroups;
        if (data?.groups?.pageInfo?.hasNextPage && newGroups.length < groupIds.length) setNextCursor(data.groups.pageInfo.endCursor);
        else setSelectedGroups(newGroups);
    }, [
        data
    ]);
    const handleSelectOnChange = (0, $cozmU.useCallback)((values)=>{
        const groups_0 = values ? values : [];
        setSelectedGroups(groups_0);
        onGroupSelected(groups_0.length > 0 ? groups_0.map((group_0)=>group_0.id) : undefined);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: 'hubSegmentationTargetGroupsDropdown',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onGroupSelected,
        source
    ]);
    const filterSystemGroups = (options)=>{
        const HIDDEN_GROUP_NAME = 'system-administrators';
        return options.filter((option)=>option.name !== HIDDEN_GROUP_NAME);
    };
    return errorComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, errorComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "card-segmentation-target-groups-selector"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: showUpdatedStyles ? 'medium' : 'small',
        weight: showUpdatedStyles ? 'regular' : 'bold',
        color: showUpdatedStyles ? 'color.text' : 'inherit'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), showUpdatedStyles ? (0, $5cbaa2d63ab38c16$export$defe85febe8b728c).segmentationTargetGroupsLabelV2 : (0, $5cbaa2d63ab38c16$export$defe85febe8b728c).segmentationTargetGroupsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
        filterOptions: filterSystemGroups,
        isLoading: loading,
        fieldId: "card-segmentation-target-groups-selector",
        inputId: "card-segmentation-target-groups-selector",
        siteId: cloudId,
        orgId: orgId,
        debounceTime: 400,
        productKey: "confluence",
        includeUsers: false,
        includeGroups: true,
        isMulti: true,
        width: "100%",
        value: selectedGroups,
        placeholder: "",
        addMoreMessage: "",
        onChange: handleSelectOnChange,
        noOptionsMessage: ()=>null,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: {
            valueContainer: (base)=>({
                    ...base,
                    minHeight: showUpdatedStyles ? 'auto' : '56px',
                    alignItems: 'start'
                }),
            multiValue: (provided)=>({
                    ...provided,
                    ...showUpdatedStyles ? $a2d6c26cfaa807db$var$updatedStyles : {},
                    div: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                })
        }
    })));
};


var $cImA8 = parcelRequire("cImA8");



















var $hekY6 = parcelRequire("hekY6");


var $55fM8 = parcelRequire("55fM8");

var $1d3b20042c2b22b5$exports = {};

var $9gO65 = parcelRequire("9gO65");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $1d3b20042c2b22b5$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $1d3b20042c2b22b5$var$isBoolean(value) {
    return value === true || value === false || $7WFUU(value) && $9gO65(value) == $1d3b20042c2b22b5$var$boolTag;
}
$1d3b20042c2b22b5$exports = $1d3b20042c2b22b5$var$isBoolean;












var $4yccB = parcelRequire("4yccB");









var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $aJxVU = parcelRequire("aJxVU");


var $fNTq8 = parcelRequire("fNTq8");


var $lpJCW = parcelRequire("lpJCW");

var $bBIvl = parcelRequire("bBIvl");

/**
 * @generated SignedSource<<89b027e30b3780f6b8cac124e701101c>>
 * @relayHash 0481678a27915107a3ab2adb52c2e123
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a
const $68ae44ea25b92a7a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "spaceId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "homepageId"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "aiDescriptionButtonWrapperQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "aiDescriptionButtonWrapperQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a",
            "metadata": {},
            "name": "aiDescriptionButtonWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$68ae44ea25b92a7a$var$node.hash = "162796af29855f994bf05873d1c21a58";
var $68ae44ea25b92a7a$export$2e2bcd8739ae039 = $68ae44ea25b92a7a$var$node;






var $6SsN4 = parcelRequire("6SsN4");


var $6yMHm = parcelRequire("6yMHm");


var $d5gEx = parcelRequire("d5gEx");




















var $ad7Ou = parcelRequire("ad7Ou");


var $320o0 = parcelRequire("320o0");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");







var $4ZLyq = parcelRequire("4ZLyq");


var $h0VcS = parcelRequire("h0VcS");

var $4gJu8 = parcelRequire("4gJu8");


var $aedCm = parcelRequire("aedCm");




function $27724d6285f5ca07$export$6983f0e8c17d512d(config, onStateChange) {
    const refetchId = (0, $cozmU.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $4gJu8.useStatefulObservableLazyEffect)((0, $aedCm.convoAIStreamingEffect), (0, $aJxVU.getDefaultConvoAIStreamingState)());
    (0, $h0VcS.useObservableEffect)((input$)=>input$.pipe((0, $4ZLyq.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const fetch = (0, $cozmU.useCallback)((request)=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $aJxVU.getDefaultConvoAIStreamingState)()
        });
    }, [
        config,
        setState
    ]);
    return [
        state,
        fetch
    ];
}



var $cFVPs = parcelRequire("cFVPs");







const $84994be7c89a253f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    suggestDescriptionLabel: {
        id: "company-hub.company-hub-common.link-cards.description.button.suggest-description.label",
        defaultMessage: "Suggest Description"
    }
});


const $4191259f97fbe3ed$var$buttonContainerStyles = (0, $buxP3.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    width: 'fit-content',
    marginTop: 'space.075',
    marginBottom: 'space.075',
    borderRadius: 'radius.large'
});
const $4191259f97fbe3ed$export$c0801da6964026da = '/gateway/api/ai';
const $4191259f97fbe3ed$export$9ebe94218768768c = ({ contentAri: contentAri, locale: locale })=>{
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                character_max: 95
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-concise-summary',
            baseUrl: $4191259f97fbe3ed$export$c0801da6964026da,
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            headers: {
                'x-experience-id': 'confluence-concise-summary',
                'x-product': 'confluence'
            }
        }
    ];
};
const $4191259f97fbe3ed$export$5a36a527b7753afd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { pageAri: pageAri, confluencePageId: confluencePageId, isAILoading: isAILoading, setIsAILoading: setIsAILoading, setAIError: setAIError, setAIDescriptionContent: setAIDescriptionContent, setAIResponseState: setAIResponseState, analyticsSource: analyticsSource } = t0;
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker } = (0, $cfM7x.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    let t1;
    if ($[0] !== trackAIResultError || $[1] !== trackAIResultView) {
        t1 = (state)=>{
            bb2: switch(state.responseState){
                case (0, $aJxVU.ConvoAIResponseState).Error:
                    if (state.error) {
                        const { status_code: aiErrorCode, message_template: aiErrorMessage } = state.error.message;
                        trackAIResultError({
                            aiErrorCode: aiErrorCode,
                            aiErrorMessage: aiErrorMessage
                        });
                    }
                    break bb2;
                case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
                    if (state.content) trackAIResultView();
                    break bb2;
                default:
            }
        };
        $[0] = trackAIResultError;
        $[1] = trackAIResultView;
        $[2] = t1;
    } else t1 = $[2];
    const onStateChange = t1;
    const [fetchNonce, setFetchNonce] = (0, $cozmU.useState)(0);
    let t2;
    if ($[3] !== locale || $[4] !== pageAri) {
        t2 = $4191259f97fbe3ed$export$9ebe94218768768c({
            contentAri: pageAri,
            locale: locale
        });
        $[3] = locale;
        $[4] = pageAri;
        $[5] = t2;
    } else t2 = $[5];
    const [request, config] = t2;
    const [t3, fetchAI] = (0, $27724d6285f5ca07$export$6983f0e8c17d512d)(config, onStateChange);
    const { content: content, responseState: responseState, error: error } = t3;
    let t4;
    if ($[6] !== fetchAI || $[7] !== fetchNonce || $[8] !== request) {
        t4 = ()=>{
            if (fetchNonce > 0) fetchAI(request);
        };
        $[6] = fetchAI;
        $[7] = fetchNonce;
        $[8] = request;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== fetchNonce) {
        t5 = [
            fetchNonce
        ];
        $[10] = fetchNonce;
        $[11] = t5;
    } else t5 = $[11];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[12] !== aiDescriptionExperienceTracker || $[13] !== analyticsSource || $[14] !== confluencePageId || $[15] !== createAnalyticsEvent || $[16] !== setIsAILoading || $[17] !== trackAIInteractionInit) {
        t6 = ()=>{
            trackAIInteractionInit();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "aiDescription",
                    source: analyticsSource
                }
            }).fire();
            aiDescriptionExperienceTracker?.start({
                analyticsSource: analyticsSource,
                confluencePageId: confluencePageId
            });
            setIsAILoading(true);
            setFetchNonce($4191259f97fbe3ed$var$_temp);
        };
        $[12] = aiDescriptionExperienceTracker;
        $[13] = analyticsSource;
        $[14] = confluencePageId;
        $[15] = createAnalyticsEvent;
        $[16] = setIsAILoading;
        $[17] = trackAIInteractionInit;
        $[18] = t6;
    } else t6 = $[18];
    const startAIDescription = t6;
    let t7;
    let t8;
    if ($[19] !== content || $[20] !== error || $[21] !== responseState || $[22] !== setAIDescriptionContent || $[23] !== setAIError || $[24] !== setAIResponseState) {
        t7 = ()=>{
            setAIResponseState(responseState);
            setAIDescriptionContent(content);
            setAIError(error);
        };
        t8 = [
            responseState,
            content,
            error,
            setAIResponseState,
            setAIDescriptionContent,
            setAIError
        ];
        $[19] = content;
        $[20] = error;
        $[21] = responseState;
        $[22] = setAIDescriptionContent;
        $[23] = setAIError;
        $[24] = setAIResponseState;
        $[25] = t7;
        $[26] = t8;
    } else {
        t7 = $[25];
        t8 = $[26];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $84994be7c89a253f$export$defe85febe8b728c).suggestDescriptionLabel);
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== isAILoading || $[29] !== startAIDescription) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $4191259f97fbe3ed$var$buttonContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: startAIDescription,
            isDisabled: isAILoading,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($320o0)))
        }, t9));
        $[28] = isAILoading;
        $[29] = startAIDescription;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
} : ({ pageAri: pageAri, confluencePageId: confluencePageId, isAILoading: isAILoading, setIsAILoading: setIsAILoading, setAIError: setAIError, setAIDescriptionContent: setAIDescriptionContent, setAIResponseState: setAIResponseState, analyticsSource: analyticsSource })=>{
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker } = (0, $cfM7x.useProductDependencies)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    const onStateChange = (0, $cozmU.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $aJxVU.ConvoAIResponseState).Error:
                if (state.error) {
                    const { status_code: aiErrorCode, message_template: aiErrorMessage } = state.error.message;
                    trackAIResultError({
                        aiErrorCode: aiErrorCode,
                        aiErrorMessage: aiErrorMessage
                    });
                }
                break;
            case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
                if (state.content) trackAIResultView();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        trackAIResultView
    ]);
    // `fetchNonce` is a monotonically increasing per-click token: it changes on *every*
    // click, so the fetching effect below always re-fires (e.g. when retrying after an
    // error). Bumping it in the click handler is what schedules a fetch.
    const [fetchNonce, setFetchNonce] = (0, $cozmU.useState)(0);
    const [request, config] = (0, $cozmU.useMemo)(()=>$4191259f97fbe3ed$export$9ebe94218768768c({
            contentAri: pageAri,
            locale: locale
        }), [
        locale,
        pageAri
    ]);
    const [{ content: content, responseState: responseState, error: error }, fetchAI] = (0, $27724d6285f5ca07$export$6983f0e8c17d512d)(config, onStateChange);
    // This effect runs after a click has bumped `fetchNonce`, then fires the request.
    // `fetchNonce > 0` skips the initial mount; keying the effect on `fetchNonce`
    // guarantees it re-runs on every click.
    (0, $cozmU.useEffect)(()=>{
        if (fetchNonce > 0) // oxlint-disable-next-line react-hooks/exhaustive-deps
        fetchAI(request);
    // fetchNonce so repeated clicks still trigger a fetch.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchNonce
    ]);
    const startAIDescription = (0, $cozmU.useCallback)(()=>{
        trackAIInteractionInit();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDescription',
                source: analyticsSource
            }
        }).fire();
        aiDescriptionExperienceTracker?.start({
            analyticsSource: analyticsSource,
            confluencePageId: confluencePageId
        });
        setIsAILoading(true);
        // Bump `fetchNonce` so the fetching effect re-fires even on repeat clicks/retries.
        setFetchNonce((prev)=>prev + 1);
    }, [
        trackAIInteractionInit,
        confluencePageId,
        createAnalyticsEvent,
        aiDescriptionExperienceTracker,
        analyticsSource,
        setIsAILoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        setAIResponseState(responseState);
        setAIDescriptionContent(content);
        setAIError(error);
    }, [
        responseState,
        content,
        error,
        setAIResponseState,
        setAIDescriptionContent,
        setAIError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $4191259f97fbe3ed$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: startAIDescription,
        isDisabled: isAILoading,
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($320o0)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $84994be7c89a253f$export$defe85febe8b728c).suggestDescriptionLabel)));
};
function $4191259f97fbe3ed$var$_temp(prev) {
    return prev + 1;
}


// If linkResourceType is 'space', then it's a Space Overview Page, which is type "page".
// If linkResourceType is a 'blog', then we update to "blogpost" for pageAri
const $569684bdc390020f$var$getContentTypeForPageAri = (linkResourceType)=>{
    switch(linkResourceType){
        case 'blog':
            return 'blogpost';
        case 'space':
            return 'page';
        default:
            return linkResourceType;
    }
};
const $569684bdc390020f$export$4e2e1778ae07237 = ({ confluencePageId: confluencePageId, linkResourceType: linkResourceType, isAILoading: isAILoading, setIsAILoading: setIsAILoading, setAIError: setAIError, setAIDescriptionContent: setAIDescriptionContent, setAIResponseState: setAIResponseState, analyticsSource: analyticsSource })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [queriedHomepageId, setQueriedHomepageId] = (0, $cozmU.useState)('');
    const [errorComponent, setErrorComponent] = (0, $cozmU.useState)(null);
    const { cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled, errorDisplayComponent: errorDisplayComponent } = (0, $cfM7x.useProductDependencies)();
    const environment = (0, $d5gEx.useRelayEnvironmentProvider)().getEnvironment({});
    const querySpaceOverviewHomepageId = (0, $cozmU.useCallback)(async ()=>{
        // If it's not a space overview page, we don't need to fetch the homepageId
        if (linkResourceType !== 'space') {
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const spaceOverviewData = await (0, $6SsN4.fetchQuery)(environment, (0, $68ae44ea25b92a7a$export$2e2bcd8739ae039), {
                spaceId: confluencePageId
            }).toPromise();
            setQueriedHomepageId(spaceOverviewData?.space?.homepageId ?? '');
        } catch (error) {
            if (errorDisplayComponent) {
                const ErrorComponent = errorDisplayComponent;
                setErrorComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, {
                    error: error
                }));
            }
        } finally{
            setLoading(false);
        }
    }, [
        linkResourceType,
        confluencePageId,
        environment,
        errorDisplayComponent
    ]);
    (0, $cozmU.useEffect)(()=>{
        querySpaceOverviewHomepageId();
    }, [
        querySpaceOverviewHomepageId
    ]);
    const contentType = $569684bdc390020f$var$getContentTypeForPageAri(linkResourceType);
    const isPageOrBlog = contentType === 'page' || contentType === 'blogpost';
    const pageId = linkResourceType === 'space' ? queriedHomepageId : confluencePageId;
    const { pageAri: pageAri } = (0, $6yMHm.useConfluencePageAri)(cloudId, pageId, contentType);
    if (errorComponent) return errorComponent;
    const shouldRenderAIButton = isAdminHubAIEnabled && !loading && isPageOrBlog;
    return shouldRenderAIButton && pageAri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4191259f97fbe3ed$export$5a36a527b7753afd), {
        pageAri: pageAri,
        confluencePageId: confluencePageId,
        isAILoading: isAILoading,
        setIsAILoading: setIsAILoading,
        setAIError: setAIError,
        setAIDescriptionContent: setAIDescriptionContent,
        setAIResponseState: setAIResponseState,
        analyticsSource: analyticsSource
    });
};














var $7WEaj = parcelRequire("7WEaj");





var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $7vK9E = parcelRequire("7vK9E");






var $6ahXt = parcelRequire("6ahXt");






























const $984bda1500270b84$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    generalError: {
        id: "company-hub-common.ai.error.common-error.general-error",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a response right now. Read more <a>in our support documentation</a>."
    },
    notEnoughContent: {
        id: "company-hub-common.ai.error.common-error.not-enough-content",
        defaultMessage: "There isn\u2019t enough content here to summarize. Try again when more content has been added."
    },
    rateLimit: {
        id: "company-hub-common.ai.error.common-error.rate-limit",
        defaultMessage: "Excessive use has been detected with Atlassian Intelligence. Try again later. Read more <a>in our support documentation</a>."
    },
    tooMuchContent: {
        id: "company-hub-common.ai.error.page-error.too-much-content",
        defaultMessage: "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize."
    },
    aupViolation: {
        id: "company-hub-common.ai.error.page-error.aup-violation",
        defaultMessage: "Your content might not comply with our Acceptable Use Policy. Please review and refer to our <a>Acceptable Use Policy</a> if needed."
    }
});


var $0903c7398792a385$export$987753f1dd27cb69 = /*#__PURE__*/ function(AIGQLErrors) {
    AIGQLErrors["NOT_ENOUGH_CONTENT"] = "NOT_ENOUGH_CONTENT";
    AIGQLErrors["TOO_MUCH_CONTENT"] = "TOO_MUCH_CONTENT";
    AIGQLErrors["TOO_MANY_REQUEST"] = "RATE_LIMIT";
    AIGQLErrors["AUP_VIOLATION"] = "AUP_VIOLATION";
    AIGQLErrors["GENERAL_ERROR"] = "GENERAL_ERROR";
    return AIGQLErrors;
}({});
var $0903c7398792a385$export$939494aa166c4495 = /*#__PURE__*/ function(AIErrorLinkType) {
    AIErrorLinkType["Troubleshooting"] = "Troubleshooting";
    AIErrorLinkType["RateLimit"] = "RateLimit";
    AIErrorLinkType["AupViolation"] = "AupViolation";
    return AIErrorLinkType;
}({});
var $0903c7398792a385$export$249411c33615135b = /*#__PURE__*/ function(ErrorMessageKeys) {
    ErrorMessageKeys["GENERAL_ERROR"] = "generalError";
    ErrorMessageKeys["NOT_ENOUGH_CONTENT"] = "notEnoughContent";
    ErrorMessageKeys["TOO_MUCH_CONTENT"] = "tooMuchContent";
    ErrorMessageKeys["RATE_LIMIT"] = "rateLimit";
    ErrorMessageKeys["AUP_VIOLATION"] = "aupViolation";
    return ErrorMessageKeys;
}({});
var $0903c7398792a385$export$4a95903507aabb8b = /*#__PURE__*/ function(ConvoAIErrorMessageMap) {
    ConvoAIErrorMessageMap["RATE_LIMIT"] = "rateLimit";
    ConvoAIErrorMessageMap["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "notEnoughContent";
    ConvoAIErrorMessageMap["ACCEPTABLE_USE_VIOLATIONS"] = "aupViolation";
    ConvoAIErrorMessageMap["BAD_REQUEST"] = "generalError";
    ConvoAIErrorMessageMap["UNEXPECTED"] = "generalError";
    ConvoAIErrorMessageMap["TIMEOUT"] = "generalError";
    ConvoAIErrorMessageMap["NOT_ENOUGH_CONTENT_ERROR"] = "notEnoughContent";
    return ConvoAIErrorMessageMap;
}({});
var $0903c7398792a385$export$42f7fb0488d3bbbc = /*#__PURE__*/ function(BaseErrorMessageMap) {
    BaseErrorMessageMap["GENERAL_ERROR"] = "generalError";
    BaseErrorMessageMap["NETWORK_ERROR"] = "generalError";
    BaseErrorMessageMap["NO_ANSWER"] = "generalError";
    BaseErrorMessageMap["NO_AGENT"] = "generalError";
    BaseErrorMessageMap["PLUGIN_ERRORED"] = "generalError";
    BaseErrorMessageMap["AI_DISABLED"] = "generalError";
    BaseErrorMessageMap["OPENAI_RATE_LIMIT"] = "rateLimit";
    BaseErrorMessageMap["AUP_VIOLATION"] = "aupViolation";
    BaseErrorMessageMap["NOT_ENOUGH_CONTENT"] = "notEnoughContent";
    // typo comes from the backend
    // https://bitbucket.org/atlassian/assistance-service/src/02087c3b6569f042ec338e08e8e0e152c4563dad/src/schema/message_publisher.py#lines-74
    BaseErrorMessageMap["ASWER_UNAVAILABLE_FOR_CONTENT"] = "notEnoughContent";
    BaseErrorMessageMap["TOO_MUCH_CONTENT"] = "tooMuchContent";
    BaseErrorMessageMap["NOT_FOUND"] = "generalError";
    BaseErrorMessageMap["INTERNAL_SERVER_ERROR"] = "generalError";
    return BaseErrorMessageMap;
}({});
const $0903c7398792a385$export$71adb9ac7cae993c = {
    ...$0903c7398792a385$export$4a95903507aabb8b,
    ...$0903c7398792a385$export$42f7fb0488d3bbbc
};
var $0903c7398792a385$export$19d76c6edad3e4d4 = /*#__PURE__*/ function(ErrorMessageKeyErrorLinkMap) {
    ErrorMessageKeyErrorLinkMap["generalError"] = "Troubleshooting";
    ErrorMessageKeyErrorLinkMap["rateLimit"] = "RateLimit";
    ErrorMessageKeyErrorLinkMap["aupViolation"] = "AupViolation";
    ErrorMessageKeyErrorLinkMap["notEnoughContent"] = "Troubleshooting";
    ErrorMessageKeyErrorLinkMap["tooMuchContent"] = "Troubleshooting";
    return ErrorMessageKeyErrorLinkMap;
}({});


const $919c5a664551a89f$var$textStyles = {
    root: "_1UtDYzKGUX"
};
const $919c5a664551a89f$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $919c5a664551a89f$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $919c5a664551a89f$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $919c5a664551a89f$var$LINK_MAP = {
    [(0, $0903c7398792a385$export$939494aa166c4495).RateLimit]: $919c5a664551a89f$export$b4fefae0b724683f,
    [(0, $0903c7398792a385$export$939494aa166c4495).AupViolation]: $919c5a664551a89f$export$2876254020381b5e,
    [(0, $0903c7398792a385$export$939494aa166c4495).Troubleshooting]: $919c5a664551a89f$export$6c1f59b2f89fe4f1
};
const $919c5a664551a89f$export$68b33c6c9404cf85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let analyticsAttributes;
    let errorType;
    let props;
    let source;
    let xcss;
    if ($[0] !== t0) {
        ({ errorType: errorType, source: source, analyticsAttributes: analyticsAttributes, xcss: xcss, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsAttributes;
        $[2] = errorType;
        $[3] = props;
        $[4] = source;
        $[5] = xcss;
    } else {
        analyticsAttributes = $[1];
        errorType = $[2];
        props = $[3];
        source = $[4];
        xcss = $[5];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const errorMessageKey = (0, $0903c7398792a385$export$71adb9ac7cae993c)[errorType];
    const errorMessage = (0, $984bda1500270b84$export$defe85febe8b728c)[errorMessageKey];
    const linkType = (0, $0903c7398792a385$export$939494aa166c4495)[(0, $0903c7398792a385$export$19d76c6edad3e4d4)[errorMessageKey]];
    let t1;
    if ($[6] !== analyticsAttributes || $[7] !== createAnalyticsEvent || $[8] !== linkType || $[9] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: source,
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: `atlassianIntelligence${linkType}DocsLink`,
                    ...analyticsAttributes ? {
                        attributes: analyticsAttributes
                    } : {}
                }
            }).fire();
        };
        $[6] = analyticsAttributes;
        $[7] = createAnalyticsEvent;
        $[8] = linkType;
        $[9] = source;
        $[10] = t1;
    } else t1 = $[10];
    const onDocsLinkClicked = t1;
    let t2;
    if ($[11] !== linkType || $[12] !== onDocsLinkClicked) {
        t2 = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $919c5a664551a89f$var$LINK_MAP[linkType],
                target: "_blank",
                onClick: onDocsLinkClicked
            }, chunks);
        $[11] = linkType;
        $[12] = onDocsLinkClicked;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== errorMessage || $[15] !== formatMessage || $[16] !== t2) {
        t3 = formatMessage(errorMessage, {
            a: t2
        });
        $[14] = errorMessage;
        $[15] = formatMessage;
        $[16] = t2;
        $[17] = t3;
    } else t3 = $[17];
    const resolvedMessage = t3;
    const t4 = xcss || $919c5a664551a89f$var$textStyles.root;
    let t5;
    if ($[18] !== props || $[19] !== resolvedMessage || $[20] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            ...props
        }, resolvedMessage);
        $[18] = props;
        $[19] = resolvedMessage;
        $[20] = t4;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : ({ errorType: errorType, source: source, analyticsAttributes: analyticsAttributes, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const errorMessageKey = (0, $0903c7398792a385$export$71adb9ac7cae993c)[errorType];
    const errorMessage = (0, $984bda1500270b84$export$defe85febe8b728c)[errorMessageKey];
    const linkType = (0, $0903c7398792a385$export$939494aa166c4495)[(0, $0903c7398792a385$export$19d76c6edad3e4d4)[errorMessageKey]];
    const onDocsLinkClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkType}DocsLink`,
                ...analyticsAttributes ? {
                    attributes: analyticsAttributes
                } : {}
            }
        }).fire();
    };
    // This is safe for messages without link replacements also.
    // formatMessage ignores replacements when none exist in the string
    const resolvedMessage = formatMessage(errorMessage, {
        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $919c5a664551a89f$var$LINK_MAP[linkType],
                target: "_blank",
                onClick: onDocsLinkClicked
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: xcss || $919c5a664551a89f$var$textStyles.root,
        ...props
    }, resolvedMessage);
};






const $60b569bc730323b0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    aIDisclaimer: {
        id: "company-hub.company-hub-common.link-cards.description.ai-disclaimer",
        defaultMessage: "Content quality may vary"
    },
    aIAttributionLabel: {
        id: "company-hub.company-hub-common.link-cards.description.link.label.ai",
        defaultMessage: "Learn more about Atlassian AI"
    }
});


const $99eeed3aeaff7994$var$styles = {
    anchor: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1UtDYzKGUX _2nTuUYKGUX",
    successContainer: "_3138421Y8M",
    errorText: "_1UtDYzAyGJ",
    errorContainer: "_1UtDYzAyGJ _3138421Y8M"
};
const $99eeed3aeaff7994$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { errorType: errorType, analyticsSource: analyticsSource } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            label: "",
            color: "var(--ds-icon-accent-red)"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== analyticsSource || $[2] !== errorType) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            xcss: $99eeed3aeaff7994$var$styles.errorContainer
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $919c5a664551a89f$export$68b33c6c9404cf85), {
            errorType: errorType,
            source: analyticsSource,
            xcss: $99eeed3aeaff7994$var$styles.errorText
        }));
        $[1] = analyticsSource;
        $[2] = errorType;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ errorType: errorType, analyticsSource: analyticsSource })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        xcss: $99eeed3aeaff7994$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-icon-accent-red)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $919c5a664551a89f$export$68b33c6c9404cf85), {
        errorType: errorType,
        source: analyticsSource,
        xcss: $99eeed3aeaff7994$var$styles.errorText
    }));
const $99eeed3aeaff7994$export$108645d938839241 = [
    (0, $0903c7398792a385$export$4a95903507aabb8b).NOT_ENOUGH_CONTENT_ERROR,
    (0, $0903c7398792a385$export$4a95903507aabb8b).ANSWER_UNAVAILABLE_FOR_CONTENT,
    (0, $0903c7398792a385$export$4a95903507aabb8b).ACCEPTABLE_USE_VIOLATIONS
];
const $99eeed3aeaff7994$export$f1233e533b345659 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { responseState: responseState, error: error, analyticsSource: analyticsSource } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker, errorDisplayComponent: errorDisplayComponent } = (0, $cfM7x.useProductDependencies)();
    const { markErrorAsHandled: markErrorAsHandled } = (0, $cfM7x.useProductDependencies)();
    const [showError, setShowError] = (0, $cozmU.useState)();
    const ErrorDisplay = errorDisplayComponent || (0, $cozmU.Fragment);
    let t1;
    let t2;
    if ($[0] !== responseState) {
        t1 = ()=>{
            if (responseState === (0, $aJxVU.ConvoAIResponseState).Error) {
                setShowError(true);
                const timer = setTimeout(()=>{
                    setShowError(false);
                }, 8000);
                return ()=>clearTimeout(timer);
            }
        };
        t2 = [
            responseState
        ];
        $[0] = responseState;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    switch(responseState){
        case (0, $aJxVU.ConvoAIResponseState).Error:
            if (showError) {
                const errorType = error?.message.message_template || (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED;
                const mappedErrorMessage = errorType in (0, $0903c7398792a385$export$4a95903507aabb8b) ? (0, $0903c7398792a385$export$4a95903507aabb8b)[errorType] : (0, $0903c7398792a385$export$4a95903507aabb8b).UNEXPECTED;
                let t3;
                if ($[3] !== mappedErrorMessage) {
                    t3 = $99eeed3aeaff7994$export$108645d938839241.includes(mappedErrorMessage);
                    $[3] = mappedErrorMessage;
                    $[4] = t3;
                } else t3 = $[4];
                const isExpectedError = t3;
                if (isExpectedError) {
                    markErrorAsHandled?.(new Error(error?.message.content));
                    aiDescriptionExperienceTracker?.abort?.({
                        reason: `Cannot generate summary due to ${errorType}`
                    });
                } else aiDescriptionExperienceTracker?.stopOnError({
                    error: new Error(error?.message.content)
                });
                let t4;
                if ($[5] !== ErrorDisplay || $[6] !== analyticsSource || $[7] !== error?.message || $[8] !== errorType || $[9] !== isExpectedError) {
                    t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isExpectedError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99eeed3aeaff7994$var$ErrorMessage, {
                        errorType: errorType,
                        analyticsSource: analyticsSource
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorDisplay, {
                        error: new Error(error?.message.content)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99eeed3aeaff7994$var$ErrorMessage, {
                        errorType: errorType,
                        analyticsSource: analyticsSource
                    })));
                    $[5] = ErrorDisplay;
                    $[6] = analyticsSource;
                    $[7] = error?.message;
                    $[8] = errorType;
                    $[9] = isExpectedError;
                    $[10] = t4;
                } else t4 = $[10];
                return t4;
            }
            return null;
        case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
            {
                aiDescriptionExperienceTracker?.succeed();
                let t3;
                if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                    t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    });
                    $[11] = t3;
                } else t3 = $[11];
                let t4;
                if ($[12] !== formatMessage) {
                    t4 = formatMessage((0, $60b569bc730323b0$export$defe85febe8b728c).aIDisclaimer);
                    $[12] = formatMessage;
                    $[13] = t4;
                } else t4 = $[13];
                let t5;
                if ($[14] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                        space: "space.050",
                        alignBlock: "center"
                    }, t3, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                        href: "https://www.atlassian.com/trust/atlassian-intelligence",
                        target: "_blank",
                        xcss: $99eeed3aeaff7994$var$styles.anchor
                    }, t4));
                    $[14] = t4;
                    $[15] = t5;
                } else t5 = $[15];
                let t6;
                if ($[16] !== formatMessage) {
                    t6 = formatMessage((0, $60b569bc730323b0$export$defe85febe8b728c).aIAttributionLabel);
                    $[16] = formatMessage;
                    $[17] = t6;
                } else t6 = $[17];
                let t7;
                if ($[18] !== t6) {
                    t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                        spacing: "compact",
                        href: "https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/",
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($320o0))),
                        label: t6,
                        target: "_blank"
                    });
                    $[18] = t6;
                    $[19] = t7;
                } else t7 = $[19];
                let t8;
                if ($[20] !== t5 || $[21] !== t7) {
                    t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                        xcss: $99eeed3aeaff7994$var$styles.successContainer,
                        spread: "space-between"
                    }, t5, t7);
                    $[20] = t5;
                    $[21] = t7;
                    $[22] = t8;
                } else t8 = $[22];
                return t8;
            }
        default:
    }
} : ({ responseState: responseState, error: error, analyticsSource: analyticsSource })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { aiDescriptionExperienceTracker: aiDescriptionExperienceTracker, errorDisplayComponent: errorDisplayComponent } = (0, $cfM7x.useProductDependencies)();
    const { markErrorAsHandled: markErrorAsHandled } = (0, $cfM7x.useProductDependencies)();
    const [showError, setShowError] = (0, $cozmU.useState)();
    const ErrorDisplay = errorDisplayComponent || (0, $cozmU.Fragment);
    (0, $cozmU.useEffect)(()=>{
        if (responseState === (0, $aJxVU.ConvoAIResponseState).Error) {
            setShowError(true);
            const timer = setTimeout(()=>{
                setShowError(false);
            }, 8000);
            return ()=>clearTimeout(timer);
        }
    }, [
        responseState
    ]);
    switch(responseState){
        case (0, $aJxVU.ConvoAIResponseState).Error:
            if (showError) {
                const errorType = error?.message.message_template || (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED;
                const mappedErrorMessage = errorType in (0, $0903c7398792a385$export$4a95903507aabb8b) ? (0, $0903c7398792a385$export$4a95903507aabb8b)[errorType] : (0, $0903c7398792a385$export$4a95903507aabb8b).UNEXPECTED;
                const isExpectedError = $99eeed3aeaff7994$export$108645d938839241.includes(mappedErrorMessage);
                if (isExpectedError) {
                    markErrorAsHandled?.(new Error(error?.message.content));
                    aiDescriptionExperienceTracker?.abort?.({
                        reason: `Cannot generate summary due to ${errorType}`
                    });
                } else aiDescriptionExperienceTracker?.stopOnError({
                    error: new Error(error?.message.content)
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isExpectedError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99eeed3aeaff7994$var$ErrorMessage, {
                    errorType: errorType,
                    analyticsSource: analyticsSource
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorDisplay, {
                    error: new Error(error?.message.content)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99eeed3aeaff7994$var$ErrorMessage, {
                    errorType: errorType,
                    analyticsSource: analyticsSource
                })));
            }
            return null;
        case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
            aiDescriptionExperienceTracker?.succeed();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $99eeed3aeaff7994$var$styles.successContainer,
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
                href: "https://www.atlassian.com/trust/atlassian-intelligence",
                target: "_blank",
                xcss: $99eeed3aeaff7994$var$styles.anchor
            }, formatMessage((0, $60b569bc730323b0$export$defe85febe8b728c).aIDisclaimer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                spacing: "compact",
                href: "https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/",
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($320o0))),
                label: formatMessage((0, $60b569bc730323b0$export$defe85febe8b728c).aIAttributionLabel),
                target: "_blank"
            }));
        default:
            break;
    }
};


var $jlbje = parcelRequire("jlbje");


















var $1sCHt = parcelRequire("1sCHt");





var $7sJoX = parcelRequire("7sJoX");


var $bsSbN = parcelRequire("bsSbN");


var $4n1IT = parcelRequire("4n1IT");












var $fLf0C = parcelRequire("fLf0C");

var $jWbXj = parcelRequire("jWbXj");







var $hgxhy = parcelRequire("hgxhy");

const $28c7869605f604a7$export$2a373433aec2c21b = 'labelColor';





const $426c0ff44d0b4216$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    labelButtonTitle: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.title",
        defaultMessage: "Label"
    },
    labelPopupTitle: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.popup.title",
        defaultMessage: "Label"
    },
    hideLabelButtonText: {
        id: "company-hub.company-hub-common.config-panel.content.label-button.popup.hide-label-button.text",
        defaultMessage: "Hide label"
    }
});


const $80c03b27b112d5fb$var$styles = {
    labelPopupContainer: "_39xV02N91d _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE"
};
const $80c03b27b112d5fb$export$239fbcd864262455 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { labelId: labelId, labelValue: labelValue, handleLabelChange: handleLabelChange, isLabelHiddenValue: isLabelHiddenValue, handleIsLabelHiddenChange: handleIsLabelHiddenChange, labelColorValue: labelColorValue, handleLabelColorChange: handleLabelColorChange } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t1;
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const [openPopup, setOpenPopup] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const customColorRef = (0, $cozmU.useRef)();
    let t2;
    if ($[2] !== handleLabelChange) {
        t2 = (event)=>{
            handleLabelChange(event.currentTarget.value.toUpperCase());
        };
        $[2] = handleLabelChange;
        $[3] = t2;
    } else t2 = $[3];
    const handleChangeTextField = t2;
    let t3;
    if ($[4] !== handleLabelColorChange) {
        t3 = (color)=>{
            handleLabelColorChange(color);
        };
        $[4] = handleLabelColorChange;
        $[5] = t3;
    } else t3 = $[5];
    const handleChangeColorPicker = t3;
    let t4;
    if ($[6] !== handleIsLabelHiddenChange || $[7] !== isLabelHiddenValue) {
        t4 = ()=>{
            handleIsLabelHiddenChange(!isLabelHiddenValue);
        };
        $[6] = handleIsLabelHiddenChange;
        $[7] = isLabelHiddenValue;
        $[8] = t4;
    } else t4 = $[8];
    const handleHideToggle = t4;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>setOpenPopup(false);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== backgroundColorMap || $[11] !== brandBackgroundColorMap || $[12] !== formatMessage || $[13] !== handleChangeColorPicker || $[14] !== handleChangeTextField || $[15] !== handleHideToggle || $[16] !== hideDefaultColorPalette || $[17] !== isLabelHiddenValue || $[18] !== labelColorValue || $[19] !== labelId || $[20] !== labelValue) {
        t6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200",
                xcss: $80c03b27b112d5fb$var$styles.labelPopupContainer,
                testId: "label-popup-content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
                htmlFor: labelId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $426c0ff44d0b4216$export$defe85febe8b728c).labelPopupTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                isTooltipDisabled: false,
                isSelected: isLabelHiddenValue,
                spacing: "compact",
                appearance: "subtle",
                label: formatMessage((0, $426c0ff44d0b4216$export$defe85febe8b728c).hideLabelButtonText),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))),
                onClick: handleHideToggle
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                id: labelId,
                value: labelValue?.toUpperCase(),
                onChange: handleChangeTextField
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fLf0C.CuratedPalette), {
                analyticsSource: (0, $28c7869605f604a7$export$2a373433aec2c21b),
                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                customColorRef: customColorRef,
                onChange: handleChangeColorPicker,
                value: labelColorValue || (0, $jWbXj.DEFAULT_GRAY_COLOR)
            }));
        $[10] = backgroundColorMap;
        $[11] = brandBackgroundColorMap;
        $[12] = formatMessage;
        $[13] = handleChangeColorPicker;
        $[14] = handleChangeTextField;
        $[15] = handleHideToggle;
        $[16] = hideDefaultColorPalette;
        $[17] = isLabelHiddenValue;
        $[18] = labelColorValue;
        $[19] = labelId;
        $[20] = labelValue;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== formatMessage || $[23] !== openPopup) {
        t7 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                iconAfter: $80c03b27b112d5fb$var$_temp,
                onClick: ()=>setOpenPopup(!openPopup),
                isSelected: openPopup
            }, formatMessage((0, $426c0ff44d0b4216$export$defe85febe8b728c).labelButtonTitle));
        $[22] = formatMessage;
        $[23] = openPopup;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== openPopup || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: openPopup,
            onClose: t5,
            placement: "bottom-start",
            content: t6,
            trigger: t7
        });
        $[25] = openPopup;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ labelId: labelId, labelValue: labelValue, handleLabelChange: handleLabelChange, isLabelHiddenValue: isLabelHiddenValue, handleIsLabelHiddenChange: handleIsLabelHiddenChange, labelColorValue: labelColorValue, handleLabelColorChange: handleLabelColorChange })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const [openPopup, setOpenPopup] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const customColorRef = (0, $cozmU.useRef)();
    const defaultLabelColor = (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const handleChangeTextField = (0, $cozmU.useCallback)((event)=>{
        handleLabelChange(event.currentTarget.value.toUpperCase());
    }, [
        handleLabelChange
    ]);
    const handleChangeColorPicker = (0, $cozmU.useCallback)((color)=>{
        handleLabelColorChange(color);
    }, [
        handleLabelColorChange
    ]);
    const handleHideToggle = ()=>{
        handleIsLabelHiddenChange(!isLabelHiddenValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: openPopup,
        onClose: ()=>setOpenPopup(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.200",
                xcss: $80c03b27b112d5fb$var$styles.labelPopupContainer,
                testId: "label-popup-content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
                htmlFor: labelId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $426c0ff44d0b4216$export$defe85febe8b728c).labelPopupTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                isTooltipDisabled: false,
                isSelected: isLabelHiddenValue,
                spacing: "compact",
                appearance: "subtle",
                label: formatMessage((0, $426c0ff44d0b4216$export$defe85febe8b728c).hideLabelButtonText),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))),
                onClick: handleHideToggle
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                id: labelId,
                value: labelValue?.toUpperCase(),
                onChange: handleChangeTextField
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fLf0C.CuratedPalette), {
                analyticsSource: (0, $28c7869605f604a7$export$2a373433aec2c21b),
                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                customColorRef: customColorRef,
                onChange: handleChangeColorPicker,
                value: labelColorValue || defaultLabelColor
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...triggerProps,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setOpenPopup(!openPopup),
                isSelected: openPopup
            }, formatMessage((0, $426c0ff44d0b4216$export$defe85febe8b728c).labelButtonTitle))
    });
};
function $80c03b27b112d5fb$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}


var $l2vMT = parcelRequire("l2vMT");



var $g6P9J = parcelRequire("g6P9J");




var $619Qo = parcelRequire("619Qo");















const $faa167ebfb79229f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkFieldLabel: {
        id: "company-hub.cards-extension.config-panel.link.field.label",
        defaultMessage: "Link"
    },
    titleFieldLabel: {
        id: "company-hub.cards-extension.title.field.label",
        defaultMessage: "Title"
    },
    recommendedFieldLabel: {
        id: "company-hub.cards-extension.recommended.field.label",
        defaultMessage: "(Recommended)"
    },
    descriptionFieldLabel: {
        id: "company-hub.cards-extension.description.field.label",
        defaultMessage: "Description"
    }
});


const $a77af11f48935525$var$styles = {
    aiLoadingTextContainer: "_2sNsIg7NXe _1UtDYzZpcK",
    fieldWrapperStyles: "_3138425zaO"
};
const $a77af11f48935525$var$debouncedParametersUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((updateCardFormField, inputPropertyToUpdate, inputIsUserEditedPropertyToUpdate, cardId, value, createAnalyticsEvent, analyticsSource, shouldUpdateUserEdited = true)=>{
    updateCardFormField(cardId, {
        [inputPropertyToUpdate]: value,
        [inputIsUserEditedPropertyToUpdate]: shouldUpdateUserEdited
    });
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'edited',
            actionSubject: inputPropertyToUpdate,
            source: analyticsSource
        }
    }).fire();
}, 400); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a77af11f48935525$var$RecommendedWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_41LZZBYbGa _1kk5Tku7m9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_41LZZBYbGa _1kk5Tku7m9",
            __cmplp.className
        ])
    });
});
const $a77af11f48935525$var$externalSiteMatcher = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
const $a77af11f48935525$var$getFieldsToUpdateOnLinkSelect = async (selectedLink, fetchCoverImageUrl, cardImage, cardTitle, cardDescription, isTitleUserEdited, isDescriptionUserEdited, submitError)=>{
    let fieldsToUpdate = (0, $k2pUk.updateLinkAndConfluencePageId)(selectedLink.url, '', true);
    try {
        const client = new (0, $4yccB.default)();
        const queriedMetadata = await client.fetchData(selectedLink.url);
        const { name: name, image: image, summary: summary } = queriedMetadata?.data || {};
        const { objectId: objectId, resourceType: resourceType } = queriedMetadata?.meta || {};
        fieldsToUpdate = {
            ...fieldsToUpdate,
            ...(0, $k2pUk.updateLinkAndConfluencePageId)(selectedLink.url, objectId, true, resourceType)
        };
        if (!cardTitle || isTitleUserEdited === false) {
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).TITLE] = name;
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = false;
        }
        if (!cardDescription || isDescriptionUserEdited === false) {
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = summary;
            fieldsToUpdate[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = false;
        } // Updating imageSrc and imageAltText
        let newImageSrc = cardImage || '';
        const newImageAltText = '';
        const coverImage = await fetchCoverImageUrl(objectId, image);
        if (coverImage) {
            const isExternalSiteImage = $a77af11f48935525$var$externalSiteMatcher.test(coverImage);
            if (!(0, $619Qo.isUnsplashImage)(coverImage) && !isExternalSiteImage) // For custom uploaded image save it in format `contentId/imageId`
            newImageSrc = `${objectId}/${coverImage}`;
            else newImageSrc = coverImage;
        } // Do not store private Loom CDN thumbnails (they expire via Policy)
        if ((0, $jlbje.isPrivateLoomImageUrl)(newImageSrc)) newImageSrc = '';
        fieldsToUpdate = {
            ...fieldsToUpdate,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_SRC]: newImageSrc,
            [(0, $hjUDQ.ITEM_FIELDS).IMAGE_ALT_TEXT]: newImageAltText
        };
    } catch (error) {
        submitError?.(error);
    }
    return fieldsToUpdate;
};
const $a77af11f48935525$export$cc05dad3d91e8c95 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(97);
    const { cardParameters: cardParameters, updateCardFormField: updateCardFormField, isDisabled: isDisabled, showDescription: showDescription, showLabel: showLabel, layout: layout, size: size } = t0;
    const { cardId: cardId, link: link, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, confluencePageId: confluencePageId, linkResourceType: linkResourceType } = cardParameters;
    const { cloudId: cloudId, submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $cozmU.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $cozmU.useState)(description);
    const [labelValue, setLabelValue] = (0, $cozmU.useState)(label);
    const [isLabelHiddenValue, setIsLabelHiddenValue] = (0, $cozmU.useState)(isLabelHidden);
    const [labelColorValue, setLabelColorValue] = (0, $cozmU.useState)(labelColor);
    const [isAILoading, setIsAILoading] = (0, $cozmU.useState)();
    const [aiDescriptionContent, setAIDescriptionContent] = (0, $cozmU.useState)();
    const [aiError, setAIError] = (0, $cozmU.useState)();
    const [aiResponseState, setAIResponseState] = (0, $cozmU.useState)();
    const linkId = `link-field-${cardId}`;
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const labelId = `label-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== cardId || $[1] !== createAnalyticsEvent || $[2] !== updateCardFormField) {
        t1 = (value, aiValue)=>{
            setDescriptionValue(value);
            $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION, (0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE), !aiValue);
        };
        $[0] = cardId;
        $[1] = createAnalyticsEvent;
        $[2] = updateCardFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleDescriptionChange = t1;
    let t2;
    if ($[4] !== cardId || $[5] !== createAnalyticsEvent || $[6] !== updateCardFormField) {
        t2 = (event)=>{
            const { value: value_0 } = event.currentTarget;
            setTitleValue(value_0.trimStart());
            $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).TITLE, (0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
        };
        $[4] = cardId;
        $[5] = createAnalyticsEvent;
        $[6] = updateCardFormField;
        $[7] = t2;
    } else t2 = $[7];
    const handleTitleOnChange = t2;
    let t3;
    if ($[8] !== cardId || $[9] !== createAnalyticsEvent || $[10] !== updateCardFormField) {
        t3 = (value_1)=>{
            setLabelValue(value_1);
            $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).LABEL, true, cardId, value_1, createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
        };
        $[8] = cardId;
        $[9] = createAnalyticsEvent;
        $[10] = updateCardFormField;
        $[11] = t3;
    } else t3 = $[11];
    const handleLabelChange = t3;
    let t4;
    if ($[12] !== cardId || $[13] !== updateCardFormField) {
        t4 = (value_2)=>{
            setIsLabelHiddenValue(value_2);
            updateCardFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).IS_LABEL_HIDDEN]: value_2
            });
        };
        $[12] = cardId;
        $[13] = updateCardFormField;
        $[14] = t4;
    } else t4 = $[14];
    const handleIsLabelHiddenChange = t4;
    let t5;
    if ($[15] !== cardId || $[16] !== updateCardFormField) {
        t5 = (value_3)=>{
            setLabelColorValue(value_3);
            updateCardFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).LABEL_COLOR]: value_3
            });
        };
        $[15] = cardId;
        $[16] = updateCardFormField;
        $[17] = t5;
    } else t5 = $[17];
    const handleLabelColorChange = t5;
    const fetchCoverImageUrl = (0, $g6P9J.useFetchCoverImage)((0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    let t6;
    if ($[18] !== cardId || $[19] !== description || $[20] !== fetchCoverImageUrl || $[21] !== imageSrc || $[22] !== isDescriptionUserEdited || $[23] !== isTitleUserEdited || $[24] !== submitError || $[25] !== title || $[26] !== updateCardFormField) {
        t6 = async (selectedLink)=>{
            const fieldsToUpdate = await $a77af11f48935525$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
            updateCardFormField(cardId, fieldsToUpdate);
        };
        $[18] = cardId;
        $[19] = description;
        $[20] = fetchCoverImageUrl;
        $[21] = imageSrc;
        $[22] = isDescriptionUserEdited;
        $[23] = isTitleUserEdited;
        $[24] = submitError;
        $[25] = title;
        $[26] = updateCardFormField;
        $[27] = t6;
    } else t6 = $[27];
    const handleSelectLink = t6;
    let t7;
    if ($[28] !== cardId || $[29] !== isDescriptionUserEdited || $[30] !== isTitleUserEdited || $[31] !== updateCardFormField) {
        t7 = ()=>{
            const fieldsToClear = {
                ...(0, $k2pUk.updateLinkAndConfluencePageId)("", "")
            };
            if (isTitleUserEdited === false) {
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).TITLE] = "";
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
            }
            if (isDescriptionUserEdited === false) {
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = "";
                fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
                setIsAILoading(undefined);
            }
            updateCardFormField(cardId, fieldsToClear);
        };
        $[28] = cardId;
        $[29] = isDescriptionUserEdited;
        $[30] = isTitleUserEdited;
        $[31] = updateCardFormField;
        $[32] = t7;
    } else t7 = $[32];
    const handleClearLink = t7;
    let t8;
    let t9;
    if ($[33] !== aiDescriptionContent || $[34] !== aiError || $[35] !== aiResponseState || $[36] !== cardId || $[37] !== createAnalyticsEvent || $[38] !== description || $[39] !== isAILoading || $[40] !== title || $[41] !== updateCardFormField) {
        t8 = ()=>{
            setTitleValue(title);
            if (isAILoading && aiDescriptionContent && aiResponseState === (0, $aJxVU.ConvoAIResponseState).FinalResponse) {
                updateCardFormField(cardId, {
                    description: aiDescriptionContent,
                    isDescriptionUserEdited: false
                });
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "edited",
                        actionSubject: (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION,
                        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                        attributes: {
                            isAIGenerated: true
                        }
                    }
                }).fire();
                setIsAILoading(false);
            }
            setDescriptionValue(description);
            if (aiError && (0, (/*@__PURE__*/$parcel$interopDefault($1d3b20042c2b22b5$exports)))(isAILoading)) setIsAILoading(false);
        };
        t9 = [
            aiDescriptionContent,
            aiResponseState,
            description,
            title,
            isAILoading,
            aiError,
            updateCardFormField,
            cardId,
            createAnalyticsEvent
        ];
        $[33] = aiDescriptionContent;
        $[34] = aiError;
        $[35] = aiResponseState;
        $[36] = cardId;
        $[37] = createAnalyticsEvent;
        $[38] = description;
        $[39] = isAILoading;
        $[40] = title;
        $[41] = updateCardFormField;
        $[42] = t8;
        $[43] = t9;
    } else {
        t8 = $[42];
        t9 = $[43];
    }
    (0, $cozmU.useEffect)(t8, t9);
    let t10;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).linkFieldLabel));
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== linkId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: linkId
        }, t10);
        $[45] = linkId;
        $[46] = t11;
    } else t11 = $[46];
    let t12;
    if ($[47] !== cloudId || $[48] !== handleClearLink || $[49] !== handleSelectLink || $[50] !== isDisabled || $[51] !== link || $[52] !== linkId || $[53] !== title) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2vMT.LinkPicker), {
            cloudId: cloudId,
            link: link,
            id: linkId,
            title: title,
            handleSelectLink: handleSelectLink,
            handleClearLink: handleClearLink,
            isDisabled: isDisabled
        });
        $[47] = cloudId;
        $[48] = handleClearLink;
        $[49] = handleSelectLink;
        $[50] = isDisabled;
        $[51] = link;
        $[52] = linkId;
        $[53] = title;
        $[54] = t12;
    } else t12 = $[54];
    let t13;
    if ($[55] !== handleIsLabelHiddenChange || $[56] !== handleLabelChange || $[57] !== handleLabelColorChange || $[58] !== isLabelHiddenValue || $[59] !== labelColorValue || $[60] !== labelId || $[61] !== labelValue || $[62] !== layout || $[63] !== showLabel || $[64] !== size) {
        t13 = layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && showLabel && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $a77af11f48935525$var$styles.fieldWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80c03b27b112d5fb$export$239fbcd864262455), {
            labelId: labelId,
            labelValue: labelValue?.trimStart(),
            handleLabelChange: handleLabelChange,
            isLabelHiddenValue: isLabelHiddenValue,
            handleIsLabelHiddenChange: handleIsLabelHiddenChange,
            labelColorValue: labelColorValue,
            handleLabelColorChange: handleLabelColorChange
        }));
        $[55] = handleIsLabelHiddenChange;
        $[56] = handleLabelChange;
        $[57] = handleLabelColorChange;
        $[58] = isLabelHiddenValue;
        $[59] = labelColorValue;
        $[60] = labelId;
        $[61] = labelValue;
        $[62] = layout;
        $[63] = showLabel;
        $[64] = size;
        $[65] = t13;
    } else t13 = $[65];
    let t14;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).titleFieldLabel);
        $[66] = t14;
    } else t14 = $[66];
    let t15;
    if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, t14, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a77af11f48935525$var$RecommendedWrapper, null, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).recommendedFieldLabel)));
        $[67] = t15;
    } else t15 = $[67];
    let t16;
    if ($[68] !== titleId) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: titleId
        }, t15);
        $[68] = titleId;
        $[69] = t16;
    } else t16 = $[69];
    let t17;
    if ($[70] !== titleValue) {
        t17 = titleValue?.trimStart();
        $[70] = titleValue;
        $[71] = t17;
    } else t17 = $[71];
    let t18;
    if ($[72] !== handleTitleOnChange || $[73] !== isDisabled || $[74] !== t17 || $[75] !== titleId) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            id: titleId,
            value: t17,
            onChange: handleTitleOnChange,
            maxLength: 255,
            isDisabled: isDisabled
        });
        $[72] = handleTitleOnChange;
        $[73] = isDisabled;
        $[74] = t17;
        $[75] = titleId;
        $[76] = t18;
    } else t18 = $[76];
    let t19;
    if ($[77] !== t16 || $[78] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a77af11f48935525$var$styles.fieldWrapperStyles,
            direction: "column"
        }, t16, t18);
        $[77] = t16;
        $[78] = t18;
        $[79] = t19;
    } else t19 = $[79];
    let t20;
    if ($[80] !== aiError || $[81] !== aiResponseState || $[82] !== confluencePageId || $[83] !== descriptionId || $[84] !== descriptionValue || $[85] !== handleDescriptionChange || $[86] !== isAILoading || $[87] !== isDisabled || $[88] !== linkResourceType || $[89] !== showDescription) {
        t20 = showDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
            config: {
                product: "confluence",
                subproduct: "confluence",
                aiFeatureName: "companyHubCardsAIDescription",
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                isAIFeature: 1
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $a77af11f48935525$var$styles.fieldWrapperStyles,
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: descriptionId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
            showUpdatedStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).descriptionFieldLabel))), confluencePageId && linkResourceType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $569684bdc390020f$export$4e2e1778ae07237), {
            confluencePageId: confluencePageId,
            linkResourceType: linkResourceType,
            isAILoading: isAILoading,
            setIsAILoading: setIsAILoading,
            setAIError: setAIError,
            setAIDescriptionContent: setAIDescriptionContent,
            setAIResponseState: setAIResponseState,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        }), isAILoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
            loading: true,
            useModalStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $a77af11f48935525$var$styles.aiLoadingTextContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBIvl.AIStreamLoading), {
            padding: "space.250"
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            id: descriptionId,
            rows: 3,
            value: descriptionValue?.trimStart(),
            onChange: (event_0)=>{
                setIsAILoading(undefined);
                handleDescriptionChange(event_0.currentTarget.value);
            },
            maxLength: 700,
            isDisabled: isDisabled,
            testId: "card-description-field"
        }), aiResponseState && (0, (/*@__PURE__*/$parcel$interopDefault($1d3b20042c2b22b5$exports)))(isAILoading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99eeed3aeaff7994$export$f1233e533b345659), {
            responseState: aiResponseState,
            error: aiError,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        }))));
        $[80] = aiError;
        $[81] = aiResponseState;
        $[82] = confluencePageId;
        $[83] = descriptionId;
        $[84] = descriptionValue;
        $[85] = handleDescriptionChange;
        $[86] = isAILoading;
        $[87] = isDisabled;
        $[88] = linkResourceType;
        $[89] = showDescription;
        $[90] = t20;
    } else t20 = $[90];
    let t21;
    if ($[91] !== t11 || $[92] !== t12 || $[93] !== t13 || $[94] !== t19 || $[95] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t11, t12, t13, t19, t20);
        $[91] = t11;
        $[92] = t12;
        $[93] = t13;
        $[94] = t19;
        $[95] = t20;
        $[96] = t21;
    } else t21 = $[96];
    return t21;
} : ({ cardParameters: cardParameters, updateCardFormField: updateCardFormField, isDisabled: isDisabled, showDescription: showDescription, showLabel: showLabel, layout: layout, size: size })=>{
    const { cardId: cardId, link: link, title: title, description: description, label: label, isLabelHidden: isLabelHidden, labelColor: labelColor, isTitleUserEdited: isTitleUserEdited, isDescriptionUserEdited: isDescriptionUserEdited, imageSrc: imageSrc, confluencePageId: confluencePageId, linkResourceType: linkResourceType } = cardParameters;
    const { cloudId: cloudId, submitError: submitError } = (0, $cfM7x.useProductDependencies)();
    const [titleValue, setTitleValue] = (0, $cozmU.useState)(title);
    const [descriptionValue, setDescriptionValue] = (0, $cozmU.useState)(description);
    const [labelValue, setLabelValue] = (0, $cozmU.useState)(label);
    const [isLabelHiddenValue, setIsLabelHiddenValue] = (0, $cozmU.useState)(isLabelHidden);
    const [labelColorValue, setLabelColorValue] = (0, $cozmU.useState)(labelColor);
    const [isAILoading, setIsAILoading] = (0, $cozmU.useState)();
    const [aiDescriptionContent, setAIDescriptionContent] = (0, $cozmU.useState)();
    const [aiError, setAIError] = (0, $cozmU.useState)();
    const [aiResponseState, setAIResponseState] = (0, $cozmU.useState)();
    const linkId = `link-field-${cardId}`;
    const titleId = `title-field-${cardId}`;
    const descriptionId = `description-field-${cardId}`;
    const labelId = `label-field-${cardId}`;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleDescriptionChange = (0, $cozmU.useCallback)((value, aiValue)=>{
        setDescriptionValue(value);
        $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION, (0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED, cardId, value, createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE), !aiValue);
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleTitleOnChange = (0, $cozmU.useCallback)((event)=>{
        const { value: value_0 } = event.currentTarget;
        setTitleValue(value_0.trimStart());
        $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).TITLE, (0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED, cardId, value_0.trimStart(), createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleLabelChange = (0, $cozmU.useCallback)((value_1)=>{
        setLabelValue(value_1);
        $a77af11f48935525$var$debouncedParametersUpdate(updateCardFormField, (0, $hjUDQ.ITEM_FIELDS).LABEL, true, cardId, value_1, createAnalyticsEvent, (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    }, [
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    const handleIsLabelHiddenChange = (0, $cozmU.useCallback)((value_2)=>{
        setIsLabelHiddenValue(value_2);
        updateCardFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).IS_LABEL_HIDDEN]: value_2
        });
    }, [
        updateCardFormField,
        cardId
    ]);
    const handleLabelColorChange = (0, $cozmU.useCallback)((value_3)=>{
        setLabelColorValue(value_3);
        updateCardFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).LABEL_COLOR]: value_3
        });
    }, [
        updateCardFormField,
        cardId
    ]);
    const fetchCoverImageUrl = (0, $g6P9J.useFetchCoverImage)((0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE));
    const handleSelectLink = (0, $cozmU.useCallback)(async (selectedLink)=>{
        const fieldsToUpdate = await $a77af11f48935525$var$getFieldsToUpdateOnLinkSelect(selectedLink, fetchCoverImageUrl, imageSrc, title, description, isTitleUserEdited || false, isDescriptionUserEdited || false, submitError);
        updateCardFormField(cardId, fieldsToUpdate);
    }, [
        cardId,
        imageSrc,
        title,
        description,
        isTitleUserEdited,
        isDescriptionUserEdited,
        fetchCoverImageUrl,
        updateCardFormField,
        submitError
    ]);
    const handleClearLink = (0, $cozmU.useCallback)(()=>{
        const fieldsToClear = {
            ...(0, $k2pUk.updateLinkAndConfluencePageId)('', '')
        };
        if (isTitleUserEdited === false) {
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).TITLE] = '';
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_TITLE_USER_EDITED] = undefined;
        }
        if (isDescriptionUserEdited === false) {
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).DESCRIPTION] = '';
            fieldsToClear[(0, $hjUDQ.ITEM_FIELDS).IS_DESCRIPTION_USER_EDITED] = undefined;
            setIsAILoading(undefined);
        }
        updateCardFormField(cardId, fieldsToClear);
    }, [
        updateCardFormField,
        cardId,
        isTitleUserEdited,
        isDescriptionUserEdited
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Sets title from prop
        setTitleValue(title); // If user triggers AI, set the the AI-generated content
        if (isAILoading && aiDescriptionContent && aiResponseState === (0, $aJxVU.ConvoAIResponseState).FinalResponse) {
            updateCardFormField(cardId, {
                description: aiDescriptionContent,
                isDescriptionUserEdited: false
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'edited',
                    actionSubject: (0, $hjUDQ.ITEM_FIELDS).DESCRIPTION,
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        isAIGenerated: true
                    }
                }
            }).fire();
            setIsAILoading(false);
        }
        setDescriptionValue(description); // Sets AI response loading state to false if AI error
        if (aiError && (0, (/*@__PURE__*/$parcel$interopDefault($1d3b20042c2b22b5$exports)))(isAILoading)) setIsAILoading(false);
    }, [
        aiDescriptionContent,
        aiResponseState,
        description,
        title,
        isAILoading,
        aiError,
        updateCardFormField,
        cardId,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: linkId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).linkFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2vMT.LinkPicker), {
        cloudId: cloudId,
        link: link,
        id: linkId,
        title: title,
        handleSelectLink: handleSelectLink,
        handleClearLink: handleClearLink,
        isDisabled: isDisabled
    }), layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && showLabel && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $a77af11f48935525$var$styles.fieldWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80c03b27b112d5fb$export$239fbcd864262455), {
        labelId: labelId,
        labelValue: labelValue?.trimStart(),
        handleLabelChange: handleLabelChange,
        isLabelHiddenValue: isLabelHiddenValue,
        handleIsLabelHiddenChange: handleIsLabelHiddenChange,
        labelColorValue: labelColorValue,
        handleLabelColorChange: handleLabelColorChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a77af11f48935525$var$styles.fieldWrapperStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).titleFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a77af11f48935525$var$RecommendedWrapper, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).recommendedFieldLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        id: titleId,
        value: titleValue?.trimStart(),
        onChange: handleTitleOnChange,
        maxLength: 255,
        isDisabled: isDisabled
    })), showDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: {
            product: 'confluence',
            subproduct: 'confluence',
            aiFeatureName: 'companyHubCardsAIDescription',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            isAIFeature: 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $a77af11f48935525$var$styles.fieldWrapperStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgxhy.PanelSubheader), {
        showUpdatedStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $faa167ebfb79229f$export$defe85febe8b728c).descriptionFieldLabel))), confluencePageId && linkResourceType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $569684bdc390020f$export$4e2e1778ae07237), {
        confluencePageId: confluencePageId,
        linkResourceType: linkResourceType,
        isAILoading: isAILoading,
        setIsAILoading: setIsAILoading,
        setAIError: setAIError,
        setAIDescriptionContent: setAIDescriptionContent,
        setAIResponseState: setAIResponseState,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    }), isAILoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
        loading: true,
        useModalStyles: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a77af11f48935525$var$styles.aiLoadingTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBIvl.AIStreamLoading), {
        padding: "space.250"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        id: descriptionId,
        rows: 3,
        value: descriptionValue?.trimStart(),
        onChange: (event_0)=>{
            setIsAILoading(undefined);
            handleDescriptionChange(event_0.currentTarget.value);
        },
        maxLength: 700,
        isDisabled: isDisabled,
        testId: "card-description-field"
    }), aiResponseState && (0, (/*@__PURE__*/$parcel$interopDefault($1d3b20042c2b22b5$exports)))(isAILoading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99eeed3aeaff7994$export$f1233e533b345659), {
        responseState: aiResponseState,
        error: aiError,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    })))));
};





const $8e0f4dd6f50d2fae$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    backgroundColor: {
        id: "company-hub.cards-extension.card.background.color",
        defaultMessage: "Background color"
    },
    textColor: {
        id: "company-hub.cards-extension.card.text.color",
        defaultMessage: "Text color"
    },
    colorValidationSuccessMessage: {
        id: "company-hub.cards-extension.card.color-contrast.success",
        defaultMessage: "Your text and background colors work well for readability."
    },
    colorValidationFailMessage: {
        id: "company-hub.cards-extension.card.color-contrast.fail",
        defaultMessage: "Your text and background colors don\u2019t work well for readability."
    }
});


const $94c05abf6ba99c9e$var$styles = {
    wrapper: "_4xdlr0FlnN _0aFT5vbt8w _3138422ADO _1DCdHi2ADO _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    bgAndTextColorOptionsWrapper: "_3138425zaO"
};
const $94c05abf6ba99c9e$export$64ef9b8c11710c47 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { cardParameters: cardParameters, contentId: contentId, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, isNoImageAllowed: isNoImageAllowed, showDescription: showDescription, layout: layout, size: size, showSegmentation: showSegmentation, showBgAndTextColorOptions: showBgAndTextColorOptions, updateCardFormField: updateCardFormField, showMediaPicker: showMediaPicker, showLabel: showLabel } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, audienceSegmentationGroupIds: audienceSegmentationGroupIds, backgroundColor: t1, textColor: t2 } = cardParameters;
    const backgroundColor = t1 === undefined ? (0, $k2pUk.cardNewParametersV4).backgroundColor : t1;
    const textColor = t2 === undefined ? (0, $k2pUk.cardNewParametersV4).textColor : t2;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t3;
    if ($[0] !== branding) {
        t3 = branding ?? {};
        $[0] = branding;
        $[1] = t3;
    } else t3 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = t3;
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    let t4;
    if ($[2] !== textColor) {
        t4 = (color)=>(0, $4yUlE.isReadable)(color, textColor);
        $[2] = textColor;
        $[3] = t4;
    } else t4 = $[3];
    const isReadableBackgroundColor = t4;
    let t5;
    if ($[4] !== backgroundColor) {
        t5 = (color_0)=>(0, $4yUlE.isReadable)(color_0, backgroundColor);
        $[4] = backgroundColor;
        $[5] = t5;
    } else t5 = $[5];
    const isReadableTextColor = t5;
    let t6;
    if ($[6] !== cardId || $[7] !== updateCardFormField) {
        t6 = (bgColor)=>{
            updateCardFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: bgColor
            });
        };
        $[6] = cardId;
        $[7] = updateCardFormField;
        $[8] = t6;
    } else t6 = $[8];
    const updateBackgroundColor = t6;
    let t7;
    if ($[9] !== cardId || $[10] !== updateCardFormField) {
        t7 = (color_1)=>{
            updateCardFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: color_1
            });
        };
        $[9] = cardId;
        $[10] = updateCardFormField;
        $[11] = t7;
    } else t7 = $[11];
    const updateTextColor = t7;
    (0, $5ddnJ.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateTextColor, branding?.defaultParameters);
    let t8;
    if ($[12] !== cardId || $[13] !== updateCardFormField) {
        t8 = (selectedGroups)=>{
            updateCardFormField(cardId, {
                [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: selectedGroups
            });
        };
        $[12] = cardId;
        $[13] = updateCardFormField;
        $[14] = t8;
    } else t8 = $[14];
    const handleOnGroupSelected = t8;
    let t9;
    if ($[15] !== audienceSegmentationGroupIds || $[16] !== handleOnGroupSelected || $[17] !== showSegmentation) {
        t9 = showSegmentation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2d6c26cfaa807db$export$2261f4215d6c3d25), {
            targetGroupsIds: audienceSegmentationGroupIds,
            onGroupSelected: handleOnGroupSelected,
            showUpdatedStyles: true,
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        }));
        $[15] = audienceSegmentationGroupIds;
        $[16] = handleOnGroupSelected;
        $[17] = showSegmentation;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== cardParameters || $[20] !== isDisabled || $[21] !== layout || $[22] !== showDescription || $[23] !== showLabel || $[24] !== size || $[25] !== updateCardFormField) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a77af11f48935525$export$cc05dad3d91e8c95), {
            cardParameters: cardParameters,
            updateCardFormField: updateCardFormField,
            isDisabled: isDisabled,
            showDescription: showDescription,
            showLabel: showLabel,
            layout: layout,
            size: size
        });
        $[19] = cardParameters;
        $[20] = isDisabled;
        $[21] = layout;
        $[22] = showDescription;
        $[23] = showLabel;
        $[24] = size;
        $[25] = updateCardFormField;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== cardId || $[28] !== confluencePageId || $[29] !== contentId || $[30] !== enableLinkInputInMediaPicker || $[31] !== imageAltText || $[32] !== imageSrc || $[33] !== initialUnsplashResults || $[34] !== isNoImageAllowed || $[35] !== showMediaPicker || $[36] !== updateCardFormField) {
        t11 = showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZnIz.ImageField), {
            shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            itemId: cardId,
            contentId: contentId,
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            updateItemFormField: updateCardFormField
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cImA8.UnsplashSearchField), {
            itemId: cardId,
            idPrefix: "card",
            imageSrc: imageSrc,
            imageAltText: imageAltText,
            updateItemFormField: updateCardFormField,
            initialUnsplashResults: initialUnsplashResults,
            contentId: contentId,
            confluencePageId: confluencePageId,
            isNoImageAllowed: isNoImageAllowed,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        });
        $[27] = cardId;
        $[28] = confluencePageId;
        $[29] = contentId;
        $[30] = enableLinkInputInMediaPicker;
        $[31] = imageAltText;
        $[32] = imageSrc;
        $[33] = initialUnsplashResults;
        $[34] = isNoImageAllowed;
        $[35] = showMediaPicker;
        $[36] = updateCardFormField;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== backgroundColor || $[39] !== backgroundColorMap || $[40] !== brandBackgroundColorMap || $[41] !== emptyColorMap || $[42] !== formatMessage || $[43] !== hideDefaultColorPalette || $[44] !== isCompanyHub || $[45] !== isReadableBackgroundColor || $[46] !== isReadableTextColor || $[47] !== showBgAndTextColorOptions || $[48] !== textColor || $[49] !== textColorMap || $[50] !== updateBackgroundColor || $[51] !== updateTextColor) {
        t12 = showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            xcss: $94c05abf6ba99c9e$var$styles.bgAndTextColorOptionsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
            isReadableColor: isReadableBackgroundColor,
            onChange: updateBackgroundColor,
            value: backgroundColor,
            pickerTitle: (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).backgroundColor,
            validationSuccessMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
            isReadableColor: isReadableTextColor,
            onChange: updateTextColor,
            value: textColor,
            pickerTitle: (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).textColor,
            validationSuccessMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationSuccessMessage),
            validationFailMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationFailMessage),
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            showTextIcon: true
        })));
        $[38] = backgroundColor;
        $[39] = backgroundColorMap;
        $[40] = brandBackgroundColorMap;
        $[41] = emptyColorMap;
        $[42] = formatMessage;
        $[43] = hideDefaultColorPalette;
        $[44] = isCompanyHub;
        $[45] = isReadableBackgroundColor;
        $[46] = isReadableTextColor;
        $[47] = showBgAndTextColorOptions;
        $[48] = textColor;
        $[49] = textColorMap;
        $[50] = updateBackgroundColor;
        $[51] = updateTextColor;
        $[52] = t12;
    } else t12 = $[52];
    let t13;
    if ($[53] !== t10 || $[54] !== t11 || $[55] !== t12 || $[56] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: $94c05abf6ba99c9e$var$styles.wrapper
        }, t9, t10, t11, t12);
        $[53] = t10;
        $[54] = t11;
        $[55] = t12;
        $[56] = t9;
        $[57] = t13;
    } else t13 = $[57];
    return t13;
} : ({ cardParameters: cardParameters, contentId: contentId, initialUnsplashResults: initialUnsplashResults, isDisabled: isDisabled, isNoImageAllowed: isNoImageAllowed, showDescription: showDescription, layout: layout, size: size, showSegmentation: showSegmentation, showBgAndTextColorOptions: showBgAndTextColorOptions, updateCardFormField: updateCardFormField, showMediaPicker: showMediaPicker, showLabel: showLabel })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cardId: cardId, imageSrc: imageSrc, imageAltText: imageAltText, confluencePageId: confluencePageId, audienceSegmentationGroupIds: audienceSegmentationGroupIds, backgroundColor: backgroundColor = (0, $k2pUk.cardNewParametersV4).backgroundColor, textColor: textColor = (0, $k2pUk.cardNewParametersV4).textColor } = cardParameters;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, isCompanyHub: isCompanyHub, enableLinkInputInMediaPicker: enableLinkInputInMediaPicker, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const isReadableBackgroundColor = (color)=>(0, $4yUlE.isReadable)(color, textColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, backgroundColor);
    const updateBackgroundColor = (bgColor)=>{
        updateCardFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).BACKGROUND_COLOR]: bgColor
        });
    };
    const updateTextColor = (color_1)=>{
        updateCardFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).TEXT_COLOR]: color_1
        });
    };
    (0, $5ddnJ.useAutoTransitioningColors)(backgroundColor, isReadableTextColor, textColor, updateTextColor, branding?.defaultParameters);
    const handleOnGroupSelected = (selectedGroups)=>{
        updateCardFormField(cardId, {
            [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: selectedGroups
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $94c05abf6ba99c9e$var$styles.wrapper
    }, showSegmentation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2d6c26cfaa807db$export$2261f4215d6c3d25), {
        targetGroupsIds: audienceSegmentationGroupIds,
        onGroupSelected: handleOnGroupSelected,
        showUpdatedStyles: true,
        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a77af11f48935525$export$cc05dad3d91e8c95), {
        cardParameters: cardParameters,
        updateCardFormField: updateCardFormField,
        isDisabled: isDisabled,
        showDescription: showDescription,
        showLabel: showLabel,
        layout: layout,
        size: size
    }), showMediaPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ZnIz.ImageField), {
        shouldAllowLinkFromUrl: enableLinkInputInMediaPicker,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        itemId: cardId,
        contentId: contentId,
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        updateItemFormField: updateCardFormField
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cImA8.UnsplashSearchField), {
        itemId: cardId,
        idPrefix: "card",
        imageSrc: imageSrc,
        imageAltText: imageAltText,
        updateItemFormField: updateCardFormField,
        initialUnsplashResults: initialUnsplashResults,
        contentId: contentId,
        confluencePageId: confluencePageId,
        isNoImageAllowed: isNoImageAllowed,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    }), showBgAndTextColorOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $94c05abf6ba99c9e$var$styles.bgAndTextColorOptionsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).backgroundColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
        isReadableColor: isReadableBackgroundColor,
        onChange: updateBackgroundColor,
        value: backgroundColor,
        pickerTitle: (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).backgroundColor,
        validationSuccessMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).textColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
        isReadableColor: isReadableTextColor,
        onChange: updateTextColor,
        value: textColor,
        pickerTitle: (0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).textColor,
        validationSuccessMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationSuccessMessage),
        validationFailMessage: formatMessage((0, $8e0f4dd6f50d2fae$export$defe85febe8b728c).colorValidationFailMessage),
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        showTextIcon: true
    }))));
};


const $bffb5ed9c7d7934b$var$actionSubjectIdPostFix = 'Card';
const $bffb5ed9c7d7934b$export$b3865b40066cd705 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let cardsAreaContainerProps;
    if ($[0] !== t0) {
        ({ ...cardsAreaContainerProps } = t0);
        $[0] = t0;
        $[1] = cardsAreaContainerProps;
    } else cardsAreaContainerProps = $[1];
    const { items: items, contentId: contentId, isNoImageAllowed: isNoImageAllowed, showBgAndTextColorOptions: showBgAndTextColorOptions, showDescription: showDescription, layout: layout, size: size, showMediaPicker: showMediaPicker, showSegmentation: showSegmentation, showLabel: showLabel, updateCardFormField: updateCardFormField } = cardsAreaContainerProps;
    const initialUnsplashResults = (0, $5eKkh.useInitialUnsplashResults)(items);
    let t1;
    if ($[2] !== contentId || $[3] !== initialUnsplashResults || $[4] !== isNoImageAllowed || $[5] !== layout || $[6] !== showBgAndTextColorOptions || $[7] !== showDescription || $[8] !== showLabel || $[9] !== showMediaPicker || $[10] !== showSegmentation || $[11] !== size || $[12] !== updateCardFormField) {
        t1 = (cardParameters, isCardDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94c05abf6ba99c9e$export$64ef9b8c11710c47), {
                cardParameters: cardParameters,
                contentId: contentId,
                initialUnsplashResults: initialUnsplashResults,
                isDisabled: isCardDisabled,
                isNoImageAllowed: isNoImageAllowed,
                showBgAndTextColorOptions: showBgAndTextColorOptions,
                showDescription: showDescription,
                layout: layout,
                size: size,
                showMediaPicker: showMediaPicker,
                showSegmentation: showSegmentation,
                showLabel: showLabel,
                updateCardFormField: updateCardFormField
            });
        $[2] = contentId;
        $[3] = initialUnsplashResults;
        $[4] = isNoImageAllowed;
        $[5] = layout;
        $[6] = showBgAndTextColorOptions;
        $[7] = showDescription;
        $[8] = showLabel;
        $[9] = showMediaPicker;
        $[10] = showSegmentation;
        $[11] = size;
        $[12] = updateCardFormField;
        $[13] = t1;
    } else t1 = $[13];
    const renderCardContent = t1;
    let t2;
    if ($[14] !== cardsAreaContainerProps || $[15] !== renderCardContent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmFR8.ItemsListBuilder), {
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            actionSubjectIdPostFix: $bffb5ed9c7d7934b$var$actionSubjectIdPostFix,
            renderItemContent: renderCardContent,
            ...cardsAreaContainerProps
        });
        $[14] = cardsAreaContainerProps;
        $[15] = renderCardContent;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : ({ ...cardsAreaContainerProps })=>{
    const { items: items, contentId: contentId, isNoImageAllowed: isNoImageAllowed, showBgAndTextColorOptions: showBgAndTextColorOptions, showDescription: showDescription, layout: layout, size: size, showMediaPicker: showMediaPicker, showSegmentation: showSegmentation, showLabel: showLabel, updateCardFormField: updateCardFormField } = cardsAreaContainerProps;
    const initialUnsplashResults = (0, $5eKkh.useInitialUnsplashResults)(items);
    const renderCardContent = (cardParameters, isCardDisabled)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94c05abf6ba99c9e$export$64ef9b8c11710c47), {
            cardParameters: cardParameters,
            contentId: contentId,
            initialUnsplashResults: initialUnsplashResults,
            isDisabled: isCardDisabled,
            isNoImageAllowed: isNoImageAllowed,
            showBgAndTextColorOptions: showBgAndTextColorOptions,
            showDescription: showDescription,
            layout: layout,
            size: size,
            showMediaPicker: showMediaPicker,
            showSegmentation: showSegmentation,
            showLabel: showLabel,
            updateCardFormField: updateCardFormField
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jmFR8.ItemsListBuilder), {
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        actionSubjectIdPostFix: $bffb5ed9c7d7934b$var$actionSubjectIdPostFix,
        renderItemContent: renderCardContent,
        ...cardsAreaContainerProps
    });
};




















var $fdbb9d7215b20ed3$export$63d216eda7dcfec9 = /*#__PURE__*/ function(CONDITIONAL_FIELDS) {
    CONDITIONAL_FIELDS["IS_AVATAR_SHOWN"] = "isAvatarShown";
    CONDITIONAL_FIELDS["IS_PUBLISH_DATE_SHOWN"] = "isPublishDateShown";
    CONDITIONAL_FIELDS["IS_SOCIAL_STATS_SHOWN"] = "isSocialStatsShown";
    CONDITIONAL_FIELDS["IS_ICON_SHOWN"] = "isIconShown";
    CONDITIONAL_FIELDS["IS_LABEL_SHOWN"] = "isLabelShown";
    CONDITIONAL_FIELDS["IS_SEGMENTATION_SHOWN"] = "isSegmentationShown";
    CONDITIONAL_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    return CONDITIONAL_FIELDS;
}({});




var $b7jDA = parcelRequire("b7jDA");












var $32chb = parcelRequire("32chb");




const $6a23bea51b3cdd29$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    publishDateToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.publish-date.label-v2",
        defaultMessage: "Last updated"
    },
    avatarToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.avatar.label-v2",
        defaultMessage: "Content owner"
    },
    labelToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.label.label-v2",
        defaultMessage: "Label"
    },
    descriptionToggleLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.type-field.toggle.ai-description.label-v2",
        defaultMessage: "Description"
    },
    socialStatsToggleLabel: {
        id: "company-hub.cards-extension.card-config-panel.content-section.display-options.social-stats-toggle-label",
        defaultMessage: "Social stats"
    },
    iconToggleLabel: {
        id: "company-hub.cards-extension.card-config-panel.content-section.display-options.icon-toggle-label",
        defaultMessage: "Icon"
    }
});


const { IS_AVATAR_SHOWN: $867558a1cef9f4f9$var$IS_AVATAR_SHOWN, IS_PUBLISH_DATE_SHOWN: $867558a1cef9f4f9$var$IS_PUBLISH_DATE_SHOWN, IS_SOCIAL_STATS_SHOWN: $867558a1cef9f4f9$var$IS_SOCIAL_STATS_SHOWN, IS_ICON_SHOWN: $867558a1cef9f4f9$var$IS_ICON_SHOWN, IS_LABEL_SHOWN: $867558a1cef9f4f9$var$IS_LABEL_SHOWN, IS_DESCRIPTION_SHOWN: $867558a1cef9f4f9$var$IS_DESCRIPTION_SHOWN } = (0, $fdbb9d7215b20ed3$export$63d216eda7dcfec9);
const $867558a1cef9f4f9$export$46763ff84295d762 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(69);
    const { renderVariant: renderVariant, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, isDescriptionShown: isDescriptionShown, layout: layout, size: size, updateMainFormField: updateMainFormField } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isAvatarShown || $[2] !== renderVariant || $[3] !== updateMainFormField) {
        t1 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_AVATAR_SHOWN]: !isAvatarShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "ownerToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isAvatarShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isAvatarShown;
        $[2] = renderVariant;
        $[3] = updateMainFormField;
        $[4] = t1;
    } else t1 = $[4];
    const handleAvatarToggleChange = t1;
    let t2;
    if ($[5] !== createAnalyticsEvent || $[6] !== isPublishDateShown || $[7] !== renderVariant || $[8] !== updateMainFormField) {
        t2 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_PUBLISH_DATE_SHOWN]: !isPublishDateShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "lastUpdateToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isPublishDateShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = isPublishDateShown;
        $[7] = renderVariant;
        $[8] = updateMainFormField;
        $[9] = t2;
    } else t2 = $[9];
    const handlePublishDateToggleChange = t2;
    let t3;
    if ($[10] !== createAnalyticsEvent || $[11] !== isSocialStatsShown || $[12] !== renderVariant || $[13] !== updateMainFormField) {
        t3 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_SOCIAL_STATS_SHOWN]: !isSocialStatsShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "socialStatsToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isSocialStatsShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[10] = createAnalyticsEvent;
        $[11] = isSocialStatsShown;
        $[12] = renderVariant;
        $[13] = updateMainFormField;
        $[14] = t3;
    } else t3 = $[14];
    const handleSocialStatsToggleChange = t3;
    let t4;
    if ($[15] !== createAnalyticsEvent || $[16] !== isIconShown || $[17] !== renderVariant || $[18] !== updateMainFormField) {
        t4 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_ICON_SHOWN]: !isIconShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "iconToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isIconShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[15] = createAnalyticsEvent;
        $[16] = isIconShown;
        $[17] = renderVariant;
        $[18] = updateMainFormField;
        $[19] = t4;
    } else t4 = $[19];
    const handleIconToggleChange = t4;
    let t5;
    if ($[20] !== createAnalyticsEvent || $[21] !== isLabelShown || $[22] !== renderVariant || $[23] !== updateMainFormField) {
        t5 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_LABEL_SHOWN]: !isLabelShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "labelToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isLabelShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[20] = createAnalyticsEvent;
        $[21] = isLabelShown;
        $[22] = renderVariant;
        $[23] = updateMainFormField;
        $[24] = t5;
    } else t5 = $[24];
    const handleLabelToggleChange = t5;
    let t6;
    if ($[25] !== createAnalyticsEvent || $[26] !== isDescriptionShown || $[27] !== renderVariant || $[28] !== updateMainFormField) {
        t6 = ()=>{
            updateMainFormField({
                [$867558a1cef9f4f9$var$IS_DESCRIPTION_SHOWN]: !isDescriptionShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "descriptionToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: !isDescriptionShown,
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[25] = createAnalyticsEvent;
        $[26] = isDescriptionShown;
        $[27] = renderVariant;
        $[28] = updateMainFormField;
        $[29] = t6;
    } else t6 = $[29];
    const handleDescriptionToggleChange = t6;
    let t7;
    if ($[30] !== formatMessage) {
        t7 = formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).avatarToggleLabel);
        $[30] = formatMessage;
        $[31] = t7;
    } else t7 = $[31];
    let t8;
    if ($[32] !== handleAvatarToggleChange || $[33] !== isAvatarShown || $[34] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: t7,
            isChecked: isAvatarShown,
            onChange: handleAvatarToggleChange
        });
        $[32] = handleAvatarToggleChange;
        $[33] = isAvatarShown;
        $[34] = t7;
        $[35] = t8;
    } else t8 = $[35];
    let t9;
    if ($[36] !== formatMessage) {
        t9 = formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).publishDateToggleLabel);
        $[36] = formatMessage;
        $[37] = t9;
    } else t9 = $[37];
    let t10;
    if ($[38] !== handlePublishDateToggleChange || $[39] !== isPublishDateShown || $[40] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: t9,
            isChecked: isPublishDateShown,
            onChange: handlePublishDateToggleChange
        });
        $[38] = handlePublishDateToggleChange;
        $[39] = isPublishDateShown;
        $[40] = t9;
        $[41] = t10;
    } else t10 = $[41];
    let t11;
    if ($[42] !== formatMessage || $[43] !== handleIconToggleChange || $[44] !== handleSocialStatsToggleChange || $[45] !== isIconShown || $[46] !== isSocialStatsShown || $[47] !== size) {
        t11 = size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).socialStatsToggleLabel),
            isChecked: isSocialStatsShown,
            onChange: handleSocialStatsToggleChange
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).iconToggleLabel),
            isChecked: isIconShown,
            onChange: handleIconToggleChange
        }));
        $[42] = formatMessage;
        $[43] = handleIconToggleChange;
        $[44] = handleSocialStatsToggleChange;
        $[45] = isIconShown;
        $[46] = isSocialStatsShown;
        $[47] = size;
        $[48] = t11;
    } else t11 = $[48];
    let t12;
    if ($[49] !== formatMessage || $[50] !== handleLabelToggleChange || $[51] !== isLabelShown || $[52] !== layout || $[53] !== renderVariant || $[54] !== size) {
        t12 = layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).labelToggleLabel),
            isChecked: isLabelShown,
            onChange: handleLabelToggleChange
        });
        $[49] = formatMessage;
        $[50] = handleLabelToggleChange;
        $[51] = isLabelShown;
        $[52] = layout;
        $[53] = renderVariant;
        $[54] = size;
        $[55] = t12;
    } else t12 = $[55];
    let t13;
    if ($[56] !== formatMessage || $[57] !== handleDescriptionToggleChange || $[58] !== isAdminHubAIEnabled || $[59] !== isDescriptionShown || $[60] !== renderVariant || $[61] !== size) {
        t13 = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).descriptionToggleLabel),
            isChecked: isDescriptionShown,
            onChange: handleDescriptionToggleChange
        }), isAdminHubAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null));
        $[56] = formatMessage;
        $[57] = handleDescriptionToggleChange;
        $[58] = isAdminHubAIEnabled;
        $[59] = isDescriptionShown;
        $[60] = renderVariant;
        $[61] = size;
        $[62] = t13;
    } else t13 = $[62];
    let t14;
    if ($[63] !== t10 || $[64] !== t11 || $[65] !== t12 || $[66] !== t13 || $[67] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.075"
        }, t8, t10, t11, t12, t13);
        $[63] = t10;
        $[64] = t11;
        $[65] = t12;
        $[66] = t13;
        $[67] = t8;
        $[68] = t14;
    } else t14 = $[68];
    return t14;
} : ({ renderVariant: renderVariant, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, isDescriptionShown: isDescriptionShown, layout: layout, size: size, updateMainFormField: updateMainFormField })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const handleAvatarToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_AVATAR_SHOWN]: !isAvatarShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'ownerToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isAvatarShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isAvatarShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handlePublishDateToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_PUBLISH_DATE_SHOWN]: !isPublishDateShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'lastUpdateToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isPublishDateShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isPublishDateShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleSocialStatsToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_SOCIAL_STATS_SHOWN]: !isSocialStatsShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'socialStatsToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isSocialStatsShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isSocialStatsShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleIconToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_ICON_SHOWN]: !isIconShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'iconToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isIconShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isIconShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleLabelToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_LABEL_SHOWN]: !isLabelShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'labelToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isLabelShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isLabelShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    const handleDescriptionToggleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            [$867558a1cef9f4f9$var$IS_DESCRIPTION_SHOWN]: !isDescriptionShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'descriptionToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: !isDescriptionShown,
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        isDescriptionShown,
        renderVariant,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).avatarToggleLabel),
        isChecked: isAvatarShown,
        onChange: handleAvatarToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).publishDateToggleLabel),
        isChecked: isPublishDateShown,
        onChange: handlePublishDateToggleChange
    }), size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).socialStatsToggleLabel),
        isChecked: isSocialStatsShown,
        onChange: handleSocialStatsToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).iconToggleLabel),
        isChecked: isIconShown,
        onChange: handleIconToggleChange
    })), layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && renderVariant === (0, $hjUDQ.RenderVariant).MANUAL && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).labelToggleLabel),
        isChecked: isLabelShown,
        onChange: handleLabelToggleChange
    }), renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $6a23bea51b3cdd29$export$defe85febe8b728c).descriptionToggleLabel),
        isChecked: isDescriptionShown,
        onChange: handleDescriptionToggleChange
    }), isAdminHubAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32chb.CardsAIDisclaimer), null)));
};












var $aRGok = parcelRequire("aRGok");























var $cFvoT = parcelRequire("cFvoT");








var $iJCWb = parcelRequire("iJCWb");













const $3552b35556365771$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    cardCountLabel: {
        id: "company-hub.cards-extension.link-cards-content.card-components.card-count-label",
        defaultMessage: "Number of cards"
    },
    showImagesToggleLabel: {
        id: "company-hub.cards-extension.link-cards-content.card-components.show-images-toggle-label.non-final",
        defaultMessage: "Show images"
    },
    viewCurrentFilters: {
        id: "company-hub.cards-extension.link-cards-content.card-components.view-current-filters",
        defaultMessage: "View current filters"
    }
});


const $7c9c2434e40692e0$export$b3a9c0e92d1dd6d5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { viewFilters: viewFilters, extensionParameters: extensionParameters, extensionActions: extensionActions } = t0;
    const { cardCount: cardCount, isImageShown: isImageShown } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const { isHelpHub: isHelpHub } = (0, $cfM7x.useProductDependencies)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isImageCurrentlyShown = isImageShown !== false;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isImageCurrentlyShown || $[2] !== updateMainFormField) {
        t1 = ()=>{
            const nextIsImageShown = !isImageCurrentlyShown;
            updateMainFormField({
                isImageShown: nextIsImageShown
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "changed",
                    actionSubject: "toggle",
                    actionSubjectId: "imageToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        value: nextIsImageShown,
                        renderVariant: (0, $hjUDQ.RenderVariant).DYNAMIC
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isImageCurrentlyShown;
        $[2] = updateMainFormField;
        $[3] = t1;
    } else t1 = $[3];
    const handleImageToggleChange = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3552b35556365771$export$defe85febe8b728c).viewCurrentFilters));
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== viewFilters) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            appearance: "primary",
            onClick: viewFilters
        }, t2);
        $[5] = viewFilters;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== updateMainFormField) {
        t4 = (value)=>updateMainFormField({
                cardCount: value
            });
        $[7] = updateMainFormField;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== cardCount || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
            analyticSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            label: (0, $3552b35556365771$export$defe85febe8b728c).cardCountLabel,
            maxValue: 20,
            minValue: 1,
            prefix: "card",
            updateRangeValue: t4,
            value: cardCount
        });
        $[9] = cardCount;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== formatMessage || $[13] !== handleImageToggleChange || $[14] !== isHelpHub || $[15] !== isImageCurrentlyShown) {
        t6 = isHelpHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: formatMessage((0, $3552b35556365771$export$defe85febe8b728c).showImagesToggleLabel),
            isChecked: isImageCurrentlyShown,
            onChange: handleImageToggleChange
        });
        $[12] = formatMessage;
        $[13] = handleImageToggleChange;
        $[14] = isHelpHub;
        $[15] = isImageCurrentlyShown;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t5, t6);
        $[17] = t3;
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ viewFilters: viewFilters, extensionParameters: extensionParameters, extensionActions: extensionActions })=>{
    const { cardCount: cardCount, isImageShown: isImageShown } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const { isHelpHub: isHelpHub } = (0, $cfM7x.useProductDependencies)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Help Hub only: authors can hide the (otherwise force-shown) header image
    // on dynamic cards. Absent/true means shown, preserving existing behaviour.
    const isImageCurrentlyShown = isImageShown !== false;
    const handleImageToggleChange = (0, $cozmU.useCallback)(()=>{
        const nextIsImageShown = !isImageCurrentlyShown;
        updateMainFormField({
            isImageShown: nextIsImageShown
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'changed',
                actionSubject: 'toggle',
                actionSubjectId: 'imageToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    value: nextIsImageShown,
                    // This toggle only exists in the dynamic variant; mirror the
                    // other display-option toggles which segment by renderVariant.
                    renderVariant: (0, $hjUDQ.RenderVariant).DYNAMIC
                }
            }
        }).fire();
    }, [
        isImageCurrentlyShown,
        updateMainFormField,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        appearance: "primary",
        onClick: viewFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $3552b35556365771$export$defe85febe8b728c).viewCurrentFilters))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        analyticSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        label: (0, $3552b35556365771$export$defe85febe8b728c).cardCountLabel,
        maxValue: 20,
        minValue: 1,
        prefix: "card",
        updateRangeValue: (value)=>updateMainFormField({
                cardCount: value
            }),
        value: cardCount
    }), isHelpHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $3552b35556365771$export$defe85febe8b728c).showImagesToggleLabel),
        isChecked: isImageCurrentlyShown,
        onChange: handleImageToggleChange
    }));
};












var $huGTe = parcelRequire("huGTe");











var $w6R6I = parcelRequire("w6R6I");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");







var $4XdCR = parcelRequire("4XdCR");


var $37AYo = parcelRequire("37AYo");




const $be3cfc9488c087cd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    header: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header",
        defaultMessage: "Build dynamic cards"
    },
    headerSubtext: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext",
        defaultMessage: "Create a customized set of automatically populated cards that display the latest information. Use filters to select card content by label, space, owner, and more."
    },
    clearAllFiltersButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button",
        defaultMessage: "Clear all filters"
    },
    cancelButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button",
        defaultMessage: "Cancel"
    },
    confirmButton: {
        id: "company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button",
        defaultMessage: "Confirm"
    }
});












var $iDrrr = parcelRequire("iDrrr");





var $3yqh5 = parcelRequire("3yqh5");






var $ik71g = parcelRequire("ik71g");




const $860b3016b188708e$export$a060942263c7e065 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { filters: filters, setFilters: setFilters } = t0;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const getSpaceIdsFromSpaceKeys = (0, $3yqh5.useGetSpaceIdsFromSpaceKeys)();
    const t1 = userId ?? null;
    const t2 = displayName ?? null;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            id: t1,
            name: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const userDetails = t3;
    const mapUserIdToProfileUrl = $860b3016b188708e$var$_temp;
    let t4;
    if ($[3] !== cloudId || $[4] !== filters || $[5] !== isAdminHubAIEnabled || $[6] !== orgId || $[7] !== userDetails) {
        t4 = {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: (0, $37AYo.ProductKeys).Confluence,
            queryParams: filters,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            experience: (0, $iDrrr.fg)("rovo_search_experience_prop") ? (0, $dBD3L.DYNAMIC_CARDS_SEARCH_EXPERIENCE) : undefined
        };
        $[3] = cloudId;
        $[4] = filters;
        $[5] = isAdminHubAIEnabled;
        $[6] = orgId;
        $[7] = userDetails;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== getSpaceIdsFromSpaceKeys || $[10] !== setFilters) {
        t5 = {
            updateQueryParameters: setFilters,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        };
        $[9] = getSpaceIdsFromSpaceKeys;
        $[10] = setFilters;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t4 || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "search-hub-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ik71g.SearchPage), {
            shell: t4,
            callbacks: t5,
            mapUserIdToProfileUrl: mapUserIdToProfileUrl
        }));
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : ({ filters: filters, setFilters: setFilters })=>{
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $cfM7x.useProductDependencies)();
    const getSpaceIdsFromSpaceKeys = (0, $3yqh5.useGetSpaceIdsFromSpaceKeys)();
    const userDetails = (0, $cozmU.useMemo)(()=>{
        return {
            id: userId ?? null,
            name: displayName ?? null
        };
    }, [
        userId,
        displayName
    ]);
    const mapUserIdToProfileUrl = (0, $cozmU.useCallback)((userId_0)=>`/wiki/people/${userId_0}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "search-hub-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ik71g.SearchPage), {
        shell: {
            cloudId: cloudId,
            orgId: orgId,
            user: userDetails,
            primaryProduct: (0, $37AYo.ProductKeys).Confluence,
            queryParams: filters,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            // Undefined when gated off so the query falls back to its `search-page` default
            experience: (0, $iDrrr.fg)('rovo_search_experience_prop') ? (0, $dBD3L.DYNAMIC_CARDS_SEARCH_EXPERIENCE) : undefined
        },
        callbacks: {
            updateQueryParameters: setFilters,
            getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
        },
        mapUserIdToProfileUrl: mapUserIdToProfileUrl
    }));
};
function $860b3016b188708e$var$_temp(userId_0) {
    return `/wiki/people/${userId_0}`;
}


const $6eac9984711a2618$var$styles = {
    header: "_2mHwu85zaO _0aFT5vbt8w",
    footer: "_37wbyuI7V3 _39xV02N91d"
};
const $6eac9984711a2618$var$productFilter = {
    product: (0, $37AYo.ProductKeys).Confluence
};
const $6eac9984711a2618$export$f05828d0709ad5e0 = (filters = {})=>{
    const { product: product, sortField: sortField, sortOrder: sortOrder, ...rest } = filters;
    return !(0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(rest);
};
const $6eac9984711a2618$var$isSortDefault = ({ sortField: sortField, sortOrder: sortOrder })=>{
    const field = sortField || (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE;
    const order = sortOrder || (0, $4XdCR.SORT_ORDER).DESC;
    return field === (0, $4XdCR.SORT_FIELD_KEY).LAST_MODIFIED_DATE && order === (0, $4XdCR.SORT_ORDER).DESC;
};
const $6eac9984711a2618$export$d4af045235e509cb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { filters: filters, setFilters: setFilters, closeModal: closeModal } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== filters) {
        t1 = {
            ...$6eac9984711a2618$var$productFilter,
            ...filters
        };
        $[0] = filters;
        $[1] = t1;
    } else t1 = $[1];
    const [stagedFilters, setStagedFilters] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[2] !== createAnalyticsEvent) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "dynamicContentModalDialog"
                }
            }).fire();
        };
        t3 = [
            createAnalyticsEvent
        ];
        $[2] = createAnalyticsEvent;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== stagedFilters) {
        t4 = !$6eac9984711a2618$export$f05828d0709ad5e0(stagedFilters) && $6eac9984711a2618$var$isSortDefault({
            sortField: stagedFilters.sortField,
            sortOrder: stagedFilters.sortOrder
        });
        $[5] = stagedFilters;
        $[6] = t4;
    } else t4 = $[6];
    const hasNoFilters = t4;
    let t5;
    if ($[7] !== stagedFilters) {
        t5 = $6eac9984711a2618$export$f05828d0709ad5e0(stagedFilters);
        $[7] = stagedFilters;
        $[8] = t5;
    } else t5 = $[8];
    const hasNoSearchFilters = !t5;
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (newFilters)=>{
            setStagedFilters({
                ...newFilters
            });
        };
        $[9] = t6;
    } else t6 = $[9];
    const handleSetStagedFilters = t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setStagedFilters({
                ...$6eac9984711a2618$var$productFilter
            });
        };
        $[10] = t7;
    } else t7 = $[10];
    const handleClearAllFilters = t7;
    let t8;
    if ($[11] !== closeModal) {
        t8 = ()=>{
            closeModal();
        };
        $[11] = closeModal;
        $[12] = t8;
    } else t8 = $[12];
    const handleCancel = t8;
    let t9;
    if ($[13] !== closeModal || $[14] !== createAnalyticsEvent || $[15] !== setFilters || $[16] !== stagedFilters) {
        t9 = ()=>{
            setFilters(stagedFilters);
            closeModal();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "confirmButton",
                    source: "dynamicContentModalDialog",
                    attributes: {
                        filters: Object.keys(stagedFilters)
                    }
                }
            }).fire();
        };
        $[13] = closeModal;
        $[14] = createAnalyticsEvent;
        $[15] = setFilters;
        $[16] = stagedFilters;
        $[17] = t9;
    } else t9 = $[17];
    const handleConfirm = t9;
    let t10;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $w6R6I.cx)($6eac9984711a2618$var$styles.header);
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).header));
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: t10
        }, t11, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).headerSubtext)))));
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== stagedFilters) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $860b3016b188708e$export$a060942263c7e065), {
            filters: stagedFilters,
            setFilters: handleSetStagedFilters
        }));
        $[21] = stagedFilters;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $w6R6I.cx)($6eac9984711a2618$var$styles.footer);
        $[23] = t14;
    } else t14 = $[23];
    let t15;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).clearAllFiltersButton);
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== hasNoFilters) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleClearAllFilters,
            isDisabled: hasNoFilters
        }, t15));
        $[25] = hasNoFilters;
        $[26] = t16;
    } else t16 = $[26];
    let t17;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).cancelButton);
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== handleCancel) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, t17);
        $[28] = handleCancel;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).confirmButton);
        $[30] = t19;
    } else t19 = $[30];
    let t20;
    if ($[31] !== handleConfirm || $[32] !== hasNoSearchFilters) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleConfirm,
            isDisabled: hasNoSearchFilters
        }, t19);
        $[31] = handleConfirm;
        $[32] = hasNoSearchFilters;
        $[33] = t20;
    } else t20 = $[33];
    let t21;
    if ($[34] !== t18 || $[35] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "end",
            gap: "space.100"
        }, t18, t20);
        $[34] = t18;
        $[35] = t20;
        $[36] = t21;
    } else t21 = $[36];
    let t22;
    if ($[37] !== t16 || $[38] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            xcss: t14
        }, t16, t21));
        $[37] = t16;
        $[38] = t21;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== closeModal || $[41] !== t13 || $[42] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
            onClose: closeModal,
            width: "x-large"
        }, t12, t13, t22);
        $[40] = closeModal;
        $[41] = t13;
        $[42] = t22;
        $[43] = t23;
    } else t23 = $[43];
    return t23;
} : ({ filters: filters, setFilters: setFilters, closeModal: closeModal })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [stagedFilters, setStagedFilters] = (0, $cozmU.useState)({
        ...$6eac9984711a2618$var$productFilter,
        ...filters
    });
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'dynamicContentModalDialog'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const hasNoFilters = (0, $cozmU.useMemo)(()=>{
        return !$6eac9984711a2618$export$f05828d0709ad5e0(stagedFilters) && $6eac9984711a2618$var$isSortDefault({
            sortField: stagedFilters.sortField,
            sortOrder: stagedFilters.sortOrder
        });
    }, [
        stagedFilters
    ]);
    const hasNoSearchFilters = (0, $cozmU.useMemo)(()=>{
        return !$6eac9984711a2618$export$f05828d0709ad5e0(stagedFilters);
    }, [
        stagedFilters
    ]);
    const handleSetStagedFilters = (0, $cozmU.useCallback)((newFilters)=>{
        setStagedFilters({
            ...newFilters
        });
    }, [
        setStagedFilters
    ]);
    const handleClearAllFilters = (0, $cozmU.useCallback)(()=>{
        setStagedFilters({
            ...$6eac9984711a2618$var$productFilter
        });
    }, [
        setStagedFilters
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        closeModal();
    }, [
        closeModal
    ]);
    const handleConfirm = (0, $cozmU.useCallback)(()=>{
        setFilters(stagedFilters);
        closeModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirmButton',
                source: 'dynamicContentModalDialog',
                attributes: {
                    filters: Object.keys(stagedFilters)
                }
            }
        }).fire();
    }, [
        stagedFilters,
        setFilters,
        closeModal,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeModal,
        width: "x-large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($6eac9984711a2618$var$styles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).headerSubtext))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $860b3016b188708e$export$a060942263c7e065), {
        filters: stagedFilters,
        setFilters: handleSetStagedFilters
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($6eac9984711a2618$var$styles.footer)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleClearAllFilters,
        isDisabled: hasNoFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).clearAllFiltersButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleConfirm,
        isDisabled: hasNoSearchFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $be3cfc9488c087cd$export$defe85febe8b728c).confirmButton))))));
};


















var $I7hWB = parcelRequire("I7hWB");





var $cJ0FD = parcelRequire("cJ0FD");





var $8ngiY = parcelRequire("8ngiY");




const $13d1cb888a55d060$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noDynamicCards: {
        id: "company-hub.cards-extension.link-cards-content.card-components.error-states.no-dynamic-cards.header",
        defaultMessage: "No dynamic cards yet"
    },
    buildDynamicCards: {
        id: "company-hub.cards-extension.link-cards-content.card-components.build-dynamic-cards",
        defaultMessage: "Build dynamic cards"
    }
});


const $4082c3f54372a133$export$2a511c47e1cb5779 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { startCreateFilters: startCreateFilters } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8ngiY))),
            alt: "",
            testId: "no-dynamic-cards-image"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $13d1cb888a55d060$export$defe85febe8b728c).noDynamicCards));
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
            label: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $13d1cb888a55d060$export$defe85febe8b728c).buildDynamicCards));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== startCreateFilters) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "space.200",
            testId: "empty-state-container"
        }, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            appearance: "primary",
            onClick: startCreateFilters
        }, t3));
        $[3] = startCreateFilters;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ({ startCreateFilters: startCreateFilters })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "space.200",
        testId: "empty-state-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ngiY))),
        alt: "",
        testId: "no-dynamic-cards-image"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $13d1cb888a55d060$export$defe85febe8b728c).noDynamicCards)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        appearance: "primary",
        onClick: startCreateFilters
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $13d1cb888a55d060$export$defe85febe8b728c).buildDynamicCards))));
};


const $fb64fc0812b200a4$var$styles = {
    disabledContentWrapper: "_0wOv4Qsyl5"
};
const $fb64fc0812b200a4$export$1a61cdf7ea7768fd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { extensionParameters: extensionParameters, extensionActions: extensionActions, isDisabled: isDisabled } = t0;
    const { filters: filters } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const hasFilters = !!filters;
    const [isDynamicContentModalOpen, setIsDynamicContentModalOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsDynamicContentModalOpen(false);
        $[0] = t1;
    } else t1 = $[0];
    const handleCloseModal = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsDynamicContentModalOpen(true);
        $[1] = t2;
    } else t2 = $[1];
    const handleOpenModal = t2;
    let t3;
    if ($[2] !== updateMainFormField) {
        t3 = (newFilters)=>{
            updateMainFormField({
                filters: newFilters
            });
        };
        $[2] = updateMainFormField;
        $[3] = t3;
    } else t3 = $[3];
    const handleSetFilters = t3;
    const t4 = isDisabled && $fb64fc0812b200a4$var$styles.disabledContentWrapper;
    let t5;
    if ($[4] !== extensionActions || $[5] !== extensionParameters || $[6] !== hasFilters) {
        t5 = hasFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9c2434e40692e0$export$b3a9c0e92d1dd6d5), {
            viewFilters: handleOpenModal,
            extensionParameters: extensionParameters,
            extensionActions: extensionActions
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4082c3f54372a133$export$2a511c47e1cb5779), {
            startCreateFilters: handleOpenModal
        });
        $[4] = extensionActions;
        $[5] = extensionParameters;
        $[6] = hasFilters;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            gap: "space.300",
            xcss: t4
        }, t5);
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== filters || $[12] !== handleSetFilters || $[13] !== isDynamicContentModalOpen) {
        t7 = isDynamicContentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eac9984711a2618$export$d4af045235e509cb), {
            filters: filters,
            closeModal: handleCloseModal,
            setFilters: handleSetFilters
        });
        $[11] = filters;
        $[12] = handleSetFilters;
        $[13] = isDynamicContentModalOpen;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, t7);
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== t6 || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t8);
        $[17] = t6;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ extensionParameters: extensionParameters, extensionActions: extensionActions, isDisabled: isDisabled })=>{
    const { filters: filters } = extensionParameters;
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const hasFilters = !!filters;
    const [isDynamicContentModalOpen, setIsDynamicContentModalOpen] = (0, $cozmU.useState)(false);
    const handleCloseModal = (0, $cozmU.useCallback)(()=>setIsDynamicContentModalOpen(false), []);
    const handleOpenModal = (0, $cozmU.useCallback)(()=>setIsDynamicContentModalOpen(true), []);
    const handleSetFilters = (newFilters)=>{
        updateMainFormField({
            filters: newFilters
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.300",
        xcss: isDisabled && $fb64fc0812b200a4$var$styles.disabledContentWrapper
    }, hasFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7c9c2434e40692e0$export$b3a9c0e92d1dd6d5), {
        viewFilters: handleOpenModal,
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4082c3f54372a133$export$2a511c47e1cb5779), {
        startCreateFilters: handleOpenModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isDynamicContentModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6eac9984711a2618$export$d4af045235e509cb), {
        filters: filters,
        closeModal: handleCloseModal,
        setFilters: handleSetFilters
    })));
};





























var $gWxR3 = parcelRequire("gWxR3");




const $c4ef15c460ac5a25$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    manualRenderVariantDropdownOptionLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.manual",
        defaultMessage: "Manual"
    },
    dynamicRenderVariantDropdownOptionLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.option.label.dynamic",
        defaultMessage: "Dynamic"
    },
    dropdownLabel: {
        id: "company-hub.company-hub-common.config-panel.render-variant.dropdown.label",
        defaultMessage: "Card type"
    }
});


const $be368b5d8f7d4348$var$manualOption = {
    label: (0, $c4ef15c460ac5a25$export$defe85febe8b728c).manualRenderVariantDropdownOptionLabel,
    value: (0, $hjUDQ.RenderVariant).MANUAL
};
const $be368b5d8f7d4348$var$dynamicOption = {
    label: (0, $c4ef15c460ac5a25$export$defe85febe8b728c).dynamicRenderVariantDropdownOptionLabel,
    value: (0, $hjUDQ.RenderVariant).DYNAMIC
};
const $be368b5d8f7d4348$var$renderVariantOptions = [
    $be368b5d8f7d4348$var$manualOption,
    $be368b5d8f7d4348$var$dynamicOption
];
const $be368b5d8f7d4348$export$68edf4601962f4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { renderVariant: renderVariant, onUpdate: onUpdate, source: source } = t0;
    let t1;
    if ($[0] !== onUpdate) {
        t1 = (selectedOption)=>onUpdate(selectedOption.value);
        $[0] = onUpdate;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== renderVariant) {
        t2 = $be368b5d8f7d4348$var$renderVariantOptions.find((option)=>option.value === renderVariant) || $be368b5d8f7d4348$var$manualOption;
        $[2] = renderVariant;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== renderVariant || $[5] !== source || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
            fieldType: "render-variant",
            label: (0, $c4ef15c460ac5a25$export$defe85febe8b728c).dropdownLabel,
            onSelect: t1,
            options: $be368b5d8f7d4348$var$renderVariantOptions,
            selectedOption: t2,
            renderVariant: renderVariant,
            source: source,
            showUpdatedStyles: true
        });
        $[4] = renderVariant;
        $[5] = source;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ renderVariant: renderVariant, onUpdate: onUpdate, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
        fieldType: "render-variant",
        label: (0, $c4ef15c460ac5a25$export$defe85febe8b728c).dropdownLabel,
        onSelect: (selectedOption)=>onUpdate(selectedOption.value),
        options: $be368b5d8f7d4348$var$renderVariantOptions,
        selectedOption: $be368b5d8f7d4348$var$renderVariantOptions.find((option)=>option.value === renderVariant) || $be368b5d8f7d4348$var$manualOption,
        renderVariant: renderVariant,
        source: source,
        showUpdatedStyles: true
    });






















const $181ce8f27a7a56db$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    segmentationTargetLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-text.v2.label",
        defaultMessage: "Target audience"
    },
    segmentationNoneDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label",
        defaultMessage: "None"
    },
    segmentationAllDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label",
        defaultMessage: "All cards"
    },
    segmentationEachDropDownItemLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label",
        defaultMessage: "Each card"
    },
    infoIconLabelText: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2",
        defaultMessage: "Choose which Confluence user groups will see your cards"
    }
});


const $4bfb77908ad25462$var$defaultOption = {
    label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationNoneDropDownItemLabel,
    value: undefined
};
const $4bfb77908ad25462$var$manualSegmentationTargetOptions = [
    $4bfb77908ad25462$var$defaultOption,
    {
        label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationAllDropDownItemLabel,
        value: (0, $hjUDQ.SegmentationTargets).ALL
    },
    {
        label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationEachDropDownItemLabel,
        value: (0, $hjUDQ.SegmentationTargets).EACH
    }
];
const $4bfb77908ad25462$var$dynamicSegmentationTargetOptions = [
    $4bfb77908ad25462$var$defaultOption,
    {
        label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationAllDropDownItemLabel,
        value: (0, $hjUDQ.SegmentationTargets).ALL
    }
];
const $4bfb77908ad25462$export$83d97d5e49e73ce8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { targetParameter: targetParameter, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards, renderVariant: renderVariant, audienceSegmentationGroupIds: audienceSegmentationGroupIds, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const displayedSegmentationTargetOptions = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL ? $4bfb77908ad25462$var$manualSegmentationTargetOptions : $4bfb77908ad25462$var$dynamicSegmentationTargetOptions;
    let t1;
    if ($[0] !== displayedSegmentationTargetOptions || $[1] !== targetParameter) {
        t1 = displayedSegmentationTargetOptions.find((t2)=>{
            const { value: value } = t2;
            return value === targetParameter;
        }) || $4bfb77908ad25462$var$defaultOption;
        $[0] = displayedSegmentationTargetOptions;
        $[1] = targetParameter;
        $[2] = t1;
    } else t1 = $[2];
    const selectedOption = t1;
    let t2;
    if ($[3] !== audienceSegmentationGroupIds || $[4] !== targetParameter || $[5] !== updateCardFormFieldForAllCards || $[6] !== updateMainFormField) {
        t2 = (selectedLabel)=>{
            const fieldsToUpdate = {
                segmentationTarget: selectedLabel.value,
                isSegmentationShown: selectedLabel.value !== undefined
            };
            if (selectedLabel.value === undefined) {
                fieldsToUpdate.audienceSegmentationGroupIds = undefined;
                updateCardFormFieldForAllCards({
                    [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
                });
            } else {
                if (selectedLabel.value === (0, $hjUDQ.SegmentationTargets).ALL && targetParameter === (0, $hjUDQ.SegmentationTargets).EACH) updateCardFormFieldForAllCards({
                    [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
                });
                else if (selectedLabel.value === (0, $hjUDQ.SegmentationTargets).EACH && targetParameter === (0, $hjUDQ.SegmentationTargets).ALL) {
                    fieldsToUpdate.audienceSegmentationGroupIds = undefined;
                    updateCardFormFieldForAllCards({
                        [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: audienceSegmentationGroupIds
                    });
                }
            }
            updateMainFormField(fieldsToUpdate);
        };
        $[3] = audienceSegmentationGroupIds;
        $[4] = targetParameter;
        $[5] = updateCardFormFieldForAllCards;
        $[6] = updateMainFormField;
        $[7] = t2;
    } else t2 = $[7];
    const handleSelect = t2;
    let t3;
    if ($[8] !== formatMessage) {
        t3 = formatMessage((0, $181ce8f27a7a56db$export$defe85febe8b728c).infoIconLabelText);
        $[8] = formatMessage;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== displayedSegmentationTargetOptions || $[11] !== handleSelect || $[12] !== renderVariant || $[13] !== selectedOption || $[14] !== source || $[15] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
            fieldType: "segmentationTarget",
            label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationTargetLabel,
            onSelect: handleSelect,
            options: displayedSegmentationTargetOptions,
            selectedOption: selectedOption,
            renderVariant: renderVariant,
            infoTooltip: t3,
            showUpdatedStyles: true,
            source: source
        });
        $[10] = displayedSegmentationTargetOptions;
        $[11] = handleSelect;
        $[12] = renderVariant;
        $[13] = selectedOption;
        $[14] = source;
        $[15] = t3;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ targetParameter: targetParameter, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards, renderVariant: renderVariant, audienceSegmentationGroupIds: audienceSegmentationGroupIds, source: source })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const displayedSegmentationTargetOptions = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL ? $4bfb77908ad25462$var$manualSegmentationTargetOptions : $4bfb77908ad25462$var$dynamicSegmentationTargetOptions;
    const selectedOption = displayedSegmentationTargetOptions.find(({ value: value })=>value === targetParameter) || $4bfb77908ad25462$var$defaultOption;
    const handleSelect = (0, $cozmU.useCallback)((selectedLabel)=>{
        const fieldsToUpdate = {
            segmentationTarget: selectedLabel.value,
            isSegmentationShown: selectedLabel.value !== undefined
        };
        if (selectedLabel.value === undefined) {
            //clear group preferences when set to none
            fieldsToUpdate.audienceSegmentationGroupIds = undefined;
            updateCardFormFieldForAllCards({
                [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
            });
        } else if (selectedLabel.value === (0, $hjUDQ.SegmentationTargets).ALL && targetParameter === (0, $hjUDQ.SegmentationTargets).EACH) //clear each group preferences when set to all from each
        updateCardFormFieldForAllCards({
            [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
        });
        else if (selectedLabel.value === (0, $hjUDQ.SegmentationTargets).EACH && targetParameter === (0, $hjUDQ.SegmentationTargets).ALL) {
            //transfer all group preferences to each when set to each from all
            fieldsToUpdate.audienceSegmentationGroupIds = undefined;
            updateCardFormFieldForAllCards({
                [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: audienceSegmentationGroupIds
            });
        }
        updateMainFormField(fieldsToUpdate);
    }, [
        updateMainFormField,
        updateCardFormFieldForAllCards,
        targetParameter,
        audienceSegmentationGroupIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
        fieldType: "segmentationTarget",
        label: (0, $181ce8f27a7a56db$export$defe85febe8b728c).segmentationTargetLabel,
        onSelect: handleSelect,
        options: displayedSegmentationTargetOptions,
        selectedOption: selectedOption,
        renderVariant: renderVariant,
        infoTooltip: formatMessage((0, $181ce8f27a7a56db$export$defe85febe8b728c).infoIconLabelText),
        showUpdatedStyles: true,
        source: source
    });
};






const $f033ac2e9f99cfed$var$styles = {
    wrapper: "_3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1wydGW5zaO",
    wrapperWithoutBorder: "_1wydGW5zaO",
    marginBottom: "_1DCdHi1Y8M"
};
const $f033ac2e9f99cfed$export$fa828d8497c36e1b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant, extensionActions: extensionActions, updateRenderVariant: updateRenderVariant, cards: cards, source: source } = t0;
    const { updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = extensionActions;
    const { enableTargeting: enableTargeting, enableUnifiedSearchFeatures: enableUnifiedSearchFeatures, enableSmartCardsFields: enableSmartCardsFields, isCompanyHub: isCompanyHub } = (0, $cfM7x.useProductDependencies)();
    const isTargetingEnabled = isCompanyHub && enableTargeting;
    const shouldShowSegmentationTargetGroupsField = segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL && isTargetingEnabled;
    let t1;
    if ($[0] !== updateMainFormField) {
        t1 = (selectedGroups)=>{
            updateMainFormField({
                audienceSegmentationGroupIds: selectedGroups
            });
        };
        $[0] = updateMainFormField;
        $[1] = t1;
    } else t1 = $[1];
    const handleGroupSelection = t1;
    const t2 = enableSmartCardsFields ? $f033ac2e9f99cfed$var$styles.wrapper : $f033ac2e9f99cfed$var$styles.wrapperWithoutBorder;
    let t3;
    if ($[2] !== enableUnifiedSearchFeatures || $[3] !== renderVariant || $[4] !== source || $[5] !== updateRenderVariant) {
        t3 = enableUnifiedSearchFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $be368b5d8f7d4348$export$68edf4601962f4ab), {
            renderVariant: renderVariant,
            onUpdate: updateRenderVariant,
            source: source
        });
        $[2] = enableUnifiedSearchFeatures;
        $[3] = renderVariant;
        $[4] = source;
        $[5] = updateRenderVariant;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== audienceSegmentationGroupIds || $[8] !== isTargetingEnabled || $[9] !== renderVariant || $[10] !== segmentationTarget || $[11] !== source || $[12] !== updateCardFormFieldForAllCards || $[13] !== updateMainFormField) {
        t4 = isTargetingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f033ac2e9f99cfed$var$styles.marginBottom
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bfb77908ad25462$export$83d97d5e49e73ce8), {
            audienceSegmentationGroupIds: audienceSegmentationGroupIds,
            updateMainFormField: updateMainFormField,
            targetParameter: segmentationTarget,
            updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
            renderVariant: renderVariant,
            source: source
        }));
        $[7] = audienceSegmentationGroupIds;
        $[8] = isTargetingEnabled;
        $[9] = renderVariant;
        $[10] = segmentationTarget;
        $[11] = source;
        $[12] = updateCardFormFieldForAllCards;
        $[13] = updateMainFormField;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== audienceSegmentationGroupIds || $[16] !== cards || $[17] !== handleGroupSelection || $[18] !== segmentationTarget || $[19] !== shouldShowSegmentationTargetGroupsField || $[20] !== source) {
        t5 = shouldShowSegmentationTargetGroupsField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2d6c26cfaa807db$export$2261f4215d6c3d25), {
            targetGroupsIds: segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL ? audienceSegmentationGroupIds : cards[0]?.audienceSegmentationGroupIds,
            onGroupSelected: handleGroupSelection,
            showUpdatedStyles: true,
            source: source
        });
        $[15] = audienceSegmentationGroupIds;
        $[16] = cards;
        $[17] = handleGroupSelection;
        $[18] = segmentationTarget;
        $[19] = shouldShowSegmentationTargetGroupsField;
        $[20] = source;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: t2,
            space: "space.200",
            testId: "cards-config-content-section-main"
        }, t3, t4, t5);
        $[22] = t2;
        $[23] = t3;
        $[24] = t4;
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
} : ({ segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, renderVariant: renderVariant, extensionActions: extensionActions, updateRenderVariant: updateRenderVariant, cards: cards, source: source })=>{
    const { updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = extensionActions;
    const { enableTargeting: enableTargeting, enableUnifiedSearchFeatures: enableUnifiedSearchFeatures, enableSmartCardsFields: enableSmartCardsFields, isCompanyHub: isCompanyHub } = (0, $cfM7x.useProductDependencies)(); // isCompanyHub is false and enableTargeting is true for Non company hub such as confluence page
    const isTargetingEnabled = isCompanyHub && enableTargeting;
    const shouldShowSegmentationTargetGroupsField = segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL && isTargetingEnabled;
    const handleGroupSelection = (selectedGroups)=>{
        updateMainFormField({
            audienceSegmentationGroupIds: selectedGroups
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: enableSmartCardsFields ? $f033ac2e9f99cfed$var$styles.wrapper : $f033ac2e9f99cfed$var$styles.wrapperWithoutBorder,
        space: "space.200",
        testId: "cards-config-content-section-main"
    }, enableUnifiedSearchFeatures && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $be368b5d8f7d4348$export$68edf4601962f4ab), {
        renderVariant: renderVariant,
        onUpdate: updateRenderVariant,
        source: source
    }), isTargetingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f033ac2e9f99cfed$var$styles.marginBottom
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bfb77908ad25462$export$83d97d5e49e73ce8), {
        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
        updateMainFormField: updateMainFormField,
        targetParameter: segmentationTarget,
        updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
        renderVariant: renderVariant,
        source: source
    })), shouldShowSegmentationTargetGroupsField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2d6c26cfaa807db$export$2261f4215d6c3d25), {
        targetGroupsIds: segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL ? audienceSegmentationGroupIds : cards[0]?.audienceSegmentationGroupIds,
        onGroupSelected: handleGroupSelection,
        showUpdatedStyles: true,
        source: source
    }));
};





const $bd3b0d3eb374461c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    listConfigContentTitleTextLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.title-text-label",
        defaultMessage: "Cards"
    },
    cardsInvalidMessage: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.error.invalid-list",
        defaultMessage: "Add cards"
    },
    preamble: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description",
        defaultMessage: "Present links, images, and more. {link}"
    },
    preambleWithoutSupportLink: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description-without-support-link",
        defaultMessage: "Present links, images, and more."
    },
    preambleSupportLinkLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.text.description.link",
        defaultMessage: "Learn more about cards."
    },
    stylesTabLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles-tab.label",
        defaultMessage: "Styles"
    },
    contentTabLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.content-tab.label",
        defaultMessage: "Content"
    },
    styleSectionGeneralTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.style.general.title",
        defaultMessage: "General"
    },
    cornerRadiusLabel: {
        id: "company-hub.cards-extension.config.corner.radius",
        defaultMessage: "Corners"
    },
    contentSectionDisplayOptionsTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.content.display-options.title",
        defaultMessage: "Display options"
    },
    layoutsTitle: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.title",
        defaultMessage: "Layouts"
    },
    layoutsCardsFixedImageHeightLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.label",
        defaultMessage: "Fixed image height"
    },
    layoutsCardsFixedImageHeightDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.fixed-image-height.description",
        defaultMessage: "Image size is the same on all cards"
    },
    layoutsCardsFlexibleImageHeightLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.label",
        defaultMessage: "Flexible image height"
    },
    layoutsCardsFlexibleImageHeightDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.cards.styles-tab.layouts.flexible-image-height.description",
        defaultMessage: "Image size responds to the amount of text"
    }
});





















var $dZCoX = parcelRequire("dZCoX");

var $1ipaC = parcelRequire("1ipaC");


var $hhnRo = parcelRequire("hhnRo");


var $65u5c = parcelRequire("65u5c");


var $4WDWC = parcelRequire("4WDWC");


var $4pBmf = parcelRequire("4pBmf");





var $eafQX = parcelRequire("eafQX");


var $51SAu = parcelRequire("51SAu");































var $lpNn5 = parcelRequire("lpNn5");










const $840976c62cc53b25$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    autoscrollLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-label",
        defaultMessage: "Autoscroll"
    },
    autoscrollTooltipContent: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.autoscroll-tooltip-content",
        defaultMessage: "Cards that don\u2019t fit on the screen will start scrolling when you exit edit mode"
    }
});


const $3e1b5b9d95a030ed$export$600864a4e47981ae = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isAutoscrollEnabled: isAutoscrollEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isAutoscrollEnabled || $[2] !== renderVariant || $[3] !== updateMainFormField) {
        t1 = ()=>{
            updateMainFormField({
                isAutoscrollEnabled: !isAutoscrollEnabled
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "toggle",
                    actionSubjectId: "autoscrollToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isAutoscrollEnabled;
        $[2] = renderVariant;
        $[3] = updateMainFormField;
        $[4] = t1;
    } else t1 = $[4];
    const handleChange = t1;
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage((0, $840976c62cc53b25$export$defe85febe8b728c).autoscrollLabel);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage((0, $840976c62cc53b25$export$defe85febe8b728c).autoscrollTooltipContent);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            testId: "autoscroll-information-icon",
            label: "autoscroll-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        });
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t3,
            position: "bottom"
        }, t4);
        $[10] = t3;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== handleChange || $[13] !== isAutoscrollEnabled || $[14] !== t2 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: t2,
            Icon: t5,
            isChecked: isAutoscrollEnabled,
            onChange: handleChange
        });
        $[12] = handleChange;
        $[13] = isAutoscrollEnabled;
        $[14] = t2;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ isAutoscrollEnabled: isAutoscrollEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            isAutoscrollEnabled: !isAutoscrollEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'autoscrollToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAutoscrollEnabled,
        renderVariant,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $840976c62cc53b25$export$defe85febe8b728c).autoscrollLabel),
        Icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $840976c62cc53b25$export$defe85febe8b728c).autoscrollTooltipContent),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            testId: "autoscroll-information-icon",
            label: "autoscroll-information",
            color: "var(--ds-icon-discovery, #AF59E1)"
        })),
        isChecked: isAutoscrollEnabled,
        onChange: handleChange
    });
};
































var $e9Sxn = parcelRequire("e9Sxn");










const $d25e4e24d846acb4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    backgroundColorLabel: {
        id: "company-hub.card-extensions.card-config.background-color-field.title",
        defaultMessage: "Background color"
    }
});


const $c29ddbab4b7f64c6$export$f741b39ac4e5761a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { backgroundColor: backgroundColor, textColor: textColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: legacyBrandMap } = t1;
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming?.brandBackgroundColorMap : undefined;
    let t2;
    if ($[2] !== isV2 || $[3] !== palette || $[4] !== primaryColor || $[5] !== textColor) {
        t2 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, "primary.1000", primaryColor) : textColor;
        $[2] = isV2;
        $[3] = palette;
        $[4] = primaryColor;
        $[5] = textColor;
        $[6] = t2;
    } else t2 = $[6];
    const resolvedTextColor = t2;
    let t3;
    if ($[7] !== backgroundColor || $[8] !== isV2 || $[9] !== palette || $[10] !== primaryColor) {
        t3 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, "primary.200", primaryColor) : backgroundColor;
        $[7] = backgroundColor;
        $[8] = isV2;
        $[9] = palette;
        $[10] = primaryColor;
        $[11] = t3;
    } else t3 = $[11];
    const resolvedBackgroundColor = t3;
    let t4;
    if ($[12] !== resolvedTextColor) {
        t4 = (color)=>(0, $4yUlE.isReadable)(color, resolvedTextColor);
        $[12] = resolvedTextColor;
        $[13] = t4;
    } else t4 = $[13];
    const isReadableBackgroundColor = t4;
    let t5;
    if ($[14] !== resolvedBackgroundColor) {
        t5 = (color_0)=>(0, $4yUlE.isReadable)(color_0, resolvedBackgroundColor);
        $[14] = resolvedBackgroundColor;
        $[15] = t5;
    } else t5 = $[15];
    const isReadableTextColor = t5;
    const toStoredColor = theming?.toStoredColor;
    let t6;
    if ($[16] !== isV2 || $[17] !== toStoredColor || $[18] !== updateMainFormField) {
        t6 = (next)=>{
            if (!isV2) return;
            const nextStored = toStoredColor ? toStoredColor(next) : next;
            updateMainFormField({
                textColor: nextStored
            });
        };
        $[16] = isV2;
        $[17] = toStoredColor;
        $[18] = updateMainFormField;
        $[19] = t6;
    } else t6 = $[19];
    (0, $5ddnJ.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, textColor, t6, branding?.defaultParameters);
    let t7;
    if ($[20] !== isV2 || $[21] !== toStoredColor || $[22] !== updateMainFormField) {
        t7 = (color_1)=>{
            const next_0 = isV2 && toStoredColor ? toStoredColor(color_1) : color_1;
            updateMainFormField({
                backgroundColor: next_0
            });
        };
        $[20] = isV2;
        $[21] = toStoredColor;
        $[22] = updateMainFormField;
        $[23] = t7;
    } else t7 = $[23];
    const handleChange = t7;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $d25e4e24d846acb4$export$defe85febe8b728c).backgroundColorLabel));
        $[24] = t8;
    } else t8 = $[24];
    const t9 = isV2 && v2BrandMap ? v2BrandMap : hideDefaultColorPalette && legacyBrandMap ? legacyBrandMap : backgroundColorMap;
    const t10 = !!isCompanyHub;
    let t11;
    if ($[25] !== handleChange || $[26] !== isReadableBackgroundColor || $[27] !== resolvedBackgroundColor || $[28] !== t10 || $[29] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center"
        }, t8, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE),
            builtInColorMap: t9,
            isReadableColor: isReadableBackgroundColor,
            onChange: handleChange,
            value: resolvedBackgroundColor,
            pickerTitle: (0, $d25e4e24d846acb4$export$defe85febe8b728c).backgroundColorLabel,
            showCustomPalette: t10
        }));
        $[25] = handleChange;
        $[26] = isReadableBackgroundColor;
        $[27] = resolvedBackgroundColor;
        $[28] = t10;
        $[29] = t9;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
} : ({ backgroundColor: backgroundColor, textColor: textColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: legacyBrandMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming?.brandBackgroundColorMap : undefined;
    const resolvedTextColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', primaryColor) : textColor;
    const resolvedBackgroundColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, 'primary.200', primaryColor) : backgroundColor;
    const isReadableBackgroundColor = (color)=>(0, $4yUlE.isReadable)(color, resolvedTextColor);
    const isReadableTextColor = (color_0)=>(0, $4yUlE.isReadable)(color_0, resolvedBackgroundColor);
    // When advanced theming is on, auto-flip text color between dark/light when the
    // admin picks a contrasting bg, so the text remains readable. Mirrors the
    // auto-transition behaviour used by spotlight / callout banner.
    const toStoredColor = theming?.toStoredColor;
    (0, $5ddnJ.useAutoTransitioningColors)(resolvedBackgroundColor, isReadableTextColor, textColor, (next)=>{
        if (!isV2) return;
        const nextStored = toStoredColor ? toStoredColor(next) : next;
        updateMainFormField({
            textColor: nextStored
        });
    }, branding?.defaultParameters);
    const handleChange = (0, $cozmU.useCallback)((color_1)=>{
        const next_0 = isV2 && toStoredColor ? toStoredColor(color_1) : color_1;
        updateMainFormField({
            backgroundColor: next_0
        });
    }, [
        updateMainFormField,
        isV2,
        toStoredColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $d25e4e24d846acb4$export$defe85febe8b728c).backgroundColorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE),
        builtInColorMap: isV2 && v2BrandMap ? v2BrandMap : hideDefaultColorPalette && legacyBrandMap ? legacyBrandMap : backgroundColorMap,
        isReadableColor: isReadableBackgroundColor,
        onChange: handleChange,
        value: resolvedBackgroundColor,
        pickerTitle: (0, $d25e4e24d846acb4$export$defe85febe8b728c).backgroundColorLabel,
        showCustomPalette: !!isCompanyHub
    }));
};









































const $86076bfb897aeb92$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    borderColor: {
        id: "company-hub.cards-extension.cards.config-panel.border.color",
        defaultMessage: "Border color"
    }
});


const $f12275b707e08a3a$export$92aacb76e2eb3993 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { borderColor: borderColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    let t1;
    if ($[0] !== branding) {
        t1 = branding ?? {};
        $[0] = branding;
        $[1] = t1;
    } else t1 = $[1];
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: legacyBrandMap } = t1;
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BorderMap = isV2 ? theming?.brandBorderColorMap : undefined;
    let t2;
    if ($[2] !== borderColor || $[3] !== isV2 || $[4] !== palette || $[5] !== primaryColor) {
        t2 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(borderColor || (0, $jWbXj.DEFAULT_GRAY_COLOR), palette, "primary.600", primaryColor) : borderColor || (0, $jWbXj.DEFAULT_GRAY_COLOR);
        $[2] = borderColor;
        $[3] = isV2;
        $[4] = palette;
        $[5] = primaryColor;
        $[6] = t2;
    } else t2 = $[6];
    const resolvedBorderColor = t2;
    const toStoredColor = theming?.toStoredColor;
    let t3;
    if ($[7] !== isV2 || $[8] !== toStoredColor || $[9] !== updateMainFormField) {
        t3 = (color)=>{
            const next = isV2 && toStoredColor ? toStoredColor(color) : color;
            updateMainFormField({
                borderColor: next
            });
        };
        $[7] = isV2;
        $[8] = toStoredColor;
        $[9] = updateMainFormField;
        $[10] = t3;
    } else t3 = $[10];
    const handleChange = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $86076bfb897aeb92$export$defe85febe8b728c).borderColor));
        $[11] = t4;
    } else t4 = $[11];
    const t5 = isV2 && v2BorderMap ? v2BorderMap : hideDefaultColorPalette && legacyBrandMap ? legacyBrandMap : backgroundColorMap;
    let t6;
    if ($[12] !== handleChange || $[13] !== isCompanyHub || $[14] !== resolvedBorderColor || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            builtInColorMap: t5,
            onChange: handleChange,
            value: resolvedBorderColor,
            pickerTitle: (0, $86076bfb897aeb92$export$defe85febe8b728c).borderColor,
            showCustomPalette: isCompanyHub,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE)
        }));
        $[12] = handleChange;
        $[13] = isCompanyHub;
        $[14] = resolvedBorderColor;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ borderColor: borderColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $cfM7x.useProductDependencies)();
    const { branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: legacyBrandMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BorderMap = isV2 ? theming?.brandBorderColorMap : undefined;
    const defaultBorderColor = (0, $jWbXj.DEFAULT_GRAY_COLOR);
    const resolvedBorderColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(borderColor || defaultBorderColor, palette, 'primary.600', primaryColor) : borderColor || defaultBorderColor;
    const toStoredColor = theming?.toStoredColor;
    const handleChange = (0, $cozmU.useCallback)((color)=>{
        const next = isV2 && toStoredColor ? toStoredColor(color) : color;
        updateMainFormField({
            borderColor: next
        });
    }, [
        updateMainFormField,
        isV2,
        toStoredColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $86076bfb897aeb92$export$defe85febe8b728c).borderColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        builtInColorMap: isV2 && v2BorderMap ? v2BorderMap : hideDefaultColorPalette && legacyBrandMap ? legacyBrandMap : backgroundColorMap,
        onChange: handleChange,
        value: resolvedBorderColor,
        pickerTitle: (0, $86076bfb897aeb92$export$defe85febe8b728c).borderColor,
        showCustomPalette: isCompanyHub,
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE)
    }));
};












var $aRvnq = parcelRequire("aRvnq");


var $dwAVI = parcelRequire("dwAVI");













const $19d33d6f380f032b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    displayAsLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.display-as-label",
        defaultMessage: "Display as"
    },
    rowItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.row-label",
        defaultMessage: "Row"
    },
    rowItemDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.row-description",
        defaultMessage: "Cards scroll in one row"
    },
    stackedItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.stacked-label",
        defaultMessage: "Stacked"
    },
    stackedItemDescription: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.stacked-description",
        defaultMessage: "Cards wrap to new lines"
    }
});


const $6ca954a14cdbf085$var$orientationOptions = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: (0, $19d33d6f380f032b$export$defe85febe8b728c).rowItemLabel,
        description: (0, $19d33d6f380f032b$export$defe85febe8b728c).rowItemDescription,
        value: (0, $ikd73.Orientation).ROW
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwAVI))),
        label: (0, $19d33d6f380f032b$export$defe85febe8b728c).stackedItemLabel,
        description: (0, $19d33d6f380f032b$export$defe85febe8b728c).stackedItemDescription,
        value: (0, $ikd73.Orientation).STACKED
    }
];
const $6ca954a14cdbf085$var$defaultOption = $6ca954a14cdbf085$var$orientationOptions[0];
const $6ca954a14cdbf085$export$9866cfa35e402e69 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { orientation: orientation, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles } = t0;
    let t1;
    if ($[0] !== orientation) {
        t1 = $6ca954a14cdbf085$var$orientationOptions.find((t2)=>{
            const { value: value } = t2;
            return value === orientation;
        }) || $6ca954a14cdbf085$var$defaultOption;
        $[0] = orientation;
        $[1] = t1;
    } else t1 = $[1];
    const selectedOption = t1;
    let t2;
    if ($[2] !== updateMainFormField) {
        t2 = (selectedLabel)=>{
            updateMainFormField({
                orientation: selectedLabel.value
            });
        };
        $[2] = updateMainFormField;
        $[3] = t2;
    } else t2 = $[3];
    const handleSelect = t2;
    let t3;
    if ($[4] !== handleSelect || $[5] !== renderVariant || $[6] !== selectedOption || $[7] !== showUpdatedStyles) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
            fieldType: "orientation",
            label: (0, $19d33d6f380f032b$export$defe85febe8b728c).displayAsLabel,
            onSelect: handleSelect,
            options: $6ca954a14cdbf085$var$orientationOptions,
            renderVariant: renderVariant,
            selectedOption: selectedOption,
            showUpdatedStyles: showUpdatedStyles,
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        });
        $[4] = handleSelect;
        $[5] = renderVariant;
        $[6] = selectedOption;
        $[7] = showUpdatedStyles;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ orientation: orientation, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles })=>{
    const selectedOption = $6ca954a14cdbf085$var$orientationOptions.find(({ value: value })=>value === orientation) || $6ca954a14cdbf085$var$defaultOption;
    const handleSelect = (0, $cozmU.useCallback)((selectedLabel)=>{
        updateMainFormField({
            orientation: selectedLabel.value
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
        fieldType: "orientation",
        label: (0, $19d33d6f380f032b$export$defe85febe8b728c).displayAsLabel,
        onSelect: handleSelect,
        options: $6ca954a14cdbf085$var$orientationOptions,
        renderVariant: renderVariant,
        selectedOption: selectedOption,
        showUpdatedStyles: showUpdatedStyles,
        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    });
};


























const $bf591c7865a301b7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    paddingLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.styles.padding-label",
        defaultMessage: "Padding"
    }
});


const $2fa0f1af71cb26bd$export$915c99e84f1c148d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isPaddingEnabled: isPaddingEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPaddingEnabled || $[2] !== renderVariant || $[3] !== updateMainFormField) {
        t1 = ()=>{
            updateMainFormField({
                isPaddingEnabled: !isPaddingEnabled
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "toggle",
                    actionSubjectId: "paddingToggle",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        renderVariant: renderVariant
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isPaddingEnabled;
        $[2] = renderVariant;
        $[3] = updateMainFormField;
        $[4] = t1;
    } else t1 = $[4];
    const handleChange = t1;
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage((0, $bf591c7865a301b7$export$defe85febe8b728c).paddingLabel);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== handleChange || $[8] !== isPaddingEnabled || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
            label: t2,
            isChecked: isPaddingEnabled,
            onChange: handleChange
        });
        $[7] = handleChange;
        $[8] = isPaddingEnabled;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ isPaddingEnabled: isPaddingEnabled, renderVariant: renderVariant, updateMainFormField: updateMainFormField })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleChange = (0, $cozmU.useCallback)(()=>{
        updateMainFormField({
            isPaddingEnabled: !isPaddingEnabled
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'paddingToggle',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: renderVariant
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isPaddingEnabled,
        renderVariant,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7jDA.ToggleField), {
        label: formatMessage((0, $bf591c7865a301b7$export$defe85febe8b728c).paddingLabel),
        isChecked: isPaddingEnabled,
        onChange: handleChange
    });
};























const $fcc3dfe3eee9b1b4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    sizeTextLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-text-label",
        defaultMessage: "Size"
    },
    sizeSmallDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.small.label",
        defaultMessage: "Small"
    },
    sizeMediumDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.medium.label",
        defaultMessage: "Medium"
    },
    sizeLargeDropDownItemLabel: {
        id: "company-hub.cards-extension.link-cards-config-panel.size-field.drop-down.item.large.label",
        defaultMessage: "Large"
    }
});


const $f03e3e4b2c385950$export$7c15ddf1d318efda = [
    {
        label: (0, $fcc3dfe3eee9b1b4$export$defe85febe8b728c).sizeSmallDropDownItemLabel,
        value: (0, $hjUDQ.Height).SMALL
    },
    {
        label: (0, $fcc3dfe3eee9b1b4$export$defe85febe8b728c).sizeMediumDropDownItemLabel,
        value: (0, $hjUDQ.Height).MEDIUM
    },
    {
        label: (0, $fcc3dfe3eee9b1b4$export$defe85febe8b728c).sizeLargeDropDownItemLabel,
        value: (0, $hjUDQ.Height).LARGE
    }
];



const $b27509c46bc1fb9a$export$2c78cba0f7eb6af1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { sizeParameter: sizeParameter, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles } = t0;
    let t1;
    if ($[0] !== sizeParameter) {
        t1 = (0, $f03e3e4b2c385950$export$7c15ddf1d318efda).find((t2)=>{
            const { value: value } = t2;
            return value === sizeParameter;
        }) || (0, $f03e3e4b2c385950$export$7c15ddf1d318efda)[0];
        $[0] = sizeParameter;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = {
            sizeOptions: (0, $f03e3e4b2c385950$export$7c15ddf1d318efda),
            selectedOption: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { sizeOptions: sizeOptions, selectedOption: selectedOption } = t2;
    let t3;
    if ($[4] !== updateMainFormField) {
        t3 = (selectedLabel)=>{
            updateMainFormField({
                size: selectedLabel.value
            });
        };
        $[4] = updateMainFormField;
        $[5] = t3;
    } else t3 = $[5];
    const handleSelect = t3;
    let t4;
    if ($[6] !== handleSelect || $[7] !== renderVariant || $[8] !== selectedOption || $[9] !== showUpdatedStyles || $[10] !== sizeOptions) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
            fieldType: "size",
            label: (0, $fcc3dfe3eee9b1b4$export$defe85febe8b728c).sizeTextLabel,
            onSelect: handleSelect,
            options: sizeOptions,
            selectedOption: selectedOption,
            renderVariant: renderVariant,
            showUpdatedStyles: showUpdatedStyles,
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        });
        $[6] = handleSelect;
        $[7] = renderVariant;
        $[8] = selectedOption;
        $[9] = showUpdatedStyles;
        $[10] = sizeOptions;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ sizeParameter: sizeParameter, renderVariant: renderVariant, updateMainFormField: updateMainFormField, showUpdatedStyles: showUpdatedStyles })=>{
    const { sizeOptions: sizeOptions, selectedOption: selectedOption } = {
        sizeOptions: (0, $f03e3e4b2c385950$export$7c15ddf1d318efda),
        selectedOption: (0, $f03e3e4b2c385950$export$7c15ddf1d318efda).find(({ value: value })=>value === sizeParameter) || (0, $f03e3e4b2c385950$export$7c15ddf1d318efda)[0]
    };
    const handleSelect = (0, $cozmU.useCallback)((selectedLabel)=>{
        updateMainFormField({
            size: selectedLabel.value
        });
    }, [
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWxR3.ConfigFieldDropdown), {
        fieldType: "size",
        label: (0, $fcc3dfe3eee9b1b4$export$defe85febe8b728c).sizeTextLabel,
        onSelect: handleSelect,
        options: sizeOptions,
        selectedOption: selectedOption,
        renderVariant: renderVariant,
        showUpdatedStyles: showUpdatedStyles,
        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    });
};









































const $78cbcb1aeed591ae$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    textColorLabel: {
        id: "company-hub.card-extensions.card-config.text-color-field.title",
        defaultMessage: "Text color"
    }
});


const $9be45f0b4d064503$export$f936dd91781178aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { textColor: textColor, backgroundColor: backgroundColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField } = t0;
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming?.brandBackgroundColorMap : undefined;
    const readableTextHex = isV2 && primaryColor ? (0, $4yUlE.isReadable)("#FFFFFF", primaryColor) ? "#FFFFFF" : "#000000" : "#000000";
    let t1;
    if ($[0] !== backgroundColor || $[1] !== isV2 || $[2] !== palette || $[3] !== primaryColor) {
        t1 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, "primary.200", primaryColor) : backgroundColor;
        $[0] = backgroundColor;
        $[1] = isV2;
        $[2] = palette;
        $[3] = primaryColor;
        $[4] = t1;
    } else t1 = $[4];
    const resolvedBackgroundColor = t1;
    let t2;
    if ($[5] !== isV2 || $[6] !== palette || $[7] !== primaryColor || $[8] !== readableTextHex || $[9] !== textColor) {
        t2 = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, "primary.1000", readableTextHex, primaryColor) : textColor;
        $[5] = isV2;
        $[6] = palette;
        $[7] = primaryColor;
        $[8] = readableTextHex;
        $[9] = textColor;
        $[10] = t2;
    } else t2 = $[10];
    const resolvedTextColor = t2;
    let t3;
    if ($[11] !== resolvedBackgroundColor) {
        t3 = (color)=>(0, $4yUlE.isReadable)(color, resolvedBackgroundColor);
        $[11] = resolvedBackgroundColor;
        $[12] = t3;
    } else t3 = $[12];
    const isReadableTextColor = t3;
    const toStoredColor = theming?.toStoredColor;
    let t4;
    if ($[13] !== isV2 || $[14] !== toStoredColor || $[15] !== updateMainFormField) {
        t4 = (color_0)=>{
            const next = isV2 && toStoredColor ? toStoredColor(color_0) : color_0;
            updateMainFormField({
                textColor: next
            });
        };
        $[13] = isV2;
        $[14] = toStoredColor;
        $[15] = updateMainFormField;
        $[16] = t4;
    } else t4 = $[16];
    const handleChange = t4;
    let t5;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $78cbcb1aeed591ae$export$defe85febe8b728c).textColorLabel));
        $[17] = t5;
    } else t5 = $[17];
    const t6 = isV2 && v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap;
    const t7 = !!isCompanyHub;
    let t8;
    if ($[18] !== handleChange || $[19] !== isReadableTextColor || $[20] !== resolvedTextColor || $[21] !== t6 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE),
            builtInColorMap: t6,
            isReadableColor: isReadableTextColor,
            onChange: handleChange,
            value: resolvedTextColor,
            pickerTitle: (0, $78cbcb1aeed591ae$export$defe85febe8b728c).textColorLabel,
            showCustomPalette: t7
        }));
        $[18] = handleChange;
        $[19] = isReadableTextColor;
        $[20] = resolvedTextColor;
        $[21] = t6;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ textColor: textColor, backgroundColor: backgroundColor, isCompanyHub: isCompanyHub, updateMainFormField: updateMainFormField })=>{
    const { isSSRProductInDarkMode: isSSRProductInDarkMode, branding: branding } = (0, $cfM7x.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette } = branding ?? {};
    const { textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $4sYZY.useBuiltInColorMap)(isSSRProductInDarkMode);
    const theming = (0, $4pBmf.useHubTheming)();
    const isV2 = theming?.isAdvancedThemingEnabled ?? false;
    const palette = isV2 ? theming?.palette : undefined;
    const primaryColor = isV2 ? theming?.primaryColor : undefined;
    const v2BrandMap = isV2 ? theming?.brandBackgroundColorMap : undefined;
    const readableTextHex = isV2 && primaryColor ? (0, $4yUlE.isReadable)('#FFFFFF', primaryColor) ? '#FFFFFF' : '#000000' : '#000000';
    const resolvedBackgroundColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(backgroundColor, palette, 'primary.200', primaryColor) : backgroundColor;
    const resolvedTextColor = isV2 && palette && primaryColor ? (0, $e9Sxn.resolveAdfColorForPicker)(textColor, palette, 'primary.1000', readableTextHex, primaryColor) : textColor;
    const isReadableTextColor = (color)=>(0, $4yUlE.isReadable)(color, resolvedBackgroundColor);
    const toStoredColor = theming?.toStoredColor;
    const handleChange = (0, $cozmU.useCallback)((color_0)=>{
        const next = isV2 && toStoredColor ? toStoredColor(color_0) : color_0;
        updateMainFormField({
            textColor: next
        });
    }, [
        updateMainFormField,
        isV2,
        toStoredColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $78cbcb1aeed591ae$export$defe85febe8b728c).textColorLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE),
        builtInColorMap: isV2 && v2BrandMap ? v2BrandMap : hideDefaultColorPalette ? emptyColorMap : textColorMap,
        isReadableColor: isReadableTextColor,
        onChange: handleChange,
        value: resolvedTextColor,
        pickerTitle: (0, $78cbcb1aeed591ae$export$defe85febe8b728c).textColorLabel,
        showCustomPalette: !!isCompanyHub
    }));
};



const $5d06b6c857f90f34$var$styles = {
    disabledContentWrapperStyles: "_0wOv4Qsyl5"
};
const $5d06b6c857f90f34$export$340caeb53b469bd1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(62);
    const { extensionParameters: extensionParameters, extensionActions: extensionActions, isCompanyHub: isCompanyHub, isDisabled: isDisabled } = t0;
    const { size: size, orientation: orientation, alignment: alignment, renderVariant: renderVariant, isAutoscrollEnabled: isAutoscrollEnabled, borderColor: borderColor, isPaddingEnabled: isPaddingEnabled, cornerStyle: cornerStyle, cornerRadius: cornerRadius, layout: layout, filters: filters, backgroundColor: t1, textColor: t2 } = extensionParameters;
    const backgroundColor = t1 === undefined ? (0, $k2pUk.cardNewParametersV4).backgroundColor : t1;
    const textColor = t2 === undefined ? (0, $k2pUk.cardNewParametersV4).textColor : t2;
    const { updateMainFormField: updateMainFormField, updateCornerStyle: updateCornerStyle, updateCornerRadius: updateCornerRadius } = extensionActions;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)();
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const theming = (0, $4pBmf.useHubTheming)();
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)("cards-extension");
    let t3;
    if ($[0] !== extensionParameters.backgroundColor || $[1] !== extensionParameters.textColor || $[2] !== resolveTextColor || $[3] !== textColor) {
        t3 = (0, $iDrrr.fg)("hubs_config_panel_text_color_parity") ? resolveTextColor({
            backgroundColor: extensionParameters.backgroundColor,
            textColor: extensionParameters.textColor,
            defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)["cards.bg"]
        }) ?? textColor : textColor;
        $[0] = extensionParameters.backgroundColor;
        $[1] = extensionParameters.textColor;
        $[2] = resolveTextColor;
        $[3] = textColor;
        $[4] = t3;
    } else t3 = $[4];
    const displayedTextColor = t3;
    let t4;
    if ($[5] !== updateCornerRadius) {
        t4 = (value)=>updateCornerRadius(value);
        $[5] = updateCornerRadius;
        $[6] = t4;
    } else t4 = $[6];
    const handleCornerRadius = t4;
    const isUnpopulatedDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && !filters;
    const shouldShowAutoscrollToggle = isCompanyHub && orientation === (0, $ikd73.Orientation).ROW && !isUnpopulatedDynamicCards;
    const t5 = isDisabled && $5d06b6c857f90f34$var$styles.disabledContentWrapperStyles;
    let t6;
    if ($[7] !== renderVariant || $[8] !== size || $[9] !== updateMainFormField) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27509c46bc1fb9a$export$2c78cba0f7eb6af1), {
            sizeParameter: size,
            renderVariant: renderVariant,
            updateMainFormField: updateMainFormField,
            showUpdatedStyles: true
        });
        $[7] = renderVariant;
        $[8] = size;
        $[9] = updateMainFormField;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== orientation || $[12] !== renderVariant || $[13] !== updateMainFormField) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ca954a14cdbf085$export$9866cfa35e402e69), {
            orientation: orientation,
            renderVariant: renderVariant,
            updateMainFormField: updateMainFormField,
            showUpdatedStyles: true
        });
        $[11] = orientation;
        $[12] = renderVariant;
        $[13] = updateMainFormField;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== isAutoscrollEnabled || $[16] !== renderVariant || $[17] !== shouldShowAutoscrollToggle || $[18] !== updateMainFormField) {
        t8 = shouldShowAutoscrollToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e1b5b9d95a030ed$export$600864a4e47981ae), {
            isAutoscrollEnabled: isAutoscrollEnabled,
            renderVariant: renderVariant,
            updateMainFormField: updateMainFormField
        });
        $[15] = isAutoscrollEnabled;
        $[16] = renderVariant;
        $[17] = shouldShowAutoscrollToggle;
        $[18] = updateMainFormField;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== backgroundColor || $[21] !== isCompanyHub || $[22] !== textColor || $[23] !== updateMainFormField) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c29ddbab4b7f64c6$export$f741b39ac4e5761a), {
            textColor: textColor,
            backgroundColor: backgroundColor,
            isCompanyHub: isCompanyHub,
            updateMainFormField: updateMainFormField
        });
        $[20] = backgroundColor;
        $[21] = isCompanyHub;
        $[22] = textColor;
        $[23] = updateMainFormField;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== backgroundColor || $[26] !== displayedTextColor || $[27] !== isCompanyHub || $[28] !== updateMainFormField) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9be45f0b4d064503$export$f936dd91781178aa), {
            textColor: displayedTextColor,
            backgroundColor: backgroundColor,
            isCompanyHub: isCompanyHub,
            updateMainFormField: updateMainFormField
        });
        $[25] = backgroundColor;
        $[26] = displayedTextColor;
        $[27] = isCompanyHub;
        $[28] = updateMainFormField;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== borderColor || $[31] !== isCompanyHub || $[32] !== isPaddingEnabled || $[33] !== layout || $[34] !== renderVariant || $[35] !== size || $[36] !== updateMainFormField) {
        t11 = layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f12275b707e08a3a$export$92aacb76e2eb3993), {
            borderColor: borderColor,
            isCompanyHub: isCompanyHub,
            updateMainFormField: updateMainFormField
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fa0f1af71cb26bd$export$915c99e84f1c148d), {
            isPaddingEnabled: isPaddingEnabled,
            renderVariant: renderVariant,
            updateMainFormField: updateMainFormField
        }));
        $[30] = borderColor;
        $[31] = isCompanyHub;
        $[32] = isPaddingEnabled;
        $[33] = layout;
        $[34] = renderVariant;
        $[35] = size;
        $[36] = updateMainFormField;
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== cornerRadius || $[39] !== cornerStyle || $[40] !== handleCornerRadius || $[41] !== isCompanyHub || $[42] !== isCornerRadiusEnabled || $[43] !== isCornerRadiusLocked || $[44] !== theming?.cornerRadius || $[45] !== updateCornerStyle) {
        t12 = isCompanyHub && !(isCornerRadiusEnabled && isCornerRadiusLocked) && (isCornerRadiusEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
            label: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).cornerRadiusLabel,
            minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
            maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
            step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
            value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
            updateRangeValue: handleCornerRadius,
            analyticSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            prefix: "cardsCornerRadius",
            unit: "px"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
            cornerStyleValue: cornerStyle ?? (0, $hjUDQ.CornerStyle).ROUNDED,
            updateCornerStyle: updateCornerStyle,
            roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
            squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
        }));
        $[38] = cornerRadius;
        $[39] = cornerStyle;
        $[40] = handleCornerRadius;
        $[41] = isCompanyHub;
        $[42] = isCornerRadiusEnabled;
        $[43] = isCornerRadiusLocked;
        $[44] = theming?.cornerRadius;
        $[45] = updateCornerStyle;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== alignment || $[48] !== orientation || $[49] !== renderVariant || $[50] !== updateMainFormField) {
        t13 = orientation === (0, $ikd73.Orientation).STACKED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dZCoX.AlignmentField), {
            selectedAlignment: alignment,
            renderVariant: renderVariant,
            updateMainFormField: updateMainFormField,
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
        });
        $[47] = alignment;
        $[48] = orientation;
        $[49] = renderVariant;
        $[50] = updateMainFormField;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== t10 || $[53] !== t11 || $[54] !== t12 || $[55] !== t13 || $[56] !== t5 || $[57] !== t6 || $[58] !== t7 || $[59] !== t8 || $[60] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            testId: "styles-general-section",
            direction: "column",
            gap: "space.200",
            xcss: t5
        }, t6, t7, t8, t9, t10, t11, t12, t13);
        $[52] = t10;
        $[53] = t11;
        $[54] = t12;
        $[55] = t13;
        $[56] = t5;
        $[57] = t6;
        $[58] = t7;
        $[59] = t8;
        $[60] = t9;
        $[61] = t14;
    } else t14 = $[61];
    return t14;
} : ({ extensionParameters: extensionParameters, extensionActions: extensionActions, isCompanyHub: isCompanyHub, isDisabled: isDisabled })=>{
    const { size: size, orientation: orientation, alignment: alignment, renderVariant: renderVariant, isAutoscrollEnabled: isAutoscrollEnabled, borderColor: borderColor, isPaddingEnabled: isPaddingEnabled, cornerStyle: cornerStyle, cornerRadius: cornerRadius, layout: layout, filters: filters, backgroundColor: // to account for when backgroundColor is undefined for cards created before visual updates
    backgroundColor = (0, $k2pUk.cardNewParametersV4).backgroundColor, textColor: // to account for when textColor is undefined for cards created before visual updates
    textColor = (0, $k2pUk.cardNewParametersV4).textColor } = extensionParameters;
    const { updateMainFormField: updateMainFormField, updateCornerStyle: updateCornerStyle, updateCornerRadius: updateCornerRadius } = extensionActions;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // Per-element corner radius is Premium, so an un-entitled hub gets no control
    // at all rather than one it could not publish. Scoped to the new flow: the
    // legacy rounded/squared toggle below is not a radius setting and stays.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const theming = (0, $4pBmf.useHubTheming)(); // Show the colour the canvas actually paints: cards re-derive an
    // auto-managed black/white against the live background at render time.
    // Resolved from the raw ADF values, exactly as `cards-content` does.
    const resolveTextColor = (0, $hhnRo.useHubAutoTextColor)('cards-extension');
    const displayedTextColor = (0, $iDrrr.fg)('hubs_config_panel_text_color_parity') ? resolveTextColor({
        backgroundColor: extensionParameters.backgroundColor,
        textColor: extensionParameters.textColor,
        defaultRef: (0, $65u5c.ELEMENT_DEFAULTS)['cards.bg']
    }) ?? textColor : textColor;
    const handleCornerRadius = (0, $cozmU.useCallback)((value)=>updateCornerRadius(value), [
        updateCornerRadius
    ]);
    const isUnpopulatedDynamicCards = renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && !filters;
    const shouldShowAutoscrollToggle = isCompanyHub && orientation === (0, $ikd73.Orientation).ROW && !isUnpopulatedDynamicCards;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        testId: "styles-general-section",
        direction: "column",
        gap: "space.200",
        xcss: isDisabled && $5d06b6c857f90f34$var$styles.disabledContentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27509c46bc1fb9a$export$2c78cba0f7eb6af1), {
        sizeParameter: size,
        renderVariant: renderVariant,
        updateMainFormField: updateMainFormField,
        showUpdatedStyles: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ca954a14cdbf085$export$9866cfa35e402e69), {
        orientation: orientation,
        renderVariant: renderVariant,
        updateMainFormField: updateMainFormField,
        showUpdatedStyles: true
    }), shouldShowAutoscrollToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e1b5b9d95a030ed$export$600864a4e47981ae), {
        isAutoscrollEnabled: isAutoscrollEnabled,
        renderVariant: renderVariant,
        updateMainFormField: updateMainFormField
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c29ddbab4b7f64c6$export$f741b39ac4e5761a), {
        textColor: textColor,
        backgroundColor: backgroundColor,
        isCompanyHub: isCompanyHub,
        updateMainFormField: updateMainFormField
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9be45f0b4d064503$export$f936dd91781178aa), {
        textColor: displayedTextColor,
        backgroundColor: backgroundColor,
        isCompanyHub: isCompanyHub,
        updateMainFormField: updateMainFormField
    }), layout === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT && size !== (0, $hjUDQ.Height).SMALL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f12275b707e08a3a$export$92aacb76e2eb3993), {
        borderColor: borderColor,
        isCompanyHub: isCompanyHub,
        updateMainFormField: updateMainFormField
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2fa0f1af71cb26bd$export$915c99e84f1c148d), {
        isPaddingEnabled: isPaddingEnabled,
        renderVariant: renderVariant,
        updateMainFormField: updateMainFormField
    })), isCompanyHub && // The new-flow slider is Premium-only; the legacy toggle is not a radius
    // setting, so it is left alone.
    !(isCornerRadiusEnabled && isCornerRadiusLocked) && (isCornerRadiusEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJCWb.RangeField), {
        label: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).cornerRadiusLabel,
        minValue: (0, $4WDWC.HUB_CORNER_RADIUS_MIN),
        maxValue: (0, $4WDWC.HUB_CORNER_RADIUS_MAX),
        step: (0, $4WDWC.HUB_CORNER_RADIUS_STEP),
        value: (0, $4WDWC.resolveHubCornerRadius)((0, $4WDWC.resolveCornerRadiusOverride)(cornerRadius, cornerStyle) ?? theming?.cornerRadius),
        updateRangeValue: handleCornerRadius,
        analyticSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        prefix: "cardsCornerRadius",
        unit: "px"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ipaC.CornerStyleConfig), {
        cornerStyleValue: cornerStyle ?? (0, $hjUDQ.CornerStyle).ROUNDED,
        updateCornerStyle: updateCornerStyle,
        roundCornerValue: (0, $hjUDQ.CornerStyle).ROUNDED,
        squareCornerValue: (0, $hjUDQ.CornerStyle).SQUARED
    })), orientation === (0, $ikd73.Orientation).STACKED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dZCoX.AlignmentField), {
        selectedAlignment: alignment,
        renderVariant: renderVariant,
        updateMainFormField: updateMainFormField,
        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
    }));
};


const $6ff6f5b009a0e161$export$af1b061943ec63f0 = [
    {
        label: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsCardsFixedImageHeightLabel,
        description: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsCardsFixedImageHeightDescription,
        value: (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT
    },
    {
        label: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsCardsFlexibleImageHeightLabel,
        description: (0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsCardsFlexibleImageHeightDescription,
        value: (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT
    }
];
var $6ff6f5b009a0e161$var$TabSections = /*#__PURE__*/ function(TabSections) {
    TabSections["GENERAL"] = "general";
    TabSections["MAIN"] = "main";
    TabSections["DISPLAY_OPTIONS"] = "displayOptions";
    TabSections["CARDS"] = "cards";
    TabSections["LAYOUTS"] = "layouts";
    return TabSections;
}($6ff6f5b009a0e161$var$TabSections || {});
var $6ff6f5b009a0e161$var$TabValues = /*#__PURE__*/ function(TabValues) {
    TabValues["STYLES"] = "styles";
    TabValues["CONTENT"] = "content";
    return TabValues;
}($6ff6f5b009a0e161$var$TabValues || {})// button keyboard accessibility spec: https://www.w3.org/WAI/ARIA/apg/patterns/button/examples/button/
;
const $6ff6f5b009a0e161$var$TRIGGER_BUTTON_KEYS = [
    'Enter',
    'Spacebar',
    ' '
];
const $6ff6f5b009a0e161$export$390155f95955bd70 = 20;
const $6ff6f5b009a0e161$var$styles = {
    linkCardsListBuilderFooterWrapper: "_2mHwu82ADO _4c065UNHnM _3iDTPbQ4SZ _0aFT5vbt8w",
    stickyFooter: "_2Y7lL41Y8M _2YLqiK5UaJ _1mT5xdHE3j _0Bm75GPgdg _0KLXrulfZc"
};
const $6ff6f5b009a0e161$var$CardsConfigPanelFeedbackCollector = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
            source: (0, $dBD3L.CARDS_EXTENSION_ANALYTIC_SOURCE),
            type: (0, $hjUDQ.FeedbackType).CARDS
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dDC4.ConfigPanelFeedbackCollector), {
        source: (0, $dBD3L.CARDS_EXTENSION_ANALYTIC_SOURCE),
        type: (0, $hjUDQ.FeedbackType).CARDS
    });
};
const $6ff6f5b009a0e161$export$388775c8ad90f12b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(105);
    const { contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = {
            localId: localId,
            editorActions: editorActions
        };
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const { cardsActions: cardsActions, cardsParameters: cardsParameters } = (0, $k2pUk.useCardsExtensionParametersAndActions)(t1);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[3] !== cardsParameters) {
        t2 = cardsParameters || {};
        $[3] = cardsParameters;
        $[4] = t2;
    } else t2 = $[4];
    const { cards: cards, renderVariant: renderVariant, cardCount: cardCount, filters: filters, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, layout: layout, size: size, isDescriptionShown: isDescriptionShown } = t2;
    const { addCard: addCard, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = cardsActions;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setIsInViewMode: setIsInViewMode } = (0, $bIp5p.useExtensionsActions)();
    const [tabSelected, setTabSelected] = (0, $cozmU.useState)("styles");
    const cardsListRef = (0, $cozmU.useRef)(null);
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const { isCompanyHub: isCompanyHub, enableSmartCardsFields: enableSmartCardsFields, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    let t3;
    let t4;
    if ($[5] !== setIsInViewMode) {
        t3 = ()=>{
            setIsInViewMode(false);
        };
        t4 = [
            setIsInViewMode
        ];
        $[5] = setIsInViewMode;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (event)=>{
            if ($6ff6f5b009a0e161$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
                cardsListRef?.current?.lastChild?.focus();
            }, 100);
        };
        $[8] = t5;
    } else t5 = $[8];
    const handleAddCardKeyPress = t5;
    let t6;
    if ($[9] !== cardCount || $[10] !== cards || $[11] !== createAnalyticsEvent || $[12] !== filters || $[13] !== segmentationTarget || $[14] !== setIsInAutoFocusMode || $[15] !== updateCardFormFieldForAllCards || $[16] !== updateMainFormField) {
        t6 = (value)=>{
            setIsInAutoFocusMode(false);
            const fieldsToUpdate = {
                renderVariant: value
            };
            if (value === (0, $hjUDQ.RenderVariant).MANUAL) {
                if (cards.length === 0) fieldsToUpdate.cards = (0, $3cB3o.getDefaultCards)();
            }
            if (value === (0, $hjUDQ.RenderVariant).DYNAMIC) {
                fieldsToUpdate.cardCount = cardCount || (0, $ikd73.DEFAULT_DYNAMIC_CARDS_COUNT);
                fieldsToUpdate.filters = filters || undefined;
            }
            if (segmentationTarget === (0, $hjUDQ.SegmentationTargets).EACH) {
                fieldsToUpdate.segmentationTarget = undefined;
                fieldsToUpdate.isSegmentationShown = false;
                updateCardFormFieldForAllCards({
                    [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
                });
            }
            updateMainFormField(fieldsToUpdate);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "renderVariantSwitcher",
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    attributes: {
                        renderVariant: value
                    }
                }
            }).fire();
        };
        $[9] = cardCount;
        $[10] = cards;
        $[11] = createAnalyticsEvent;
        $[12] = filters;
        $[13] = segmentationTarget;
        $[14] = setIsInAutoFocusMode;
        $[15] = updateCardFormFieldForAllCards;
        $[16] = updateMainFormField;
        $[17] = t6;
    } else t6 = $[17];
    const updateRenderVariant = t6;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (tab)=>{
            setTabSelected(tab.value);
        };
        $[18] = t7;
    } else t7 = $[18];
    const handleTabClick = t7;
    let t8;
    if ($[19] !== addCard || $[20] !== cards || $[21] !== isDisabled || $[22] !== renderVariant || $[23] !== tabSelected) {
        t8 = ()=>{
            const hasReachedCardLimit = cards?.length >= $6ff6f5b009a0e161$export$390155f95955bd70;
            const isManualCard = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL;
            const isContentTabSelected = tabSelected === "content";
            const canShowCardsMessages = isManualCard && isContentTabSelected;
            const showAddCardsButton = !hasReachedCardLimit && canShowCardsMessages;
            const showCardsErrorMessage = !(0, $9BXp4.checkItems)(cards) && canShowCardsMessages;
            if (isDisabled) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6ff6f5b009a0e161$var$styles.stickyFooter
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $6ff6f5b009a0e161$var$styles.linkCardsListBuilderFooterWrapper
            }, showAddCardsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $chOte.AddItemButton), {
                addItem: addCard,
                onAddItemKeyPress: handleAddCardKeyPress,
                analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                actionSubjectIdSuffix: "Card"
            }), showCardsErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).cardsInvalidMessage)), isContentTabSelected ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ff6f5b009a0e161$var$CardsConfigPanelFeedbackCollector, null)));
        };
        $[19] = addCard;
        $[20] = cards;
        $[21] = isDisabled;
        $[22] = renderVariant;
        $[23] = tabSelected;
        $[24] = t8;
    } else t8 = $[24];
    const renderConfigPanelFooter = t8;
    const previewImage = $6ff6f5b009a0e161$var$_temp;
    if (!cardsParameters) {
        let t9;
        if ($[25] !== extensionKey) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
                source: extensionKey,
                isConfigPanel: true
            });
            $[25] = extensionKey;
            $[26] = t9;
        } else t9 = $[26];
        return t9;
    }
    let t9;
    if ($[27] !== updateMainFormField) {
        t9 = (cards_0)=>updateMainFormField({
                cards: cards_0
            });
        $[27] = updateMainFormField;
        $[28] = t9;
    } else t9 = $[28];
    const updateCards = t9;
    let t10;
    if ($[29] !== formatMessage) {
        t10 = formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).stylesTabLabel);
        $[29] = formatMessage;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== formatMessage) {
        t11 = formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).styleSectionGeneralTitle);
        $[31] = formatMessage;
        $[32] = t11;
    } else t11 = $[32];
    let t12;
    if ($[33] !== cardsActions || $[34] !== cardsParameters || $[35] !== isCompanyHub || $[36] !== isDisabled) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d06b6c857f90f34$export$340caeb53b469bd1), {
            extensionParameters: cardsParameters,
            extensionActions: cardsActions,
            isCompanyHub: isCompanyHub,
            isDisabled: isDisabled
        });
        $[33] = cardsActions;
        $[34] = cardsParameters;
        $[35] = isCompanyHub;
        $[36] = isDisabled;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== t11 || $[39] !== t12) {
        t13 = {
            sectionId: "general",
            title: t11,
            defaultIsExpanded: true,
            component: t12
        };
        $[38] = t11;
        $[39] = t12;
        $[40] = t13;
    } else t13 = $[40];
    let t14;
    if ($[41] !== cardsActions.updateLayout || $[42] !== formatMessage || $[43] !== layout || $[44] !== size) {
        t14 = size !== (0, $hjUDQ.Height).SMALL ? [
            {
                sectionId: "layouts",
                title: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsTitle),
                defaultIsExpanded: false,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
                    updateLayout: cardsActions.updateLayout,
                    source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                    layoutOptions: $6ff6f5b009a0e161$export$af1b061943ec63f0,
                    previewImage: previewImage,
                    currentLayoutSelection: layout
                })
            }
        ] : [];
        $[41] = cardsActions.updateLayout;
        $[42] = formatMessage;
        $[43] = layout;
        $[44] = size;
        $[45] = t14;
    } else t14 = $[45];
    let t15;
    if ($[46] !== t13 || $[47] !== t14) {
        t15 = [
            t13,
            ...t14
        ];
        $[46] = t13;
        $[47] = t14;
        $[48] = t15;
    } else t15 = $[48];
    let t16;
    if ($[49] !== t10 || $[50] !== t15) {
        t16 = {
            label: t10,
            value: "styles",
            tabContent: t15
        };
        $[49] = t10;
        $[50] = t15;
        $[51] = t16;
    } else t16 = $[51];
    let t17;
    if ($[52] !== formatMessage) {
        t17 = formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).contentTabLabel);
        $[52] = formatMessage;
        $[53] = t17;
    } else t17 = $[53];
    let t18;
    if ($[54] !== audienceSegmentationGroupIds || $[55] !== cards || $[56] !== cardsActions || $[57] !== renderVariant || $[58] !== segmentationTarget || $[59] !== updateRenderVariant) {
        t18 = {
            sectionId: "main",
            component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f033ac2e9f99cfed$export$fa828d8497c36e1b), {
                audienceSegmentationGroupIds: audienceSegmentationGroupIds,
                renderVariant: renderVariant,
                segmentationTarget: segmentationTarget,
                cards: cards,
                extensionActions: cardsActions,
                updateRenderVariant: updateRenderVariant,
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
            })
        };
        $[54] = audienceSegmentationGroupIds;
        $[55] = cards;
        $[56] = cardsActions;
        $[57] = renderVariant;
        $[58] = segmentationTarget;
        $[59] = updateRenderVariant;
        $[60] = t18;
    } else t18 = $[60];
    let t19;
    if ($[61] !== enableSmartCardsFields || $[62] !== filters || $[63] !== formatMessage || $[64] !== isAvatarShown || $[65] !== isDescriptionShown || $[66] !== isIconShown || $[67] !== isLabelShown || $[68] !== isPublishDateShown || $[69] !== isSocialStatsShown || $[70] !== layout || $[71] !== renderVariant || $[72] !== size || $[73] !== updateMainFormField) {
        t19 = enableSmartCardsFields && (renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && filters) ? [
            {
                title: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).contentSectionDisplayOptionsTitle),
                sectionId: "displayOptions",
                defaultIsExpanded: false,
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $867558a1cef9f4f9$export$46763ff84295d762), {
                    isAvatarShown: isAvatarShown,
                    isPublishDateShown: isPublishDateShown,
                    isSocialStatsShown: isSocialStatsShown,
                    isIconShown: isIconShown,
                    isLabelShown: isLabelShown,
                    layout: layout,
                    size: size,
                    renderVariant: renderVariant,
                    updateMainFormField: updateMainFormField,
                    isDescriptionShown: isDescriptionShown !== false
                })
            }
        ] : [];
        $[61] = enableSmartCardsFields;
        $[62] = filters;
        $[63] = formatMessage;
        $[64] = isAvatarShown;
        $[65] = isDescriptionShown;
        $[66] = isIconShown;
        $[67] = isLabelShown;
        $[68] = isPublishDateShown;
        $[69] = isSocialStatsShown;
        $[70] = layout;
        $[71] = renderVariant;
        $[72] = size;
        $[73] = updateMainFormField;
        $[74] = t19;
    } else t19 = $[74];
    let t20;
    if ($[75] !== cardsActions || $[76] !== cardsParameters || $[77] !== contentId || $[78] !== isDisabled || $[79] !== isLabelShown || $[80] !== renderVariant || $[81] !== size || $[82] !== updateCards) {
        t20 = {
            sectionId: "cards",
            defaultIsExpanded: false,
            component: renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                paddingBlockStart: "space.400"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb64fc0812b200a4$export$1a61cdf7ea7768fd), {
                extensionParameters: cardsParameters,
                extensionActions: cardsActions,
                isDisabled: isDisabled
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bffb5ed9c7d7934b$export$b3865b40066cd705), {
                items: cardsParameters.cards,
                removeItem: cardsActions.removeCard,
                updateCardFormField: cardsActions.updateCardFormField,
                updateItems: updateCards,
                contentId: contentId,
                showDescription: cardsParameters.size !== (0, $hjUDQ.Height).SMALL,
                layout: cardsParameters.layout,
                size: size,
                showSegmentation: Boolean(cardsParameters.isSegmentationShown && cardsParameters.segmentationTarget === (0, $hjUDQ.SegmentationTargets).EACH),
                itemsListRef: cardsListRef,
                isNoImageAllowed: true,
                shouldUseCardV2UI: true,
                showMediaPicker: true,
                showLabel: isLabelShown
            })
        };
        $[75] = cardsActions;
        $[76] = cardsParameters;
        $[77] = contentId;
        $[78] = isDisabled;
        $[79] = isLabelShown;
        $[80] = renderVariant;
        $[81] = size;
        $[82] = updateCards;
        $[83] = t20;
    } else t20 = $[83];
    let t21;
    if ($[84] !== t18 || $[85] !== t19 || $[86] !== t20) {
        t21 = [
            t18,
            ...t19,
            t20
        ];
        $[84] = t18;
        $[85] = t19;
        $[86] = t20;
        $[87] = t21;
    } else t21 = $[87];
    let t22;
    if ($[88] !== t17 || $[89] !== t21) {
        t22 = {
            label: t17,
            value: "content",
            tabContent: t21
        };
        $[88] = t17;
        $[89] = t21;
        $[90] = t22;
    } else t22 = $[90];
    let t23;
    if ($[91] !== t16 || $[92] !== t22) {
        t23 = [
            t16,
            t22
        ];
        $[91] = t16;
        $[92] = t22;
        $[93] = t23;
    } else t23 = $[93];
    const tabSections = t23;
    let t24;
    if ($[94] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).listConfigContentTitleTextLabel);
        $[94] = t24;
    } else t24 = $[94];
    const t25 = showConfigPreambleSupportLink ? (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preamble : (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preambleWithoutSupportLink;
    let t26;
    if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://support.atlassian.com/confluence-cloud/docs/display-beautiful-dynamic-content-on-your-page-with-cards/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preambleSupportLinkLabel))
        };
        $[95] = t26;
    } else t26 = $[95];
    let t27;
    if ($[96] !== t25) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...t25,
            values: t26
        }));
        $[96] = t25;
        $[97] = t27;
    } else t27 = $[97];
    let t28;
    if ($[98] !== tabSections) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
            feature: "premiumCardsConfig"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            tabSections: tabSections,
            onTabClick: handleTabClick
        }));
        $[98] = tabSections;
        $[99] = t28;
    } else t28 = $[99];
    let t29;
    if ($[100] !== closeConfigPanel || $[101] !== renderConfigPanelFooter || $[102] !== t27 || $[103] !== t28) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
            title: t24,
            footerComponent: renderConfigPanelFooter,
            closeConfigPanel: closeConfigPanel
        }, t27, t28);
        $[100] = closeConfigPanel;
        $[101] = renderConfigPanelFooter;
        $[102] = t27;
        $[103] = t28;
        $[104] = t29;
    } else t29 = $[104];
    return t29;
} : ({ contentId: contentId, closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions, extensionKey: extensionKey })=>{
    const { cardsActions: cardsActions, cardsParameters: cardsParameters } = (0, $k2pUk.useCardsExtensionParametersAndActions)({
        localId: localId,
        editorActions: editorActions
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cards: cards, renderVariant: renderVariant, cardCount: cardCount, filters: filters, isAvatarShown: isAvatarShown, isPublishDateShown: isPublishDateShown, isSocialStatsShown: isSocialStatsShown, isIconShown: isIconShown, isLabelShown: isLabelShown, segmentationTarget: segmentationTarget, audienceSegmentationGroupIds: audienceSegmentationGroupIds, layout: layout, size: size, isDescriptionShown: isDescriptionShown } = cardsParameters || {};
    const { addCard: addCard, updateMainFormField: updateMainFormField, updateCardFormFieldForAllCards: updateCardFormFieldForAllCards } = cardsActions;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setIsInViewMode: setIsInViewMode } = (0, $bIp5p.useExtensionsActions)();
    const [tabSelected, setTabSelected] = (0, $cozmU.useState)("styles");
    const cardsListRef = (0, $cozmU.useRef)(null);
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const { isCompanyHub: isCompanyHub, enableSmartCardsFields: enableSmartCardsFields, showConfigPreambleSupportLink: showConfigPreambleSupportLink } = (0, $cfM7x.useProductDependencies)();
    (0, $cozmU.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]);
    const handleAddCardKeyPress = (event)=>{
        if ($6ff6f5b009a0e161$var$TRIGGER_BUTTON_KEYS.includes(event.key)) setTimeout(()=>{
            cardsListRef?.current?.lastChild?.focus();
        }, 100);
    };
    const updateRenderVariant = (0, $cozmU.useCallback)((value)=>{
        setIsInAutoFocusMode(false);
        const fieldsToUpdate = {
            renderVariant: value
        };
        if (value === (0, $hjUDQ.RenderVariant).MANUAL) {
            if (cards.length === 0) fieldsToUpdate.cards = (0, $3cB3o.getDefaultCards)();
        }
        if (value === (0, $hjUDQ.RenderVariant).DYNAMIC) {
            fieldsToUpdate.cardCount = cardCount || (0, $ikd73.DEFAULT_DYNAMIC_CARDS_COUNT);
            fieldsToUpdate.filters = filters || undefined;
        } // Clear segmentation target if it's set to EACH and switching variant
        if (segmentationTarget === (0, $hjUDQ.SegmentationTargets).EACH) {
            fieldsToUpdate.segmentationTarget = undefined;
            fieldsToUpdate.isSegmentationShown = false;
            updateCardFormFieldForAllCards({
                [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: undefined
            });
        }
        updateMainFormField(fieldsToUpdate);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'renderVariantSwitcher',
                source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                attributes: {
                    renderVariant: value
                }
            }
        }).fire();
    }, [
        cards,
        setIsInAutoFocusMode,
        updateMainFormField,
        updateCardFormFieldForAllCards,
        cardCount,
        filters,
        createAnalyticsEvent,
        segmentationTarget
    ]);
    const handleTabClick = (0, $cozmU.useCallback)((tab)=>{
        setTabSelected(tab.value);
    }, []);
    const renderConfigPanelFooter = (0, $cozmU.useCallback)(()=>{
        const hasReachedCardLimit = cards?.length >= $6ff6f5b009a0e161$export$390155f95955bd70;
        const isManualCard = renderVariant === (0, $hjUDQ.RenderVariant).MANUAL;
        const isContentTabSelected = tabSelected === "content";
        const canShowCardsMessages = isManualCard && isContentTabSelected;
        const showAddCardsButton = !hasReachedCardLimit && canShowCardsMessages;
        const showCardsErrorMessage = !(0, $9BXp4.checkItems)(cards) && canShowCardsMessages; // when Cards is disabled (ie. premium gated), don't show the footer
        if (isDisabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6ff6f5b009a0e161$var$styles.stickyFooter
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $6ff6f5b009a0e161$var$styles.linkCardsListBuilderFooterWrapper
        }, showAddCardsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $chOte.AddItemButton), {
            addItem: addCard,
            onAddItemKeyPress: handleAddCardKeyPress,
            analyticsSource: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
            actionSubjectIdSuffix: "Card"
        }), showCardsErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5KFAG.FormFieldErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).cardsInvalidMessage)), isContentTabSelected ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ff6f5b009a0e161$var$CardsConfigPanelFeedbackCollector, null)));
    }, [
        cards,
        addCard,
        isDisabled,
        renderVariant,
        tabSelected
    ]);
    const previewImage = (0, $cozmU.useCallback)((layout_0)=>{
        if (layout_0 === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return {
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($e25abac37e9b0f19$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1fc5cfda5ccd77d9$exports)))
        };
        else return {
            imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4cfb46c97c571659$exports))),
            imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7736333409c58daf$exports)))
        };
    }, []);
    if (!cardsParameters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6u4w.NoExtensionData), {
        source: extensionKey,
        isConfigPanel: true
    });
    const updateCards = (cards_0)=>updateMainFormField({
            cards: cards_0
        });
    const tabSections = [
        {
            label: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).stylesTabLabel),
            value: "styles",
            tabContent: [
                {
                    sectionId: "general",
                    title: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).styleSectionGeneralTitle),
                    defaultIsExpanded: true,
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5d06b6c857f90f34$export$340caeb53b469bd1), {
                        extensionParameters: cardsParameters,
                        extensionActions: cardsActions,
                        isCompanyHub: isCompanyHub,
                        isDisabled: isDisabled
                    })
                },
                ...size !== (0, $hjUDQ.Height).SMALL ? [
                    {
                        sectionId: "layouts",
                        title: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).layoutsTitle),
                        defaultIsExpanded: false,
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VNQP.LayoutOptions), {
                            updateLayout: cardsActions.updateLayout,
                            source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
                            layoutOptions: $6ff6f5b009a0e161$export$af1b061943ec63f0,
                            previewImage: previewImage,
                            currentLayoutSelection: layout
                        })
                    }
                ] : []
            ]
        },
        {
            label: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).contentTabLabel),
            value: "content",
            tabContent: [
                {
                    sectionId: "main",
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f033ac2e9f99cfed$export$fa828d8497c36e1b), {
                        audienceSegmentationGroupIds: audienceSegmentationGroupIds,
                        renderVariant: renderVariant,
                        segmentationTarget: segmentationTarget,
                        cards: cards,
                        extensionActions: cardsActions,
                        updateRenderVariant: updateRenderVariant,
                        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE)
                    })
                },
                ...enableSmartCardsFields && (renderVariant === (0, $hjUDQ.RenderVariant).MANUAL || renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC && filters) ? [
                    {
                        title: formatMessage((0, $bd3b0d3eb374461c$export$defe85febe8b728c).contentSectionDisplayOptionsTitle),
                        sectionId: "displayOptions",
                        defaultIsExpanded: false,
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $867558a1cef9f4f9$export$46763ff84295d762), {
                            isAvatarShown: isAvatarShown,
                            isPublishDateShown: isPublishDateShown,
                            isSocialStatsShown: isSocialStatsShown,
                            isIconShown: isIconShown,
                            isLabelShown: isLabelShown,
                            layout: layout,
                            size: size,
                            renderVariant: renderVariant,
                            updateMainFormField: updateMainFormField,
                            // and we want to enable the toggle by default
                            isDescriptionShown: isDescriptionShown !== false
                        })
                    }
                ] : [],
                {
                    sectionId: "cards",
                    defaultIsExpanded: false,
                    component: renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        paddingBlockStart: "space.400"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fb64fc0812b200a4$export$1a61cdf7ea7768fd), {
                        extensionParameters: cardsParameters,
                        extensionActions: cardsActions,
                        isDisabled: isDisabled
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bffb5ed9c7d7934b$export$b3865b40066cd705), {
                        items: cardsParameters.cards,
                        removeItem: cardsActions.removeCard,
                        updateCardFormField: cardsActions.updateCardFormField,
                        updateItems: updateCards,
                        contentId: contentId,
                        showDescription: cardsParameters.size !== (0, $hjUDQ.Height).SMALL,
                        layout: cardsParameters.layout,
                        size: size,
                        showSegmentation: Boolean(cardsParameters.isSegmentationShown && cardsParameters.segmentationTarget === (0, $hjUDQ.SegmentationTargets).EACH),
                        itemsListRef: cardsListRef,
                        isNoImageAllowed: true,
                        shouldUseCardV2UI: true,
                        showMediaPicker: true,
                        showLabel: isLabelShown
                    })
                }
            ]
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a96iv.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).listConfigContentTitleTextLabel),
        footerComponent: renderConfigPanelFooter,
        closeConfigPanel: closeConfigPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...showConfigPreambleSupportLink ? (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preamble : (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preambleWithoutSupportLink,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://support.atlassian.com/confluence-cloud/docs/display-beautiful-dynamic-content-on-your-page-with-cards/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bd3b0d3eb374461c$export$defe85febe8b728c).preambleSupportLinkLabel))
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cGll.PremiumGateForExtensionConfigPanel), {
        feature: "premiumCardsConfig"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zyjT.ConfigPanelGrouping), {
        source: (0, $dBD3L.CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE),
        tabSections: tabSections,
        onTabClick: handleTabClick
    })));
};
function $6ff6f5b009a0e161$var$_temp(layout_0) {
    if (layout_0 === (0, $ikd73.CardsLayout).FIXED_IMAGE_HEIGHT) return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($e25abac37e9b0f19$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1fc5cfda5ccd77d9$exports)))
    };
    else return {
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4cfb46c97c571659$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7736333409c58daf$exports)))
    };
}
module.exports["CardsConfigPanelContent"] = $6ff6f5b009a0e161$export$388775c8ad90f12b;

});

parcelRegister("8ngiY", function(module, exports) {
module.exports = new URL("NoDynamicCards.7cd8fd7d.svg", import.meta.url).toString();

});

parcelRegister("gWxR3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $kB5K2 = parcelRequire("kB5K2");


var $7sJoX = parcelRequire("7sJoX");


var $fodiz = parcelRequire("fodiz");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $9vJye = parcelRequire("9vJye");













const $a4761db5715557fc$export$2cf7ef1e2dd6c6b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { fontFamily: fontFamily, label: label } = t0;
    let t1;
    if ($[0] !== fontFamily || $[1] !== label) {
        t1 = fontFamily ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: {
                fontFamily: fontFamily
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label);
        $[0] = fontFamily;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ fontFamily: fontFamily, label: label })=>fontFamily ? // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            fontFamily: fontFamily
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label);


const $fcd807ff37a9eb60$var$styles = {
    dropdownTrigger: "_2Y7lL48HPE _4c065UgVvo _1UtDYzZpcK _0KLXru66of _1eOmH6o126",
    dropdownFullWidthStyles: "_39xV02N91d",
    border: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8",
    iconBackgroundStyles: "_0bjKvDcjp5 _0KLXruG6qS _39xV02Uofl _0jFU0VUofl _0hPCNLDIqT _37wbyuDIqT",
    dropdownTriggerInnerStyles: "_2mHwu81Y8M",
    dropdownTriggerTextStyles: "_2O5Vij7dHp _3YEZNOdnbC _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _2fwxA5ecOK _39HuIbz8Lp _1ANEUSLRg7",
    iconContainerStyles: "_3YEZNOdnbC",
    selected: "_3vBAKHQvmT _1UtDYzjTy9 _0KLXruY9q9",
    fieldStyles: "_39xV02N91d"
};
const $fcd807ff37a9eb60$var$FieldWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { useInline: useInline, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== useInline) {
        t1 = useInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, children);
        $[0] = children;
        $[1] = useInline;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ useInline: useInline, children: children })=>useInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, children);
const $fcd807ff37a9eb60$var$FieldDropdown = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { id: id, isDisabled: isDisabled, onSelect: onSelect, selectedOption: selectedOption, showUpdatedStyles: showUpdatedStyles, options: options } = t0;
    let t1;
    if ($[0] !== id || $[1] !== isDisabled || $[2] !== selectedOption.fontFamily || $[3] !== selectedOption.label || $[4] !== showUpdatedStyles) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...props,
                id: id,
                isDisabled: isDisabled,
                ref: triggerRef,
                xcss: (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.dropdownTrigger, $fcd807ff37a9eb60$var$styles.border, !showUpdatedStyles && $fcd807ff37a9eb60$var$styles.dropdownFullWidthStyles, props.isSelected && $fcd807ff37a9eb60$var$styles.selected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                xcss: (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.dropdownTriggerInnerStyles, props.isSelected && $fcd807ff37a9eb60$var$styles.selected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $fcd807ff37a9eb60$var$styles.dropdownTriggerTextStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "inherit",
                weight: "medium"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4761db5715557fc$export$2cf7ef1e2dd6c6b1), {
                label: selectedOption.label,
                fontFamily: selectedOption.fontFamily
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcd807ff37a9eb60$var$styles.iconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                spacing: "none",
                label: "",
                size: "small"
            }))));
        };
        $[0] = id;
        $[1] = isDisabled;
        $[2] = selectedOption.fontFamily;
        $[3] = selectedOption.label;
        $[4] = showUpdatedStyles;
        $[5] = t1;
    } else t1 = $[5];
    const t2 = !showUpdatedStyles;
    let t3;
    if ($[6] !== onSelect || $[7] !== options || $[8] !== selectedOption.value) {
        let t4;
        if ($[10] !== onSelect || $[11] !== selectedOption.value) {
            t4 = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                    isSelected: selectedOption.value === option.value,
                    key: `${option.value}-key`,
                    ...option.icon && {
                        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                            xcss: $fcd807ff37a9eb60$var$styles.iconBackgroundStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(option.icon, {
                            label: `${option.value}-option-icon`,
                            color: "var(--ds-icon, #292A2E)"
                        }))
                    },
                    ...option.description && {
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), option.description)
                    },
                    onClick: ()=>onSelect(option)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4761db5715557fc$export$2cf7ef1e2dd6c6b1), {
                    label: option.label,
                    fontFamily: option.fontFamily
                }));
            $[10] = onSelect;
            $[11] = selectedOption.value;
            $[12] = t4;
        } else t4 = $[12];
        t3 = options.map(t4);
        $[6] = onSelect;
        $[7] = options;
        $[8] = selectedOption.value;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[13] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t3);
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== t1 || $[16] !== t2 || $[17] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t1,
            shouldFitContainer: t2
        }, t4);
        $[15] = t1;
        $[16] = t2;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : ({ id: id, isDisabled: isDisabled, onSelect: onSelect, selectedOption: selectedOption, showUpdatedStyles: showUpdatedStyles, options: options })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...props,
                id: id,
                isDisabled: isDisabled,
                ref: triggerRef,
                xcss: (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.dropdownTrigger, $fcd807ff37a9eb60$var$styles.border, !showUpdatedStyles && $fcd807ff37a9eb60$var$styles.dropdownFullWidthStyles, props.isSelected && $fcd807ff37a9eb60$var$styles.selected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                xcss: (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.dropdownTriggerInnerStyles, props.isSelected && $fcd807ff37a9eb60$var$styles.selected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $fcd807ff37a9eb60$var$styles.dropdownTriggerTextStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "inherit",
                weight: "medium"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4761db5715557fc$export$2cf7ef1e2dd6c6b1), {
                label: selectedOption.label,
                fontFamily: selectedOption.fontFamily
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $fcd807ff37a9eb60$var$styles.iconContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                spacing: "none",
                label: "",
                size: "small"
            })))),
        shouldFitContainer: !showUpdatedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, options.map((option)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            isSelected: selectedOption.value === option.value,
            key: `${option.value}-key`,
            ...option.icon && {
                elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    xcss: $fcd807ff37a9eb60$var$styles.iconBackgroundStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(option.icon, {
                    label: `${option.value}-option-icon`,
                    color: "var(--ds-icon, #292A2E)"
                }))
            },
            ...option.description && {
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), option.description)
            },
            onClick: ()=>onSelect(option)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4761db5715557fc$export$2cf7ef1e2dd6c6b1), {
            label: option.label,
            fontFamily: option.fontFamily
        }));
    })));
const $fcd807ff37a9eb60$export$71e448abd02c1425 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { children: children, fieldType: fieldType, label: label, onSelect: onSelect, options: options, renderVariant: renderVariant, selectedOption: selectedOption, showUpdatedStyles: t1, infoTooltip: infoTooltip, source: source } = t0;
    const showUpdatedStyles = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== fieldType || $[2] !== onSelect || $[3] !== renderVariant || $[4] !== source) {
        t2 = (selectedLabel)=>{
            onSelect(selectedLabel);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "dropdownItem",
                    actionSubjectId: `${fieldType}Dropdown`,
                    source: source,
                    attributes: {
                        renderVariant: renderVariant,
                        selectedValue: selectedLabel.value
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = fieldType;
        $[2] = onSelect;
        $[3] = renderVariant;
        $[4] = source;
        $[5] = t2;
    } else t2 = $[5];
    const handleSelect = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.fieldStyles);
        $[6] = t3;
    } else t3 = $[6];
    const t4 = `${fieldType}-dropdown`;
    const t5 = showUpdatedStyles ? "medium" : "small";
    const t6 = showUpdatedStyles ? "color.text" : "color.text.subtlest";
    const t7 = showUpdatedStyles ? "regular" : "bold";
    let t8;
    if ($[7] !== label) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label);
        $[7] = label;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: t5,
            color: t6,
            weight: t7
        }, t8);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== t4 || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
            htmlFor: t4
        }, t9);
        $[14] = t4;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== infoTooltip) {
        t11 = infoTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: infoTooltip,
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            testId: "info-icon",
            label: infoTooltip,
            color: "var(--ds-icon-discovery, #AF59E1)"
        }));
        $[17] = infoTooltip;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t10 || $[20] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t10, t11);
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
    } else t12 = $[21];
    const t13 = `${fieldType}-dropdown`;
    let t14;
    if ($[22] !== handleSelect || $[23] !== isDisabled || $[24] !== options || $[25] !== selectedOption || $[26] !== showUpdatedStyles || $[27] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fcd807ff37a9eb60$var$FieldDropdown, {
            id: t13,
            isDisabled: isDisabled,
            onSelect: handleSelect,
            selectedOption: selectedOption,
            showUpdatedStyles: showUpdatedStyles,
            options: options
        });
        $[22] = handleSelect;
        $[23] = isDisabled;
        $[24] = options;
        $[25] = selectedOption;
        $[26] = showUpdatedStyles;
        $[27] = t13;
        $[28] = t14;
    } else t14 = $[28];
    let t15;
    if ($[29] !== showUpdatedStyles || $[30] !== t12 || $[31] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fcd807ff37a9eb60$var$FieldWrapper, {
            useInline: showUpdatedStyles
        }, t12, t14));
        $[29] = showUpdatedStyles;
        $[30] = t12;
        $[31] = t14;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== children || $[34] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            direction: "column",
            xcss: t3
        }, t15, children);
        $[33] = children;
        $[34] = t15;
        $[35] = t16;
    } else t16 = $[35];
    return t16;
} : ({ children: children, fieldType: fieldType, label: label, onSelect: onSelect, options: options, renderVariant: renderVariant, selectedOption: selectedOption, showUpdatedStyles: showUpdatedStyles = false, infoTooltip: infoTooltip, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const handleSelect = (0, $cozmU.useCallback)((selectedLabel)=>{
        onSelect(selectedLabel);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'dropdownItem',
                actionSubjectId: `${fieldType}Dropdown`,
                source: source,
                attributes: {
                    renderVariant: renderVariant,
                    selectedValue: selectedLabel.value
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        fieldType,
        onSelect,
        renderVariant,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        direction: "column",
        xcss: (0, $w6R6I.cx)($fcd807ff37a9eb60$var$styles.fieldStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fcd807ff37a9eb60$var$FieldWrapper, {
        useInline: showUpdatedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: `${fieldType}-dropdown`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: showUpdatedStyles ? 'medium' : 'small',
        color: showUpdatedStyles ? 'color.text' : 'color.text.subtlest',
        weight: showUpdatedStyles ? 'regular' : 'bold'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label))), infoTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: infoTooltip,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        testId: "info-icon",
        label: infoTooltip,
        color: "var(--ds-icon-discovery, #AF59E1)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fcd807ff37a9eb60$var$FieldDropdown, {
        id: `${fieldType}-dropdown`,
        isDisabled: isDisabled,
        onSelect: handleSelect,
        selectedOption: selectedOption,
        showUpdatedStyles: showUpdatedStyles,
        options: options
    }))), children);
};
module.exports["ConfigFieldDropdown"] = $fcd807ff37a9eb60$export$71e448abd02c1425;

});

parcelRegister("dZCoX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $w6R6I = parcelRequire("w6R6I");


var $hZR9z = parcelRequire("hZR9z");


var $6aEgq = parcelRequire("6aEgq");


var $4ezc2 = parcelRequire("4ezc2");


var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $9vJye = parcelRequire("9vJye");


var $hjUDQ = parcelRequire("hjUDQ");




const $4b80c83739240446$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    leftAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.left",
        defaultMessage: "Left"
    },
    centerAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.center",
        defaultMessage: "Center"
    },
    rightAlignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2.right",
        defaultMessage: "Right"
    },
    alignmentLabel: {
        id: "company-hub.company-hub-common.link-cards.link-cards-config-panel.alignment-text-label.v2",
        defaultMessage: "Alignment"
    }
});


const $c524902aea7cd637$var$styles = {
    borderOptionContainer: "_4c065UFQfX _2Y7lL41Y8M _0KLXrumhAQ",
    border: "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8",
    selected: "_3vBAKHQvmT _0KLXruY9q9 _1UtDYzjTy9"
};
const $c524902aea7cd637$var$alignmentOptions = [
    {
        label: (0, $4b80c83739240446$export$defe85febe8b728c).leftAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($6aEgq))),
        value: (0, $hjUDQ.Alignment).LEFT
    },
    {
        label: (0, $4b80c83739240446$export$defe85febe8b728c).centerAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($hZR9z))),
        value: (0, $hjUDQ.Alignment).CENTER
    },
    {
        label: (0, $4b80c83739240446$export$defe85febe8b728c).rightAlignmentLabel,
        IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4ezc2))),
        value: (0, $hjUDQ.Alignment).RIGHT
    }
];
const $c524902aea7cd637$export$8c99ded85c285ba = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { selectedAlignment: selectedAlignment, updateMainFormField: updateMainFormField, renderVariant: renderVariant, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== renderVariant || $[2] !== source || $[3] !== updateMainFormField) {
        t1 = (newValue)=>{
            updateMainFormField({
                alignment: newValue
            });
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "buttonGroup",
                    actionSubjectId: "alignment",
                    source: source,
                    attributes: {
                        renderVariant: renderVariant,
                        selectedValue: newValue
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = renderVariant;
        $[2] = source;
        $[3] = updateMainFormField;
        $[4] = t1;
    } else t1 = $[4];
    const handleSelect = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4b80c83739240446$export$defe85febe8b728c).alignmentLabel));
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formatMessage || $[7] !== handleSelect || $[8] !== isDisabled || $[9] !== selectedAlignment) {
        t3 = $c524902aea7cd637$var$alignmentOptions.map((t4)=>{
            const { label: label, IconComponent: IconComponent, value: value } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
                hideTooltipOnMouseDown: true,
                key: value
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                xcss: (0, $w6R6I.cx)($c524902aea7cd637$var$styles.borderOptionContainer, $c524902aea7cd637$var$styles.border, value === selectedAlignment && $c524902aea7cd637$var$styles.selected),
                onClick: ()=>handleSelect(value),
                isDisabled: isDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                color: value === selectedAlignment ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                label: formatMessage(label)
            })));
        });
        $[6] = formatMessage;
        $[7] = handleSelect;
        $[8] = isDisabled;
        $[9] = selectedAlignment;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075"
        }, t3));
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ selectedAlignment: selectedAlignment, updateMainFormField: updateMainFormField, renderVariant: renderVariant, source: source })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isDisabled = (0, $9vJye.useIsDisabledContext)();
    const handleSelect = (0, $cozmU.useCallback)((newValue)=>{
        updateMainFormField({
            alignment: newValue
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'buttonGroup',
                actionSubjectId: 'alignment',
                source: source,
                attributes: {
                    renderVariant: renderVariant,
                    selectedValue: newValue
                }
            }
        }).fire();
    }, [
        updateMainFormField,
        createAnalyticsEvent,
        renderVariant,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $4b80c83739240446$export$defe85febe8b728c).alignmentLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075"
    }, $c524902aea7cd637$var$alignmentOptions.map(({ label: label, IconComponent: IconComponent, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), label),
            hideTooltipOnMouseDown: true,
            key: value
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: (0, $w6R6I.cx)($c524902aea7cd637$var$styles.borderOptionContainer, $c524902aea7cd637$var$styles.border, value === selectedAlignment && $c524902aea7cd637$var$styles.selected),
            onClick: ()=>handleSelect(value),
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
            color: value === selectedAlignment ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
            label: formatMessage(label)
        }))))));
};
module.exports["AlignmentField"] = $c524902aea7cd637$export$8c99ded85c285ba;

});


//# sourceMappingURL=cards-extension.232ec634.js.map
